const INSTITUTIONS = [
    {
        country: 'United States',
        domains: ['student.42.us.org'],
        web_pages: ['http://www.42.us.org/'],
        alpha_two_code: 'US',
        name: '42 US',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ancollege.edu'],
        web_pages: ['http://www.ancollege.edu'],
        alpha_two_code: 'US',
        name: 'Aaniiih Nakoda College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['acu.edu'],
        web_pages: ['http://www.acu.edu/'],
        alpha_two_code: 'US',
        name: 'Abilene Christian University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stonybrookmedicine.edu'],
        web_pages: ['http://www.stonybrookmedicine.edu/'],
        alpha_two_code: 'US',
        name: 'Academic medical center at State University of New York at Stony Brook',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['academyart.edu', 'art.edu'],
        web_pages: ['https://www.academyart.edu/'],
        alpha_two_code: 'US',
        name: 'Academy of Art University',
        'state-province': 'California',
    },
    {
        country: 'United States',
        domains: ['adelphi.edu'],
        web_pages: ['http://www.adelphi.edu/'],
        alpha_two_code: 'US',
        name: 'Adelphi University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.sunyacc.edu'],
        web_pages: ['http://WWW.SUNYACC.EDU'],
        alpha_two_code: 'US',
        name: 'Adirondack Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['agnesscott.edu'],
        web_pages: ['http://www.agnesscott.edu/'],
        alpha_two_code: 'US',
        name: 'Agnes Scott College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['atc.edu'],
        web_pages: ['http://www.atc.edu/'],
        alpha_two_code: 'US',
        name: 'Aiken Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aims.edu'],
        web_pages: ['http://www.aims.edu'],
        alpha_two_code: 'US',
        name: 'Aims Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['afit.edu'],
        web_pages: ['http://www.afit.edu/'],
        alpha_two_code: 'US',
        name: 'Air Force Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aamu.edu'],
        web_pages: ['http://www.aamu.edu/'],
        alpha_two_code: 'US',
        name: 'Alabama A&M University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ascc.edu'],
        web_pages: ['http://www.ascc.edu'],
        alpha_two_code: 'US',
        name: 'Alabama Southern Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alasu.edu'],
        web_pages: ['http://www.alasu.edu/'],
        alpha_two_code: 'US',
        name: 'Alabama State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alamancecc.edu'],
        web_pages: ['http://www.alamancecc.edu'],
        alpha_two_code: 'US',
        name: 'Alamance Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aloma.edu'],
        web_pages: ['http://www.alamo.edu/'],
        alpha_two_code: 'US',
        name: 'Alamo Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alaskapacific.edu'],
        web_pages: ['http://www.alaskapacific.edu'],
        alpha_two_code: 'US',
        name: 'Alaska Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asurams.edu'],
        web_pages: ['http://www.asurams.edu/'],
        alpha_two_code: 'US',
        name: 'Albany State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['albanytech.edu'],
        web_pages: ['http://www.albanytech.edu'],
        alpha_two_code: 'US',
        name: 'Albany Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['acofi.edu'],
        web_pages: ['http://www.acofi.edu/'],
        alpha_two_code: 'US',
        name: 'Albertson College of Idaho',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['albion.edu'],
        web_pages: ['http://www.albion.edu/'],
        alpha_two_code: 'US',
        name: 'Albion College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alextech.edu'],
        web_pages: ['http://www.alextech.edu'],
        alpha_two_code: 'US',
        name: 'Alexandria Technical & Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alfred.edu'],
        web_pages: ['http://www.alfred.edu/'],
        alpha_two_code: 'US',
        name: 'Alfred University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hancockcollege.edu'],
        web_pages: ['http://www.hancockcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Allan Hancock College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['allegany.edu'],
        web_pages: ['http://www.allegany.edu'],
        alpha_two_code: 'US',
        name: 'Allegany College of Maryland',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alleg.edu'],
        web_pages: ['http://www.alleg.edu/'],
        alpha_two_code: 'US',
        name: 'Allegheny College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['allencollege.edu'],
        web_pages: ['https://www.allencollege.edu/'],
        alpha_two_code: 'US',
        name: 'Allen College',
        'state-province': 'Iowa',
    },
    {
        country: 'United States',
        domains: ['allencc.edu'],
        web_pages: ['http://www.allencc.edu'],
        alpha_two_code: 'US',
        name: 'Allen County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['allencol.edu'],
        web_pages: ['http://www.allencol.edu/'],
        alpha_two_code: 'US',
        name: 'Allentown College of Saint Francis de Sales',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alliant.edu'],
        web_pages: ['https://www.alliant.edu/'],
        alpha_two_code: 'US',
        name: 'Alliant International University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alma.edu'],
        web_pages: ['http://www.alma.edu/'],
        alpha_two_code: 'US',
        name: 'Alma College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alpenacc.edu'],
        web_pages: ['http://www.alpenacc.edu'],
        alpha_two_code: 'US',
        name: 'Alpena Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastalpines.edu'],
        web_pages: ['http://www.coastalpines.edu/'],
        alpha_two_code: 'US',
        name: 'Altamaha Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alverno.edu'],
        web_pages: ['http://www.alverno.edu/'],
        alpha_two_code: 'US',
        name: 'Alverno College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alvincollege.edu'],
        web_pages: ['http://www.alvincollege.edu'],
        alpha_two_code: 'US',
        name: 'Alvin Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['actx.edu'],
        web_pages: ['http://www.actx.edu'],
        alpha_two_code: 'US',
        name: 'Amarillo College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ambassador.edu'],
        web_pages: ['http://www.ambassador.edu/'],
        alpha_two_code: 'US',
        name: 'Ambassador University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aada.edu'],
        web_pages: ['http://www.aada.edu'],
        alpha_two_code: 'US',
        name: 'American Academy of Dramatic Arts-​New York',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['amercoastuniv.edu'],
        web_pages: ['http://www.amercoastuniv.edu/'],
        alpha_two_code: 'US',
        name: 'American Coastline University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aic.edu'],
        web_pages: ['http://www.aic.edu/'],
        alpha_two_code: 'US',
        name: 'American International College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['apus.edu'],
        web_pages: ['http://www.apus.edu/'],
        alpha_two_code: 'US',
        name: 'American Public University System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['arc.losrios.edu'],
        web_pages: ['http://www.arc.losrios.edu/'],
        alpha_two_code: 'US',
        name: 'American River College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['american.edu'],
        web_pages: ['http://www.american.edu/'],
        alpha_two_code: 'US',
        name: 'American University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['amherst.edu'],
        web_pages: ['http://www.amherst.edu/'],
        alpha_two_code: 'US',
        name: 'Amherst College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ancilla.edu'],
        web_pages: ['http://www.ancilla.edu'],
        alpha_two_code: 'US',
        name: 'Ancilla College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['andersonuniversity.edu'],
        web_pages: ['https://andersonuniversity.edu/'],
        alpha_two_code: 'US',
        name: 'Anderson University',
        'state-province': 'South Carolina',
    },
    {
        country: 'United States',
        domains: ['andrewcollege.edu'],
        web_pages: ['http://www.andrewcollege.edu'],
        alpha_two_code: 'US',
        name: 'Andrew College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['andrews.edu'],
        web_pages: ['http://www.andrews.edu/'],
        alpha_two_code: 'US',
        name: 'Andrews University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['angelina.edu'],
        web_pages: ['http://www.angelina.edu'],
        alpha_two_code: 'US',
        name: 'Angelina College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['angelo.edu'],
        web_pages: ['http://www.angelo.edu/'],
        alpha_two_code: 'US',
        name: 'Angelo State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aacc.edu'],
        web_pages: ['http://www.aacc.edu/'],
        alpha_two_code: 'US',
        name: 'Anne Arundel Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['anokatech.edu'],
        web_pages: ['http://www.anokatech.edu'],
        alpha_two_code: 'US',
        name: 'Anoka Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['anokaramsey.edu'],
        web_pages: ['http://www.anokaramsey.edu'],
        alpha_two_code: 'US',
        name: 'Anoka-​Ramsey Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['avc.edu'],
        web_pages: ['http://www.avc.edu'],
        alpha_two_code: 'US',
        name: 'Antelope Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['antiochne.edu'],
        web_pages: ['http://www.antiochne.edu/'],
        alpha_two_code: 'US',
        name: 'Antioch New England',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['antioch.edu'],
        web_pages: ['http://www.antioch.edu/'],
        alpha_two_code: 'US',
        name: 'Antioch University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['antiochla.edu'],
        web_pages: ['http://www.antiochla.edu/'],
        alpha_two_code: 'US',
        name: 'Antioch University - Los Angeles',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['seattleantioch.edu'],
        web_pages: ['http://www.seattleantioch.edu/'],
        alpha_two_code: 'US',
        name: 'Antioch University - Seattle',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['appstate.edu'],
        web_pages: ['http://www.appstate.edu/'],
        alpha_two_code: 'US',
        name: 'Appalachian State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aquinas.edu'],
        web_pages: ['http://www.aquinas.edu/'],
        alpha_two_code: 'US',
        name: 'Aquinas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['arapahoe.edu'],
        web_pages: ['http://www.arapahoe.edu'],
        alpha_two_code: 'US',
        name: 'Arapahoe Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['arcadia.edu'],
        web_pages: ['http://www.arcadia.edu/'],
        alpha_two_code: 'US',
        name: 'Arcadia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asu.edu'],
        web_pages: ['http://www.asu.edu/'],
        alpha_two_code: 'US',
        name: 'Arizona State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['azwestern.edu'],
        web_pages: ['http://www.azwestern.edu/'],
        alpha_two_code: 'US',
        name: 'Arizona Western College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['anc.edu'],
        web_pages: ['http://www.anc.edu'],
        alpha_two_code: 'US',
        name: 'Arkansas Northeastern College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['astate.edu'],
        web_pages: ['http://www.astate.edu/'],
        alpha_two_code: 'US',
        name: 'Arkansas State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asub.edu'],
        web_pages: ['http://www.asub.edu'],
        alpha_two_code: 'US',
        name: 'Arkansas State University-​Beebe',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asumh.edu'],
        web_pages: ['http://www.asumh.edu'],
        alpha_two_code: 'US',
        name: 'Arkansas State University-​Mountain Home',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asun.edu'],
        web_pages: ['http://www.asun.edu'],
        alpha_two_code: 'US',
        name: 'Arkansas State University-​Newport',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['atu.edu'],
        web_pages: ['http://www.atu.edu/'],
        alpha_two_code: 'US',
        name: 'Arkansas Tech University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['armstrong.edu'],
        web_pages: ['http://www.armstrong.edu/'],
        alpha_two_code: 'US',
        name: 'Armstrong State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asa.edu'],
        web_pages: ['http://www.asa.edu'],
        alpha_two_code: 'US',
        name: 'ASA College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['abtech.edu'],
        web_pages: ['http://www.abtech.edu'],
        alpha_two_code: 'US',
        name: 'Asheville-​Buncombe Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ashford.edu'],
        web_pages: ['https://www.ashford.edu/'],
        alpha_two_code: 'US',
        name: 'Ashford University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ashland.kctcs.edu'],
        web_pages: ['http://www.ashland.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Ashland Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ashland.edu'],
        web_pages: ['http://www.ashland.edu/'],
        alpha_two_code: 'US',
        name: 'Ashland University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['asnuntuck.edu'],
        web_pages: ['http://www.Asnuntuck.edu'],
        alpha_two_code: 'US',
        name: 'Asnuntuck Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['assumption.edu'],
        web_pages: ['http://www.assumption.edu/'],
        alpha_two_code: 'US',
        name: 'Assumption College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['acs350.org'],
        web_pages: ['http://www.acs350.org'],
        alpha_two_code: 'US',
        name: 'Assumption College for Sisters',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['athens.edu'],
        web_pages: ['http://www.athens.edu/'],
        alpha_two_code: 'US',
        name: 'Athens State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['athenstech.edu'],
        web_pages: ['http://www.athenstech.edu/'],
        alpha_two_code: 'US',
        name: 'Athens Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['atlantatech.edu'],
        web_pages: ['http://www.atlantatech.edu/'],
        alpha_two_code: 'US',
        name: 'Atlanta Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['atlantic.edu'],
        web_pages: ['http://www.atlantic.edu'],
        alpha_two_code: 'US',
        name: 'Atlantic Cape Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['auburn.edu'],
        web_pages: ['http://www.auburn.edu/'],
        alpha_two_code: 'US',
        name: 'Auburn University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aum.edu'],
        web_pages: ['http://www.aum.edu/'],
        alpha_two_code: 'US',
        name: 'Auburn University at Montgomery',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['augsburg.edu'],
        web_pages: ['http://www.augsburg.edu/'],
        alpha_two_code: 'US',
        name: 'Augsburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['augustatech.edu'],
        web_pages: ['http://www.augustatech.edu'],
        alpha_two_code: 'US',
        name: 'Augusta Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['augusta.edu', 'gru.edu'],
        web_pages: ['http://www.augusta.edu/', 'http://www.gru.edu/'],
        alpha_two_code: 'US',
        name: 'Augusta University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['augustana.edu'],
        web_pages: ['http://www.augustana.edu/'],
        alpha_two_code: 'US',
        name: 'Augustana College (IL)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['augie.edu'],
        web_pages: ['http://www.augie.edu/'],
        alpha_two_code: 'US',
        name: 'Augustana College (SD)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aurora.edu'],
        web_pages: ['http://www.aurora.edu/'],
        alpha_two_code: 'US',
        name: 'Aurora University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['austincollege.edu'],
        web_pages: ['http://www.austincollege.edu/'],
        alpha_two_code: 'US',
        name: 'Austin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['austincc.edu'],
        web_pages: ['http://www.austincc.edu/'],
        alpha_two_code: 'US',
        name: 'Austin Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['apsu.edu'],
        web_pages: ['http://www.apsu.edu/'],
        alpha_two_code: 'US',
        name: 'Austin Peay State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['averett.edu'],
        web_pages: ['http://www.averett.edu/'],
        alpha_two_code: 'US',
        name: 'Averett College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['avila.edu'],
        web_pages: ['http://www.avila.edu/'],
        alpha_two_code: 'US',
        name: 'Avila College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['apu.edu'],
        web_pages: ['http://www.apu.edu/'],
        alpha_two_code: 'US',
        name: 'Azusa Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['babson.edu'],
        web_pages: ['http://www.babson.edu/'],
        alpha_two_code: 'US',
        name: 'Babson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bainbridge.edu'],
        web_pages: ['http://www.bainbridge.edu'],
        alpha_two_code: 'US',
        name: 'Bainbridge State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['baker.edu'],
        web_pages: ['http://www.baker.edu/'],
        alpha_two_code: 'US',
        name: 'Baker College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bakeru.edu'],
        web_pages: ['http://www.bakeru.edu/'],
        alpha_two_code: 'US',
        name: 'Baker University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bakersfieldcollege.edu'],
        web_pages: ['http://www.bakersfieldcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Bakersfield College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bw.edu'],
        web_pages: ['https://www.bw.edu/'],
        alpha_two_code: 'US',
        name: 'Baldwin Wallace University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bsu.edu'],
        web_pages: ['http://www.bsu.edu/'],
        alpha_two_code: 'US',
        name: 'Ball State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bccc.edu'],
        web_pages: ['http://www.bccc.edu'],
        alpha_two_code: 'US',
        name: 'Baltimore City Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bbc.edu'],
        web_pages: ['http://www.bbc.edu/'],
        alpha_two_code: 'US',
        name: 'Baptist Bible College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bard.edu'],
        web_pages: ['http://www.bard.edu/'],
        alpha_two_code: 'US',
        name: 'Bard College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['barnard.edu'],
        web_pages: ['http://www.barnard.edu/'],
        alpha_two_code: 'US',
        name: 'Barnard College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['barry.edu'],
        web_pages: ['http://www.barry.edu/'],
        alpha_two_code: 'US',
        name: 'Barry University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['barstow.edu'],
        web_pages: ['http://www.barstow.edu'],
        alpha_two_code: 'US',
        name: 'Barstow Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bartonccc.edu'],
        web_pages: ['http://www.bartonccc.edu'],
        alpha_two_code: 'US',
        name: 'Barton County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bastyr.edu'],
        web_pages: ['http://www.bastyr.edu/'],
        alpha_two_code: 'US',
        name: 'Bastyr University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bates.edu'],
        web_pages: ['http://www.bates.edu/'],
        alpha_two_code: 'US',
        name: 'Bates College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bates.ctc.edu'],
        web_pages: ['http://www.bates.ctc.edu/'],
        alpha_two_code: 'US',
        name: 'Bates Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mybrcc.edu'],
        web_pages: ['http://www.mybrcc.edu'],
        alpha_two_code: 'US',
        name: 'Baton Rouge Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['baycollege.edu'],
        web_pages: ['http://www.baycollege.edu/'],
        alpha_two_code: 'US',
        name: 'Bay de Noc Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bmcc.edu'],
        web_pages: ['http://www.bmcc.edu'],
        alpha_two_code: 'US',
        name: 'Bay Mills Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bcm.edu'],
        web_pages: ['http://www.bcm.edu/'],
        alpha_two_code: 'US',
        name: 'Baylor College of Medicine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['baylor.edu'],
        web_pages: ['http://www.baylor.edu/'],
        alpha_two_code: 'US',
        name: 'Baylor University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['beaufortccc.edu'],
        web_pages: ['http://www.beaufortccc.edu'],
        alpha_two_code: 'US',
        name: 'Beaufort County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bellevue.edu'],
        web_pages: ['http://www.bellevue.edu/'],
        alpha_two_code: 'US',
        name: 'Bellevue University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['btc.ctc.edu'],
        web_pages: ['http://www.btc.ctc.edu'],
        alpha_two_code: 'US',
        name: 'Bellingham Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['belmontcollege.edu'],
        web_pages: ['http://www.belmontcollege.edu'],
        alpha_two_code: 'US',
        name: 'Belmont College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['belmont.edu'],
        web_pages: ['http://www.belmont.edu/'],
        alpha_two_code: 'US',
        name: 'Belmont University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['beloit.edu'],
        web_pages: ['http://www.beloit.edu/'],
        alpha_two_code: 'US',
        name: 'Beloit College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bemidjistate.edu'],
        web_pages: ['http://www.bemidjistate.edu/'],
        alpha_two_code: 'US',
        name: 'Bemidji State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['benedictine.edu'],
        web_pages: ['http://www.benedictine.edu/'],
        alpha_two_code: 'US',
        name: 'Benedictine College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bennington.edu'],
        web_pages: ['http://www.bennington.edu/'],
        alpha_two_code: 'US',
        name: 'Bennington College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bentley.edu'],
        web_pages: ['http://www.bentley.edu/'],
        alpha_two_code: 'US',
        name: 'Bentley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['berea.edu'],
        web_pages: ['http://www.berea.edu/'],
        alpha_two_code: 'US',
        name: 'Berea College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bergen.edu'],
        web_pages: ['http://www.bergen.edu'],
        alpha_two_code: 'US',
        name: 'Bergen Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['berkeleycitycollege.edu'],
        web_pages: ['http://www.berkeleycitycollege.edu/wp/'],
        alpha_two_code: 'US',
        name: 'Berkeley City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['berklee.edu'],
        web_pages: ['http://www.berklee.edu/'],
        alpha_two_code: 'US',
        name: 'Berklee College of Music',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['berkshirecc.edu'],
        web_pages: ['http://www.berkshirecc.edu'],
        alpha_two_code: 'US',
        name: 'Berkshire Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bethanywv.edu'],
        web_pages: ['http://www.bethanywv.edu/'],
        alpha_two_code: 'US',
        name: 'Bethany College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bethelks.edu'],
        web_pages: ['http://www.bethelks.edu/'],
        alpha_two_code: 'US',
        name: 'Bethel College (KS)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bethel.edu'],
        web_pages: ['http://www.bethel.edu/'],
        alpha_two_code: 'US',
        name: 'Bethel University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bscc.edu'],
        web_pages: ['http://www.bscc.edu'],
        alpha_two_code: 'US',
        name: 'Bevill State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bigbend.edu'],
        web_pages: ['http://www.bigbend.edu'],
        alpha_two_code: 'US',
        name: 'Big Bend Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bigsandy.kctcs.edu'],
        web_pages: ['http://www.bigsandy.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Big Sandy Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['biola.edu'],
        web_pages: ['http://www.biola.edu/'],
        alpha_two_code: 'US',
        name: 'Biola University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bsc.edu'],
        web_pages: ['http://www.bsc.edu/'],
        alpha_two_code: 'US',
        name: 'Birmingham-Southern College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bishop.edu'],
        web_pages: ['http://www.bishop.edu'],
        alpha_two_code: 'US',
        name: 'Bishop State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bhc.edu'],
        web_pages: ['http://www.bhc.edu'],
        alpha_two_code: 'US',
        name: 'Black Hawk College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bhsu.edu'],
        web_pages: ['http://www.bhsu.edu/'],
        alpha_two_code: 'US',
        name: 'Black Hills State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['blackrivertech.edu'],
        web_pages: ['http://www.blackrivertech.edu'],
        alpha_two_code: 'US',
        name: 'Black River Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bfcc.edu'],
        web_pages: ['http://bfcc.edu'],
        alpha_two_code: 'US',
        name: 'Blackfeet Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['blackhawk.edu'],
        web_pages: ['http://www.blackhawk.edu'],
        alpha_two_code: 'US',
        name: 'Blackhawk Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bladencc.edu'],
        web_pages: ['http://www.bladencc.edu'],
        alpha_two_code: 'US',
        name: 'Bladen Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['blinn.edu'],
        web_pages: ['http://www.blinn.edu'],
        alpha_two_code: 'US',
        name: 'Blinn College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bloomu.edu'],
        web_pages: ['http://www.bloomu.edu/'],
        alpha_two_code: 'US',
        name: 'Bloomsburg University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['bluecc.edu'],
        web_pages: ['http://www.bluecc.edu'],
        alpha_two_code: 'US',
        name: 'Blue Mountain Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['blueridgectc.edu'],
        web_pages: ['http://www.blueridgectc.edu/'],
        alpha_two_code: 'US',
        name: 'Blue Ridge Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['blueridge.edu'],
        web_pages: ['http://www.blueridge.edu'],
        alpha_two_code: 'US',
        name: 'Blue Ridge Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bluegrass.kctcs.edu'],
        web_pages: ['http://www.bluegrass.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Bluegrass Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bluffton.edu'],
        web_pages: ['http://www.bluffton.edu/'],
        alpha_two_code: 'US',
        name: 'Bluffton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bju.edu'],
        web_pages: ['http://www.bju.edu/'],
        alpha_two_code: 'US',
        name: 'Bob Jones University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['boisestate.edu'],
        web_pages: ['http://www.boisestate.edu/'],
        alpha_two_code: 'US',
        name: 'Boise State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bpcc.edu'],
        web_pages: ['http://www.bpcc.edu'],
        alpha_two_code: 'US',
        name: 'Bossier Parish Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bc.edu'],
        web_pages: ['http://www.bc.edu/'],
        alpha_two_code: 'US',
        name: 'Boston College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bgsp.edu'],
        web_pages: ['http://www.bgsp.edu/'],
        alpha_two_code: 'US',
        name: 'Boston Graduate School of Psychoanalysis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bu.edu'],
        web_pages: ['http://www.bu.edu/'],
        alpha_two_code: 'US',
        name: 'Boston University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bowdoin.edu'],
        web_pages: ['http://www.bowdoin.edu/'],
        alpha_two_code: 'US',
        name: 'Bowdoin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bowiestate.edu'],
        web_pages: ['http://www.bowiestate.edu/'],
        alpha_two_code: 'US',
        name: 'Bowie State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bgsu.edu'],
        web_pages: ['http://www.bgsu.edu/'],
        alpha_two_code: 'US',
        name: 'Bowling Green State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bradley.edu'],
        web_pages: ['http://www.bradley.edu/'],
        alpha_two_code: 'US',
        name: 'Bradley University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brandeis.edu'],
        web_pages: ['http://www.brandeis.edu/'],
        alpha_two_code: 'US',
        name: 'Brandeis University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brandman.edu'],
        web_pages: ['https://www.brandman.edu/'],
        alpha_two_code: 'US',
        name: 'Brandman University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brenau.edu'],
        web_pages: ['http://www.brenau.edu/'],
        alpha_two_code: 'US',
        name: 'Brenau University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brescia.edu'],
        web_pages: ['https://www.brescia.edu/'],
        alpha_two_code: 'US',
        name: 'Brescia University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['briar-cliff.edu'],
        web_pages: ['http://www.briar-cliff.edu/'],
        alpha_two_code: 'US',
        name: 'Briar Cliff College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bridgemont.edu'],
        web_pages: ['http://www.bridgemont.edu'],
        alpha_two_code: 'US',
        name: 'Bridgemont Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bridgewater.edu'],
        web_pages: ['http://www.bridgewater.edu/'],
        alpha_two_code: 'US',
        name: 'Bridgewater College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['byu.edu'],
        web_pages: ['http://www.byu.edu/'],
        alpha_two_code: 'US',
        name: 'Brigham Young University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['byui.edu'],
        web_pages: ['http://www.byui.edu/'],
        alpha_two_code: 'US',
        name: 'Brigham Young University - Idaho',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['byuh.edu'],
        web_pages: ['http://www.byuh.edu/'],
        alpha_two_code: 'US',
        name: 'Brigham Young University Hawaii',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bristolcc.edu'],
        web_pages: ['http://bristolcc.edu/'],
        alpha_two_code: 'US',
        name: 'Bristol Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brookdalecc.edu'],
        web_pages: ['http://www.brookdalecc.edu'],
        alpha_two_code: 'US',
        name: 'Brookdale Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brookhavencollege.edu'],
        web_pages: ['http://www.brookhavencollege.edu/'],
        alpha_two_code: 'US',
        name: 'Brookhaven College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brookings.edu'],
        web_pages: ['https://www.brookings.edu/'],
        alpha_two_code: 'US',
        name: 'Brookings Institution',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['broward.edu'],
        web_pages: ['http://www.broward.edu/'],
        alpha_two_code: 'US',
        name: 'Broward College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brown.edu'],
        web_pages: ['http://www.brown.edu/'],
        alpha_two_code: 'US',
        name: 'Brown University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brunswickcc.edu'],
        web_pages: ['http://www.brunswickcc.edu'],
        alpha_two_code: 'US',
        name: 'Brunswick Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bryant.edu'],
        web_pages: ['http://www.bryant.edu/'],
        alpha_two_code: 'US',
        name: 'Bryant College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brynmawr.edu'],
        web_pages: ['http://www.brynmawr.edu/college'],
        alpha_two_code: 'US',
        name: 'Bryn Mawr College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bucknell.edu'],
        web_pages: ['http://www.bucknell.edu/'],
        alpha_two_code: 'US',
        name: 'Bucknell University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bucks.edu'],
        web_pages: ['http://www.bucks.edu/'],
        alpha_two_code: 'US',
        name: 'Bucks County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bvu.edu'],
        web_pages: ['http://www.bvu.edu/'],
        alpha_two_code: 'US',
        name: 'Buena Vista University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bhcc.mass.edu'],
        web_pages: ['http://www.bhcc.mass.edu'],
        alpha_two_code: 'US',
        name: 'Bunker Hill Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bcc.edu'],
        web_pages: ['http://www.bcc.edu'],
        alpha_two_code: 'US',
        name: 'Burlington County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['butlercc.edu'],
        web_pages: ['http://www.butlercc.edu/'],
        alpha_two_code: 'US',
        name: 'Butler Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bc3.edu'],
        web_pages: ['http://www.bc3.edu'],
        alpha_two_code: 'US',
        name: 'Butler County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['butler.edu'],
        web_pages: ['http://www.butler.edu/'],
        alpha_two_code: 'US',
        name: 'Butler University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['butte.edu'],
        web_pages: ['http://www.butte.edu'],
        alpha_two_code: 'US',
        name: 'Butte College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cabrillo.edu'],
        web_pages: ['http://www.cabrillo.edu'],
        alpha_two_code: 'US',
        name: 'Cabrillo College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calbright.edu'],
        web_pages: ['https://www.calbright.edu/'],
        alpha_two_code: 'US',
        name: 'Calbright College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccti.edu'],
        web_pages: ['http://www.cccti.edu'],
        alpha_two_code: 'US',
        name: 'Caldwell Community College and Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calhoun.edu'],
        web_pages: ['http://www.calhoun.edu'],
        alpha_two_code: 'US',
        name: 'Calhoun Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calbaptist.edu'],
        web_pages: ['http://www.calbaptist.edu/'],
        alpha_two_code: 'US',
        name: 'California Baptist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calcoast.edu'],
        web_pages: ['http://www.calcoast.edu/'],
        alpha_two_code: 'US',
        name: 'California Coast University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['caltech.edu'],
        web_pages: ['http://www.caltech.edu/'],
        alpha_two_code: 'US',
        name: 'California Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['callutheran.edu'],
        web_pages: ['http://www.callutheran.edu/'],
        alpha_two_code: 'US',
        name: 'California Lutheran University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csum.edu'],
        web_pages: ['http://www.csum.edu/'],
        alpha_two_code: 'US',
        name: 'California Maritime Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cnuas.edu'],
        web_pages: ['http://www.cnuas.edu/'],
        alpha_two_code: 'US',
        name: 'California National University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cpp.edu'],
        web_pages: ['http://www.cpp.edu/'],
        alpha_two_code: 'US',
        name: 'California Polytechnic State University, Pomona',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calpoly.edu'],
        web_pages: ['http://www.calpoly.edu/'],
        alpha_two_code: 'US',
        name: 'California Polytechnic State University, San Luis Obispo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calsouthern.edu'],
        web_pages: ['http://www.calsouthern.edu/'],
        alpha_two_code: 'US',
        name: 'California Southern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csuci.edu'],
        web_pages: ['https://www.csuci.edu/'],
        alpha_two_code: 'US',
        name: 'California State University Channel Islands',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calstate.edu'],
        web_pages: ['http://www.calstate.edu/'],
        alpha_two_code: 'US',
        name: 'California State University System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csub.edu', 'csubak.edu'],
        web_pages: ['http://www.csub.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Bakersfield',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csuchico.edu'],
        web_pages: ['http://www.csuchico.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Chico',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csudh.edu'],
        web_pages: ['http://www.csudh.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Dominguez Hills',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csufresno.edu', 'fresnostate.edu'],
        web_pages: ['http://www.csufresno.edu/', 'http://www.fresnostate.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Fresno',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fullerton.edu'],
        web_pages: ['http://www.fullerton.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Fullerton',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csuhayward.edu'],
        web_pages: ['http://www.csuhayward.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Hayward',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csulb.edu'],
        web_pages: ['http://www.csulb.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Long Beach',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['calstatela.edu'],
        web_pages: ['http://www.calstatela.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Los Angeles',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monterey.edu'],
        web_pages: ['http://www.monterey.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Monterey Bay',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csun.edu'],
        web_pages: ['http://www.csun.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Northridge',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csus.edu'],
        web_pages: ['http://www.csus.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Sacramento',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csusb.edu'],
        web_pages: ['http://www.csusb.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, San Bernardino',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csusm.edu'],
        web_pages: ['http://www.csusm.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, San Marcos',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csustan.edu'],
        web_pages: ['http://www.csustan.edu/'],
        alpha_two_code: 'US',
        name: 'California State University, Stanislaus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cup.edu'],
        web_pages: ['http://www.cup.edu/'],
        alpha_two_code: 'US',
        name: 'California University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['calvin.edu'],
        web_pages: ['http://www.calvin.edu/'],
        alpha_two_code: 'US',
        name: 'Calvin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['camdencc.edu'],
        web_pages: ['http://www.camdencc.edu'],
        alpha_two_code: 'US',
        name: 'Camden County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cameron.edu'],
        web_pages: ['http://www.cameron.edu/'],
        alpha_two_code: 'US',
        name: 'Cameron University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['campbell.edu'],
        web_pages: ['http://www.campbell.edu/'],
        alpha_two_code: 'US',
        name: 'Campbell University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['campbellsville.edu'],
        web_pages: ['http://www.campbellsville.edu/'],
        alpha_two_code: 'US',
        name: 'Campbellsville College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['canadacollege.edu'],
        web_pages: ['http://canadacollege.edu'],
        alpha_two_code: 'US',
        name: 'Canada College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['canisius.edu'],
        web_pages: ['http://www.canisius.edu/'],
        alpha_two_code: 'US',
        name: 'Canisius College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['littlehoop.edu'],
        web_pages: ['http://www.littlehoop.edu'],
        alpha_two_code: 'US',
        name: 'Cankdeska Cikana Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['capecod.edu'],
        web_pages: ['http://www.capecod.edu'],
        alpha_two_code: 'US',
        name: 'Cape Cod Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cfcc.edu'],
        web_pages: ['http://www.cfcc.edu'],
        alpha_two_code: 'US',
        name: 'Cape Fear Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['capella.edu', 'capellauniversity.edu'],
        web_pages: ['http://www.capella.edu/', 'http://www.capellauniversity.edu/'],
        alpha_two_code: 'US',
        name: 'Capella University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.commnet.edu'],
        web_pages: ['http://www.ccc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Capital Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['captechu.edu'],
        web_pages: ['http://www.captechu.edu/'],
        alpha_two_code: 'US',
        name: 'Capitol Technology University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccnn.edu'],
        web_pages: ['http://www.ccnn.edu/'],
        alpha_two_code: 'US',
        name: 'Career College of Northern Nevada',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carlalbert.edu'],
        web_pages: ['http://www.carlalbert.edu'],
        alpha_two_code: 'US',
        name: 'Carl Albert State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sandburg.edu'],
        web_pages: ['http://www.sandburg.edu'],
        alpha_two_code: 'US',
        name: 'Carl Sandburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carleton.edu'],
        web_pages: ['http://www.carleton.edu/'],
        alpha_two_code: 'US',
        name: 'Carleton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carlow.edu'],
        web_pages: ['http://www.carlow.edu/'],
        alpha_two_code: 'US',
        name: 'Carlow College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmu.edu'],
        web_pages: ['http://www.cmu.edu/'],
        alpha_two_code: 'US',
        name: 'Carnegie Mellon University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carolinascollege.edu'],
        web_pages: ['http://www.carolinascollege.edu'],
        alpha_two_code: 'US',
        name: 'Carolinas College of Health Sciences',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carrington.edu'],
        web_pages: ['http://www.carrington.edu'],
        alpha_two_code: 'US',
        name: 'Carrington College California-​Sacramento',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carroll.edu'],
        web_pages: ['http://www.carroll.edu/'],
        alpha_two_code: 'US',
        name: 'Carroll College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carrollcc.edu'],
        web_pages: ['http://www.carrollcc.edu'],
        alpha_two_code: 'US',
        name: 'Carroll Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carrollu.edu'],
        web_pages: ['http://www.carrollu.edu/'],
        alpha_two_code: 'US',
        name: 'Carroll University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cn.edu'],
        web_pages: ['http://www.cn.edu/'],
        alpha_two_code: 'US',
        name: 'Carson-Newman College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carteret.edu'],
        web_pages: ['http://www.carteret.edu'],
        alpha_two_code: 'US',
        name: 'Carteret Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['carthage.edu'],
        web_pages: ['http://www.carthage.edu/'],
        alpha_two_code: 'US',
        name: 'Carthage College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cascadia.edu'],
        web_pages: ['http://www.cascadia.edu'],
        alpha_two_code: 'US',
        name: 'Cascadia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['case.edu'],
        web_pages: ['http://www.case.edu/'],
        alpha_two_code: 'US',
        name: 'Case Western Reserve University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['caspercollege.edu'],
        web_pages: ['http://www.caspercollege.edu'],
        alpha_two_code: 'US',
        name: 'Casper College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['castleton.edu'],
        web_pages: ['http://www.castleton.edu/'],
        alpha_two_code: 'US',
        name: 'Castleton State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cvcc.edu'],
        web_pages: ['http://www.cvcc.edu'],
        alpha_two_code: 'US',
        name: 'Catawba Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cua.edu'],
        web_pages: ['http://www.cua.edu/'],
        alpha_two_code: 'US',
        name: 'Catholic University of America',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cayuga-cc.edu'],
        web_pages: ['http://www.cayuga-cc.edu/'],
        alpha_two_code: 'US',
        name: 'Cayuga County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cecil.edu'],
        web_pages: ['http://www.cecil.edu'],
        alpha_two_code: 'US',
        name: 'Cecil College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cedarvalleycollege.edu'],
        web_pages: ['http://www.cedarvalleycollege.edu'],
        alpha_two_code: 'US',
        name: 'Cedar Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cedarville.edu'],
        web_pages: ['http://www.cedarville.edu/'],
        alpha_two_code: 'US',
        name: 'Cedarville College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['centenary.edu'],
        web_pages: ['http://www.centenary.edu/'],
        alpha_two_code: 'US',
        name: 'Centenary College of Louisiana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cacc.edu'],
        web_pages: ['http://www.cacc.edu'],
        alpha_two_code: 'US',
        name: 'Central Alabama Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['centralaz.edu'],
        web_pages: ['http://www.centralaz.edu'],
        alpha_two_code: 'US',
        name: 'Central Arizona College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccc.edu'],
        web_pages: ['http://www.cccc.edu'],
        alpha_two_code: 'US',
        name: 'Central Carolina Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cctech.edu'],
        web_pages: ['http://www.cctech.edu'],
        alpha_two_code: 'US',
        name: 'Central Carolina Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['central.edu'],
        web_pages: ['http://www.central.edu/'],
        alpha_two_code: 'US',
        name: 'Central College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccneb.edu'],
        web_pages: ['http://www.cccneb.edu'],
        alpha_two_code: 'US',
        name: 'Central Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccsu.edu'],
        web_pages: ['http://www.ccsu.edu/'],
        alpha_two_code: 'US',
        name: 'Central Connecticut State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['centralgatech.edu'],
        web_pages: ['http://www.centralgatech.edu'],
        alpha_two_code: 'US',
        name: 'Central Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.clcmn.edu'],
        web_pages: ['http://WWW.CLCMN.EDU'],
        alpha_two_code: 'US',
        name: 'Central Lakes College-​Brainerd',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmcc.edu'],
        web_pages: ['http://www.cmcc.edu'],
        alpha_two_code: 'US',
        name: 'Central Maine Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmmccollege.edu'],
        web_pages: ['http://www.cmmccollege.edu'],
        alpha_two_code: 'US',
        name: 'Central Maine Medical Center College of Nursing and Health Professions',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmc.edu'],
        web_pages: ['http://www.cmc.edu/'],
        alpha_two_code: 'US',
        name: 'Central Methodist College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmich.edu'],
        web_pages: ['http://www.cmich.edu/'],
        alpha_two_code: 'US',
        name: 'Central Michigan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cnm.edu'],
        web_pages: ['http://www.cnm.edu'],
        alpha_two_code: 'US',
        name: 'Central New Mexico Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cotc.edu'],
        web_pages: ['http://www.cotc.edu'],
        alpha_two_code: 'US',
        name: 'Central Ohio Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cocc.edu'],
        web_pages: ['http://www.cocc.edu'],
        alpha_two_code: 'US',
        name: 'Central Oregon Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cpcc.edu'],
        web_pages: ['http://www.cpcc.edu'],
        alpha_two_code: 'US',
        name: 'Central Piedmont Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ctcd.edu'],
        web_pages: ['http://www.ctcd.edu'],
        alpha_two_code: 'US',
        name: 'Central Texas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cvcc.vccs.edu'],
        web_pages: ['http://www.cvcc.vccs.edu'],
        alpha_two_code: 'US',
        name: 'Central Virginia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cwu.edu'],
        web_pages: ['http://www.cwu.edu/'],
        alpha_two_code: 'US',
        name: 'Central Washington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cwc.edu'],
        web_pages: ['http://www.cwc.edu/'],
        alpha_two_code: 'US',
        name: 'Central Wyoming College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['centre.edu'],
        web_pages: ['http://www.centre.edu/'],
        alpha_two_code: 'US',
        name: 'Centre College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['century.edu'],
        web_pages: ['http://www.century.edu'],
        alpha_two_code: 'US',
        name: 'Century College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cerritos.edu'],
        web_pages: ['http://www.cerritos.edu'],
        alpha_two_code: 'US',
        name: 'Cerritos College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cerrocoso.edu'],
        web_pages: ['http://cerrocoso.edu'],
        alpha_two_code: 'US',
        name: 'Cerro Coso Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chabotcollege.edu'],
        web_pages: ['http://www.chabotcollege.edu'],
        alpha_two_code: 'US',
        name: 'Chabot College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clpccd.edu'],
        web_pages: ['http://www.clpccd.edu/'],
        alpha_two_code: 'US',
        name: 'Chabot-Las Positas Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csc.edu'],
        web_pages: ['http://www.csc.edu/'],
        alpha_two_code: 'US',
        name: 'Chadron State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chaffey.edu'],
        web_pages: ['http://www.chaffey.edu'],
        alpha_two_code: 'US',
        name: 'Chaffey College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['champlain.edu'],
        web_pages: ['http://www.champlain.edu/'],
        alpha_two_code: 'US',
        name: 'Champlain College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cgc.maricopa.edu'],
        web_pages: ['http://www.cgc.maricopa.edu'],
        alpha_two_code: 'US',
        name: 'Chandler-​Gilbert Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chapman.edu'],
        web_pages: ['http://www.chapman.edu/'],
        alpha_two_code: 'US',
        name: 'Chapman University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chatfield.edu'],
        web_pages: ['http://www.chatfield.edu'],
        alpha_two_code: 'US',
        name: 'Chatfield College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chatham.edu'],
        web_pages: ['http://www.chatham.edu/'],
        alpha_two_code: 'US',
        name: 'Chatham College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chattahoocheetech.edu'],
        web_pages: ['http://www.chattahoocheetech.edu'],
        alpha_two_code: 'US',
        name: 'Chattahoochee Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cv.edu'],
        web_pages: ['http://www.cv.edu'],
        alpha_two_code: 'US',
        name: 'Chattahoochee Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chattanoogastate.edu'],
        web_pages: ['http://www.chattanoogastate.edu'],
        alpha_two_code: 'US',
        name: 'Chattanooga State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chemeketa.edu'],
        web_pages: ['http://www.chemeketa.edu'],
        alpha_two_code: 'US',
        name: 'Chemeketa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chesapeake.edu'],
        web_pages: ['http://www.chesapeake.edu/'],
        alpha_two_code: 'US',
        name: 'Chesapeake College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cheyney.edu'],
        web_pages: ['http://www.cheyney.edu/'],
        alpha_two_code: 'US',
        name: 'Cheyney University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csopp.edu'],
        web_pages: ['http://www.csopp.edu/'],
        alpha_two_code: 'US',
        name: 'Chicago School of Professional Psychology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cdkc.edu'],
        web_pages: ['http://cdkc.edu'],
        alpha_two_code: 'US',
        name: 'Chief Dull Knife College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cvtc.edu'],
        web_pages: ['http://www.cvtc.edu'],
        alpha_two_code: 'US',
        name: 'Chippewa Valley Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cbu.edu'],
        web_pages: ['http://www.cbu.edu/'],
        alpha_two_code: 'US',
        name: 'Christian Brothers University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cts.edu'],
        web_pages: ['http://www.cts.edu/'],
        alpha_two_code: 'US',
        name: 'Christian Theological Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cnu.edu'],
        web_pages: ['http://www.cnu.edu/'],
        alpha_two_code: 'US',
        name: 'Christopher Newport University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cincinnatistate.edu'],
        web_pages: ['http://www.cincinnatistate.edu'],
        alpha_two_code: 'US',
        name: 'Cincinnati State Technical and Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cisco.edu'],
        web_pages: ['http://www.cisco.edu'],
        alpha_two_code: 'US',
        name: 'Cisco College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['citruscollege.edu'],
        web_pages: ['http://www.citruscollege.edu'],
        alpha_two_code: 'US',
        name: 'Citrus College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccsf.edu'],
        web_pages: ['http://www.ccsf.edu'],
        alpha_two_code: 'US',
        name: 'City College of San Francisco',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://www.ccc.edu/colleges/washington/Pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Harold Washington College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://ccc.edu/colleges/truman/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Harry S Truman College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://www.ccc.edu/colleges/kennedy/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Kennedy-​King College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://www.ccc.edu/colleges/malcolm-x/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Malcolm X College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://ccc.edu/colleges/olive-harvey/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Olive-​Harvey College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://ccc.edu/colleges/daley/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Richard J Daley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccc.edu'],
        web_pages: ['http://ccc.edu/colleges/wright/pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'City Colleges of Chicago-​Wilbur Wright College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cityu.edu'],
        web_pages: ['http://www.cityu.edu/'],
        alpha_two_code: 'US',
        name: 'City University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cuny.edu'],
        web_pages: ['http://www.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'City University of New York',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clackamas.edu'],
        web_pages: ['http://www.clackamas.edu'],
        alpha_two_code: 'US',
        name: 'Clackamas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cgs.edu'],
        web_pages: ['http://www.cgs.edu/'],
        alpha_two_code: 'US',
        name: 'Claremont Graduate School',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cgu.edu'],
        web_pages: ['https://www.cgu.edu/'],
        alpha_two_code: 'US',
        name: 'Claremont Graduate University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['claremontmckenna.edu'],
        web_pages: ['http://www.cmc.edu/'],
        alpha_two_code: 'US',
        name: 'Claremont McKenna College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cst.edu'],
        web_pages: ['https://cst.edu/'],
        alpha_two_code: 'US',
        name: 'Claremont School of Theology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarendoncollege.edu'],
        web_pages: ['http://www.clarendoncollege.edu'],
        alpha_two_code: 'US',
        name: 'Clarendon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarion.edu'],
        web_pages: ['http://www.clarion.edu/'],
        alpha_two_code: 'US',
        name: 'Clarion University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['cau.edu'],
        web_pages: ['https://www.cau.edu/'],
        alpha_two_code: 'US',
        name: 'Clark Atlanta University',
        'state-province': 'GA',
    },
    {
        country: 'United States',
        domains: ['clark.edu'],
        web_pages: ['http://www.clark.edu'],
        alpha_two_code: 'US',
        name: 'Clark College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarkstate.edu'],
        web_pages: ['http://www.clarkstate.edu'],
        alpha_two_code: 'US',
        name: 'Clark State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarku.edu'],
        web_pages: ['http://www.clarku.edu/'],
        alpha_two_code: 'US',
        name: 'Clark University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarke.edu'],
        web_pages: ['http://www.clarke.edu/'],
        alpha_two_code: 'US',
        name: 'Clarke College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clarkson.edu'],
        web_pages: ['http://www.clarkson.edu/'],
        alpha_two_code: 'US',
        name: 'Clarkson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clatsopcc.edu'],
        web_pages: ['http://www.clatsopcc.edu'],
        alpha_two_code: 'US',
        name: 'Clatsop Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clayton.edu'],
        web_pages: ['http://www.clayton.edu/'],
        alpha_two_code: 'US',
        name: 'Clayton State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clemson.edu'],
        web_pages: ['http://www.clemson.edu/'],
        alpha_two_code: 'US',
        name: 'Clemson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clevelandcc.edu'],
        web_pages: ['http://www.clevelandcc.edu'],
        alpha_two_code: 'US',
        name: 'Cleveland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clevelandstatecc.edu'],
        web_pages: ['http://www.clevelandstatecc.edu'],
        alpha_two_code: 'US',
        name: 'Cleveland State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csuohio.edu'],
        web_pages: ['http://www.csuohio.edu/'],
        alpha_two_code: 'US',
        name: 'Cleveland State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clinch.edu'],
        web_pages: ['http://www.clinch.edu/'],
        alpha_two_code: 'US',
        name: 'Clinch Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clinton.edu'],
        web_pages: ['http://www.clinton.edu'],
        alpha_two_code: 'US',
        name: 'Clinton Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cloud.edu'],
        web_pages: ['http://www.cloud.edu'],
        alpha_two_code: 'US',
        name: 'Cloud County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cptc.edu'],
        web_pages: ['http://www.cptc.edu'],
        alpha_two_code: 'US',
        name: 'Clover Park Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['clovis.edu'],
        web_pages: ['http://www.clovis.edu'],
        alpha_two_code: 'US',
        name: 'Clovis Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coahomacc.edu'],
        web_pages: ['http://www.coahomacc.edu/'],
        alpha_two_code: 'US',
        name: 'Coahoma Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccd.edu'],
        web_pages: ['http://www.cccd.edu/'],
        alpha_two_code: 'US',
        name: 'Coast Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastalalabama.edu'],
        web_pages: ['http://www.coastalalabama.edu/'],
        alpha_two_code: 'US',
        name: 'Coastal Alabama Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastalbend.edu'],
        web_pages: ['http://www.coastalbend.edu'],
        alpha_two_code: 'US',
        name: 'Coastal Bend College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastalcarolina.edu'],
        web_pages: ['http://www.coastalcarolina.edu/'],
        alpha_two_code: 'US',
        name: 'Coastal Carolina Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastal.edu'],
        web_pages: ['http://www.coastal.edu/'],
        alpha_two_code: 'US',
        name: 'Coastal Carolina University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastline.edu'],
        web_pages: ['http://www.coastline.edu'],
        alpha_two_code: 'US',
        name: 'Coastline Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cochise.edu'],
        web_pages: ['http://www.cochise.edu'],
        alpha_two_code: 'US',
        name: 'Cochise College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coconino.edu'],
        web_pages: ['https://www.coconino.edu/'],
        alpha_two_code: 'US',
        name: 'Coconino Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coe.edu'],
        web_pages: ['http://www.coe.edu/'],
        alpha_two_code: 'US',
        name: 'Coe College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coffeyville.edu'],
        web_pages: ['http://www.coffeyville.edu'],
        alpha_two_code: 'US',
        name: 'Coffeyville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coker.edu'],
        web_pages: ['http://www.coker.edu/'],
        alpha_two_code: 'US',
        name: 'Coker College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colby.edu'],
        web_pages: ['http://www.colby.edu/'],
        alpha_two_code: 'US',
        name: 'Colby College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colbycc.edu'],
        web_pages: ['http://www.colbycc.edu'],
        alpha_two_code: 'US',
        name: 'Colby Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cshl.edu'],
        web_pages: ['http://www.cshl.edu/'],
        alpha_two_code: 'US',
        name: 'Cold Spring Harbor Laboratory',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colgate.edu'],
        web_pages: ['http://www.colgate.edu/'],
        alpha_two_code: 'US',
        name: 'Colgate University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['peralta.edu'],
        web_pages: ['http://www.peralta.edu'],
        alpha_two_code: 'US',
        name: 'College of Alameda',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cofc.edu'],
        web_pages: ['http://www.cofc.edu/'],
        alpha_two_code: 'US',
        name: 'College of Charleston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dupage.edu'],
        web_pages: ['http://www.dupage.edu'],
        alpha_two_code: 'US',
        name: 'College of DuPage',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ceu.edu'],
        web_pages: ['http://www.ceu.edu/'],
        alpha_two_code: 'US',
        name: 'College of Eastern Utah',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.clcillinois.edu'],
        web_pages: ['http://WWW.CLCILLINOIS.EDU'],
        alpha_two_code: 'US',
        name: 'College of Lake County',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marin.edu'],
        web_pages: ['http://www.marin.edu'],
        alpha_two_code: 'US',
        name: 'College of Marin',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mountsaintvincent.edu'],
        web_pages: ['https://mountsaintvincent.edu/'],
        alpha_two_code: 'US',
        name: 'College of Mount Saint Vincent',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cnr.edu'],
        web_pages: ['http://www.cnr.edu/'],
        alpha_two_code: 'US',
        name: 'College of New Rochelle',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csbsju.edu'],
        web_pages: ['http://www.csbsju.edu/'],
        alpha_two_code: 'US',
        name: 'College of Saint Benedict',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stkate.edu'],
        web_pages: ['http://www.stkate.edu/'],
        alpha_two_code: 'US',
        name: 'College of Saint Catherine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['strose.edu'],
        web_pages: ['http://www.strose.edu/'],
        alpha_two_code: 'US',
        name: 'College of Saint Rose',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['collegeofsanmateo.edu'],
        web_pages: ['http://www.collegeofsanmateo.edu'],
        alpha_two_code: 'US',
        name: 'College of San Mateo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csi.edu'],
        web_pages: ['http://www.csi.edu'],
        alpha_two_code: 'US',
        name: 'College of Southern Idaho',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csmd.edu'],
        web_pages: ['http://www.csmd.edu/'],
        alpha_two_code: 'US',
        name: 'College of Southern Maryland',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csn.edu'],
        web_pages: ['https://www.csn.edu/'],
        alpha_two_code: 'US',
        name: 'College of Southern Nevada',
        'state-province': 'NV',
    },
    {
        country: 'United States',
        domains: ['stfrancis.edu'],
        web_pages: ['http://www.stfrancis.edu/'],
        alpha_two_code: 'US',
        name: 'College of St. Francis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['css.edu'],
        web_pages: ['http://www.css.edu/'],
        alpha_two_code: 'US',
        name: 'College of St. Scholastica',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['albemarle.edu'],
        web_pages: ['http://www.albemarle.edu'],
        alpha_two_code: 'US',
        name: 'College of the Albemarle',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coa.edu'],
        web_pages: ['http://www.coa.edu/'],
        alpha_two_code: 'US',
        name: 'College of the Atlantic',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['canyons.edu'],
        web_pages: ['http://www.canyons.edu'],
        alpha_two_code: 'US',
        name: 'College of the Canyons',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['collegeofthedesert.edu'],
        web_pages: ['http://collegeofthedesert.edu'],
        alpha_two_code: 'US',
        name: 'College of the Desert',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['holycross.edu'],
        web_pages: ['http://www.holycross.edu/'],
        alpha_two_code: 'US',
        name: 'College of the Holy Cross',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['com.edu'],
        web_pages: ['http://www.com.edu'],
        alpha_two_code: 'US',
        name: 'College of the Mainland',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coto.edu'],
        web_pages: ['http://www.coto.edu'],
        alpha_two_code: 'US',
        name: 'College of the Ouachitas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['redwoods.edu'],
        web_pages: ['http://www.redwoods.edu'],
        alpha_two_code: 'US',
        name: 'College of the Redwoods',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cos.edu'],
        web_pages: ['http://www.cos.edu'],
        alpha_two_code: 'US',
        name: 'College of the Sequoias',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['siskiyous.edu'],
        web_pages: ['http://www.siskiyous.edu'],
        alpha_two_code: 'US',
        name: 'College of the Siskiyous',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cwidaho.cc'],
        web_pages: ['http://cwidaho.cc/'],
        alpha_two_code: 'US',
        name: 'College of Western Idaho',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wm.edu'],
        web_pages: ['http://www.wm.edu/'],
        alpha_two_code: 'US',
        name: 'College of William and Mary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wooster.edu'],
        web_pages: ['http://www.wooster.edu/'],
        alpha_two_code: 'US',
        name: 'College of Wooster',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['collin.edu'],
        web_pages: ['http://www.collin.edu'],
        alpha_two_code: 'US',
        name: 'Collin County Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccu.edu'],
        web_pages: ['http://www.ccu.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado Christian University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coloradocollege.edu'],
        web_pages: ['http://www.coloradocollege.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccs.edu'],
        web_pages: ['http://www.cccs.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado Community College System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coloradomesa.edu'],
        web_pages: ['http://www.coloradomesa.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado Mesa University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cncc.edu'],
        web_pages: ['http://www.cncc.edu'],
        alpha_two_code: 'US',
        name: 'Colorado Northwestern Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mines.edu'],
        web_pages: ['http://www.mines.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado School of Mines',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colostate.edu'],
        web_pages: ['http://www.colostate.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csuglobal.edu'],
        web_pages: ['http://www.csuglobal.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado State University - Global Campus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coloradotech.edu', 'ctuonline.edu'],
        web_pages: ['http://www.coloradotech.edu/', 'http://www.ctuonline.edu/'],
        alpha_two_code: 'US',
        name: 'Colorado Technical University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbiabasin.edu'],
        web_pages: ['http://www.columbiabasin.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia Basin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gocolumbia.edu'],
        web_pages: ['http://www.gocolumbia.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia College (CA)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccis.edu'],
        web_pages: ['http://www.ccis.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia College (MO)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbiasc.edu'],
        web_pages: ['https://www.columbiasc.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia College (SC)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colum.edu'],
        web_pages: ['http://www.colum.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia College Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cgcc.cc.or.us'],
        web_pages: ['http://www.cgcc.cc.or.us'],
        alpha_two_code: 'US',
        name: 'Columbia Gorge Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colsouth.edu'],
        web_pages: ['http://www.colsouth.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia Southern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbiastate.edu'],
        web_pages: ['http://www.columbiastate.edu'],
        alpha_two_code: 'US',
        name: 'Columbia State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cuc.edu'],
        web_pages: ['http://www.cuc.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia Union College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbia.edu'],
        web_pages: ['http://www.columbia.edu/'],
        alpha_two_code: 'US',
        name: 'Columbia University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunycgcc.edu'],
        web_pages: ['http://www.sunycgcc.edu'],
        alpha_two_code: 'US',
        name: 'Columbia-​Greene Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cscc.edu'],
        web_pages: ['http://www.cscc.edu/'],
        alpha_two_code: 'US',
        name: 'Columbus State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbusstate.edu'],
        web_pages: ['http://www.columbusstate.edu/'],
        alpha_two_code: 'US',
        name: 'Columbus State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['columbustech.edu'],
        web_pages: ['http://www.columbustech.edu/'],
        alpha_two_code: 'US',
        name: 'Columbus Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccac.edu'],
        web_pages: ['http://www.ccac.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Allegheny County',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccaurora.edu'],
        web_pages: ['http://www.ccaurora.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Aurora',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccbcmd.edu'],
        web_pages: ['http://www.ccbcmd.edu/'],
        alpha_two_code: 'US',
        name: 'Community College of Baltimore County',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccbc.edu'],
        web_pages: ['http://www.ccbc.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Beaver County',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccd.edu'],
        web_pages: ['http://www.ccd.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Denver',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccp.edu'],
        web_pages: ['http://www.ccp.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Philadelphia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccri.edu'],
        web_pages: ['http://www.ccri.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Rhode Island',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccv.edu'],
        web_pages: ['http://www.ccv.edu'],
        alpha_two_code: 'US',
        name: 'Community College of Vermont',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccsnh.edu'],
        web_pages: ['https://www.ccsnh.edu/'],
        alpha_two_code: 'US',
        name: 'Community College System of New Hampshire',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccaa.edu'],
        web_pages: ['http://www.ccaa.edu/'],
        alpha_two_code: 'US',
        name: 'Concordia College - Ann Arbor',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cord.edu'],
        web_pages: ['http://www.cord.edu/'],
        alpha_two_code: 'US',
        name: 'Concordia College - Moorhead',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ccsn.edu'],
        web_pages: ['http://www.ccsn.edu/'],
        alpha_two_code: 'US',
        name: 'Concordia College - Seward',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csp.edu'],
        web_pages: ['http://www.csp.edu/'],
        alpha_two_code: 'US',
        name: 'Concordia College - St. Paul',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['conncoll.edu'],
        web_pages: ['http://www.conncoll.edu/'],
        alpha_two_code: 'US',
        name: 'Connecticut College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ct.edu'],
        web_pages: ['http://www.ct.edu/'],
        alpha_two_code: 'US',
        name: 'Connecticut State University System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['connorsstate.edu'],
        web_pages: ['http://www.connorsstate.edu'],
        alpha_two_code: 'US',
        name: 'Connors State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['contracosta.edu'],
        web_pages: ['http://www.contracosta.edu'],
        alpha_two_code: 'US',
        name: 'Contra Costa College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['4cd.edu'],
        web_pages: ['http://www.4cd.edu/'],
        alpha_two_code: 'US',
        name: 'Contra Costa Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cooper.edu'],
        web_pages: ['http://www.cooper.edu/'],
        alpha_two_code: 'US',
        name: 'Cooper Union for the Advancement of Science and Art',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colin.edu'],
        web_pages: ['http://www.colin.edu'],
        alpha_two_code: 'US',
        name: 'Copiah-​Lincoln Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cmccd.edu'],
        web_pages: ['http://www.cmccd.edu'],
        alpha_two_code: 'US',
        name: 'Copper Mountain Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coppin.edu'],
        web_pages: ['http://www.coppin.edu/'],
        alpha_two_code: 'US',
        name: 'Coppin State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cornell-iowa.edu'],
        web_pages: ['http://www.cornell-iowa.edu/'],
        alpha_two_code: 'US',
        name: 'Cornell College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cornell.edu'],
        web_pages: ['http://www.cornell.edu/'],
        alpha_two_code: 'US',
        name: 'Cornell University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['corning-cc.edu'],
        web_pages: ['http://www.corning-cc.edu/'],
        alpha_two_code: 'US',
        name: 'Corning Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccua.edu'],
        web_pages: ['http://www.cccua.edu/'],
        alpha_two_code: 'US',
        name: 'Cossatot Community College of the University of Arkansas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['crc.losrios.edu'],
        web_pages: ['http://www.crc.losrios.edu/'],
        alpha_two_code: 'US',
        name: 'Cosumnes River College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.ccm.edu'],
        web_pages: ['http://WWW.CCM.EDU'],
        alpha_two_code: 'US',
        name: 'County College of Morris',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cowley.edu'],
        web_pages: ['http://www.cowley.edu'],
        alpha_two_code: 'US',
        name: 'Cowley County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['craftonhills.edu'],
        web_pages: ['http://www.craftonhills.edu'],
        alpha_two_code: 'US',
        name: 'Crafton Hills College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cravencc.edu'],
        web_pages: ['http://www.cravencc.edu'],
        alpha_two_code: 'US',
        name: 'Craven Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['creighton.edu'],
        web_pages: ['http://www.creighton.edu/'],
        alpha_two_code: 'US',
        name: 'Creighton University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['crowder.edu'],
        web_pages: ['http://www.crowder.edu'],
        alpha_two_code: 'US',
        name: 'Crowder College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.cuesta.edu'],
        web_pages: ['http://WWW.CUESTA.EDU'],
        alpha_two_code: 'US',
        name: 'Cuesta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cccnj.edu'],
        web_pages: ['http://www.cccnj.edu'],
        alpha_two_code: 'US',
        name: 'Cumberland County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['baruch.cuny.edu'],
        web_pages: ['https://www.baruch.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Baruch College',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['bmcc.cuny.edu'],
        web_pages: ['http://www.bmcc.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Borough of Manhattan Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bcc.cuny.edu'],
        web_pages: ['http://www.bcc.cuny.edu'],
        alpha_two_code: 'US',
        name: 'CUNY Bronx Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brooklyn.cuny.edu'],
        web_pages: ['http://www.brooklyn.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Brooklyn College',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['ccny.cuny.edu'],
        web_pages: ['https://www.ccny.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY City College of NY',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['citytech.cuny.edu'],
        web_pages: ['https://www.citytech.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY City Tech',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['csi.cuny.edu'],
        web_pages: ['https://www.csi.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY College of Staten Island',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['hostos.cuny.edu'],
        web_pages: ['http://www.hostos.cuny.edu'],
        alpha_two_code: 'US',
        name: 'CUNY Hostos Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kbcc.cuny.edu'],
        web_pages: ['http://www.kbcc.cuny.edu'],
        alpha_two_code: 'US',
        name: 'CUNY Kingsborough Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lagcc.cuny.edu'],
        web_pages: ['http://www.lagcc.cuny.edu'],
        alpha_two_code: 'US',
        name: 'CUNY LaGuardia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['macauly.cuny.edu'],
        web_pages: ['https://macaulay.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Macauly Honors College',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['mec.cuny.edu'],
        web_pages: ['https://www.mec.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Medgar Evers College',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['qc.cuny.edu'],
        web_pages: ['https://www.qc.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'CUNY Queens College',
        'state-province': 'NY',
    },
    {
        country: 'United States',
        domains: ['qcc.cuny.edu'],
        web_pages: ['http://www.qcc.cuny.edu'],
        alpha_two_code: 'US',
        name: 'CUNY Queensborough Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['curry.edu'],
        web_pages: ['http://www.curry.edu/'],
        alpha_two_code: 'US',
        name: 'Curry College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tri-c.edu'],
        web_pages: ['http://www.tri-c.edu'],
        alpha_two_code: 'US',
        name: 'Cuyahoga Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cuyamaca.edu'],
        web_pages: ['http://www.cuyamaca.edu'],
        alpha_two_code: 'US',
        name: 'Cuyamaca College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cypresscollege.edu'],
        web_pages: ['http://www.cypresscollege.edu'],
        alpha_two_code: 'US',
        name: 'Cypress College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dslcc.edu'],
        web_pages: ['http://www.dslcc.edu'],
        alpha_two_code: 'US',
        name: 'Dabney S Lancaster Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['daemen.edu'],
        web_pages: ['http://www.daemen.edu/'],
        alpha_two_code: 'US',
        name: 'Daemen College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dakotacollege.edu'],
        web_pages: ['http://www.dakotacollege.edu'],
        alpha_two_code: 'US',
        name: 'Dakota College at Bottineau',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dctc.edu'],
        web_pages: ['http://www.dctc.edu/'],
        alpha_two_code: 'US',
        name: 'Dakota County Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dsu.edu'],
        web_pages: ['http://www.dsu.edu/'],
        alpha_two_code: 'US',
        name: 'Dakota State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dwu.edu'],
        web_pages: ['http://www.dwu.edu/'],
        alpha_two_code: 'US',
        name: 'Dakota Wesleyan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dbu.edu'],
        web_pages: ['http://www.dbu.edu/'],
        alpha_two_code: 'US',
        name: 'Dallas Baptist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dcccd.edu'],
        web_pages: ['http://www.dcccd.edu/'],
        alpha_two_code: 'US',
        name: 'Dallas County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dana.edu'],
        web_pages: ['http://www.dana.edu/'],
        alpha_two_code: 'US',
        name: 'Dana College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dwc.edu'],
        web_pages: ['http://www.dwc.edu/'],
        alpha_two_code: 'US',
        name: 'Daniel Webster College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dacc.edu'],
        web_pages: ['http://www.dacc.edu'],
        alpha_two_code: 'US',
        name: 'Danville Area Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dcc.vccs.edu'],
        web_pages: ['http://www.dcc.vccs.edu'],
        alpha_two_code: 'US',
        name: 'Danville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dartmouth.edu'],
        web_pages: ['http://www.dartmouth.edu/'],
        alpha_two_code: 'US',
        name: 'Dartmouth College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['darton.edu'],
        web_pages: ['http://www.darton.edu'],
        alpha_two_code: 'US',
        name: 'Darton State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['davenport.edu'],
        web_pages: ['http://www.davenport.edu/'],
        alpha_two_code: 'US',
        name: 'Davenport University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['davidson.edu'],
        web_pages: ['http://www.davidson.edu/'],
        alpha_two_code: 'US',
        name: 'Davidson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['davidsonccc.edu'],
        web_pages: ['http://www.davidsonccc.edu'],
        alpha_two_code: 'US',
        name: 'Davidson County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dne.wvnet.edu'],
        web_pages: ['http://www.dne.wvnet.edu/'],
        alpha_two_code: 'US',
        name: 'Davis & Elkins College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['daviscollege.edu'],
        web_pages: ['http://www.daviscollege.edu'],
        alpha_two_code: 'US',
        name: 'Davis College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dawson.edu'],
        web_pages: ['http://www.dawson.edu'],
        alpha_two_code: 'US',
        name: 'Dawson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['daytonastate.edu'],
        web_pages: ['http://www.daytonastate.edu/'],
        alpha_two_code: 'US',
        name: 'Daytona State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['deanza.edu'],
        web_pages: ['http://www.deanza.edu/'],
        alpha_two_code: 'US',
        name: 'De Anza College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dliflc.edu'],
        web_pages: ['http://www.dliflc.edu/'],
        alpha_two_code: 'US',
        name: 'Defense Language Institute Foreign Language Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['defiance.edu'],
        web_pages: ['http://www.defiance.edu/'],
        alpha_two_code: 'US',
        name: 'Defiance College',
        'state-province': 'Ohio',
    },
    {
        country: 'United States',
        domains: ['delmar.edu'],
        web_pages: ['http://www.delmar.edu'],
        alpha_two_code: 'US',
        name: 'Del Mar College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dcad.edu'],
        web_pages: ['http://www.dcad.edu'],
        alpha_two_code: 'US',
        name: 'Delaware College of Art and Design',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dccc.edu'],
        web_pages: ['http://www.dccc.edu'],
        alpha_two_code: 'US',
        name: 'Delaware County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dsc.edu'],
        web_pages: ['http://www.dsc.edu/'],
        alpha_two_code: 'US',
        name: 'Delaware State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dtcc.edu'],
        web_pages: ['https://www.dtcc.edu/our-campuses/georgetown'],
        alpha_two_code: 'US',
        name: 'Delaware Technical Community College-​Owens',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dtcc.edu'],
        web_pages: ['https://www.dtcc.edu/our-campuses/wilmington'],
        alpha_two_code: 'US',
        name: 'Delaware Technical Community College-​Stanton/​Wilmington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dtcc.edu'],
        web_pages: ['https://www.dtcc.edu/our-campuses/dover'],
        alpha_two_code: 'US',
        name: 'Delaware Technical Community College-​Terry',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dcc.edu'],
        web_pages: ['http://WWW.DCC.EDU'],
        alpha_two_code: 'US',
        name: 'Delgado Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['delta.edu'],
        web_pages: ['http://www.delta.edu'],
        alpha_two_code: 'US',
        name: 'Delta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['deltastate.edu'],
        web_pages: ['http://www.deltastate.edu/'],
        alpha_two_code: 'US',
        name: 'Delta State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['denison.edu'],
        web_pages: ['http://www.denison.edu/'],
        alpha_two_code: 'US',
        name: 'Denison University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['denmarktech.edu'],
        web_pages: ['http://www.denmarktech.edu'],
        alpha_two_code: 'US',
        name: 'Denmark Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['denvercollegeofnursing.edu'],
        web_pages: ['https://www.denvercollegeofnursing.edu/'],
        alpha_two_code: 'US',
        name: 'Denver College of Nursing',
        'state-province': 'Colorado',
    },
    {
        country: 'United States',
        domains: ['depaul.edu'],
        web_pages: ['http://www.depaul.edu/'],
        alpha_two_code: 'US',
        name: 'DePaul University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['depauw.edu'],
        web_pages: ['http://www.depauw.edu/'],
        alpha_two_code: 'US',
        name: 'DePauw University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dmacc.edu'],
        web_pages: ['http://www.dmacc.edu'],
        alpha_two_code: 'US',
        name: 'Des Moines Area Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['devry.edu'],
        web_pages: ['http://www.devry.edu/'],
        alpha_two_code: 'US',
        name: 'DeVry Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dvc.edu'],
        web_pages: ['http://www.dvc.edu'],
        alpha_two_code: 'US',
        name: 'Diablo Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dickinson.edu'],
        web_pages: ['http://www.dickinson.edu/'],
        alpha_two_code: 'US',
        name: 'Dickinson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dickinsonstate.edu'],
        web_pages: ['http://www.dickinsonstate.edu/'],
        alpha_two_code: 'US',
        name: 'Dickinson State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['digipen.edu'],
        web_pages: ['https://www.digipen.edu/'],
        alpha_two_code: 'US',
        name: 'DigiPen Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dillard.edu'],
        web_pages: ['http://www.dillard.edu/'],
        alpha_two_code: 'US',
        name: 'Dillard University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dc3.edu'],
        web_pages: ['http://www.dc3.edu'],
        alpha_two_code: 'US',
        name: 'Dodge City Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dominican.edu'],
        web_pages: ['http://www.dominican.edu/'],
        alpha_two_code: 'US',
        name: 'Dominican College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dordt.edu'],
        web_pages: ['http://www.dordt.edu/'],
        alpha_two_code: 'US',
        name: 'Dordt College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dowling.edu'],
        web_pages: ['http://www.dowling.edu/'],
        alpha_two_code: 'US',
        name: 'Dowling College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['drake.edu'],
        web_pages: ['http://www.drake.edu/'],
        alpha_two_code: 'US',
        name: 'Drake University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['drew.edu'],
        web_pages: ['http://www.drew.edu/'],
        alpha_two_code: 'US',
        name: 'Drew University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['drexel.edu'],
        web_pages: ['http://www.drexel.edu/'],
        alpha_two_code: 'US',
        name: 'Drexel University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['drury.edu'],
        web_pages: ['http://www.drury.edu/'],
        alpha_two_code: 'US',
        name: 'Drury College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['duke.edu'],
        web_pages: ['http://www.duke.edu/'],
        alpha_two_code: 'US',
        name: 'Duke University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['duq.edu'],
        web_pages: ['http://www.duq.edu/'],
        alpha_two_code: 'US',
        name: 'Duquesne University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['durhamtech.edu'],
        web_pages: ['http://www.durhamtech.edu'],
        alpha_two_code: 'US',
        name: 'Durham Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunydutchess.edu'],
        web_pages: ['http://www.sunydutchess.edu'],
        alpha_two_code: 'US',
        name: 'Dutchess Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dscc.edu'],
        web_pages: ['http://www.dscc.edu'],
        alpha_two_code: 'US',
        name: 'Dyersburg State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['earlham.edu'],
        web_pages: ['http://www.earlham.edu/'],
        alpha_two_code: 'US',
        name: 'Earlham College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.eacc.edu'],
        web_pages: ['http://WWW.EACC.EDU'],
        alpha_two_code: 'US',
        name: 'East Arkansas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ecu.edu'],
        web_pages: ['http://www.ecu.edu/'],
        alpha_two_code: 'US',
        name: 'East Carolina University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eastcentral.edu'],
        web_pages: ['http://www.eastcentral.edu'],
        alpha_two_code: 'US',
        name: 'East Central College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eccc.edu'],
        web_pages: ['http://www.eccc.edu'],
        alpha_two_code: 'US',
        name: 'East Central Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ecok.edu'],
        web_pages: ['http://www.ecok.edu/'],
        alpha_two_code: 'US',
        name: 'East Central University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elac.edu'],
        web_pages: ['http://www.elac.edu/index.htm'],
        alpha_two_code: 'US',
        name: 'East Los Angeles College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eastms.edu'],
        web_pages: ['http://www.eastms.edu/'],
        alpha_two_code: 'US',
        name: 'East Mississippi Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['esu.edu'],
        web_pages: ['http://www.esu.edu/'],
        alpha_two_code: 'US',
        name: 'East Stroudsburg State University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['etsu.edu'],
        web_pages: ['http://www.etsu.edu/'],
        alpha_two_code: 'US',
        name: 'East Tennessee State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['etbu.edu'],
        web_pages: ['https://www.etbu.edu/'],
        alpha_two_code: 'US',
        name: 'East Texas Baptist University',
        'state-province': 'TX',
    },
    {
        country: 'United States',
        domains: ['eac.edu'],
        web_pages: ['http://www.eac.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Arizona College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['easternct.edu'],
        web_pages: ['http://www.easternct.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Connecticut State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['easternflorida.edu'],
        web_pages: ['http://www.easternflorida.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Florida State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['egcc.edu'],
        web_pages: ['http://www.egcc.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Gateway Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eitc.edu'],
        web_pages: ['http://www.eitc.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Idaho Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eiu.edu'],
        web_pages: ['http://www.eiu.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Illinois University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eicc.edu'],
        web_pages: ['http://www.eicc.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Iowa Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eku.edu'],
        web_pages: ['http://www.eku.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Kentucky University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emcc.edu'],
        web_pages: ['http://www.emcc.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Maine Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emu.edu'],
        web_pages: ['http://www.emu.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Mennonite University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emich.edu'],
        web_pages: ['http://www.emich.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Michigan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['enmu.edu'],
        web_pages: ['http://www.enmu.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern New Mexico University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roswell.enmu.edu'],
        web_pages: ['http://www.roswell.enmu.edu'],
        alpha_two_code: 'US',
        name: 'Eastern New Mexico University-​Roswell Campus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eosc.edu'],
        web_pages: ['http://www.eosc.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Oklahoma State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eou.edu'],
        web_pages: ['http://www.eou.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Oregon State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['es.vccs.edu'],
        web_pages: ['http://www.es.vccs.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Shore Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ewu.edu'],
        web_pages: ['http://www.ewu.edu/'],
        alpha_two_code: 'US',
        name: 'Eastern Washington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eastern.wvnet.edu'],
        web_pages: ['http://www.Eastern.wvnet.edu'],
        alpha_two_code: 'US',
        name: 'Eastern West Virginia Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ewc.wy.edu'],
        web_pages: ['http://ewc.wy.edu'],
        alpha_two_code: 'US',
        name: 'Eastern Wyoming College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['eastfieldcollege.edu'],
        web_pages: ['http://www.eastfieldcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Eastfield College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ecpi.edu'],
        web_pages: ['https://www.ecpi.edu/'],
        alpha_two_code: 'US',
        name: 'ECPI University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['edgecombe.edu'],
        web_pages: ['http://www.edgecombe.edu'],
        alpha_two_code: 'US',
        name: 'Edgecombe Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['edgewood.edu'],
        web_pages: ['http://www.edgewood.edu/'],
        alpha_two_code: 'US',
        name: 'Edgewood College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['edinboro.edu'],
        web_pages: ['http://www.edinboro.edu/'],
        alpha_two_code: 'US',
        name: 'Edinboro University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['edisonohio.edu'],
        web_pages: ['http://www.edisonOHIO.edu'],
        alpha_two_code: 'US',
        name: 'Edison State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['edcc.edu'],
        web_pages: ['http://www.edcc.edu'],
        alpha_two_code: 'US',
        name: 'Edmonds Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['compton.edu'],
        web_pages: ['http://www.compton.edu'],
        alpha_two_code: 'US',
        name: 'El Camino College-​Compton Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elcamino.edu'],
        web_pages: ['http://www.elcamino.edu'],
        alpha_two_code: 'US',
        name: 'El Camino Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elcentrocollege.edu'],
        web_pages: ['http://www.elcentrocollege.edu/'],
        alpha_two_code: 'US',
        name: 'El Centro College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['epcc.edu'],
        web_pages: ['http://www.epcc.edu'],
        alpha_two_code: 'US',
        name: 'El Paso Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elgin.edu'],
        web_pages: ['http://www.elgin.edu'],
        alpha_two_code: 'US',
        name: 'Elgin Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ecsu.edu'],
        web_pages: ['http://www.ecsu.edu/'],
        alpha_two_code: 'US',
        name: 'Elizabeth City State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['etown.edu'],
        web_pages: ['http://www.etown.edu/'],
        alpha_two_code: 'US',
        name: 'Elizabethtown College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elizabethtown.kctcs.edu'],
        web_pages: ['http://www.elizabethtown.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Elizabethtown Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elmhurst.edu'],
        web_pages: ['http://www.elmhurst.edu/'],
        alpha_two_code: 'US',
        name: 'Elmhurst College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['elon.edu'],
        web_pages: ['http://www.elon.edu/'],
        alpha_two_code: 'US',
        name: 'Elon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['erau.edu'],
        web_pages: ['http://www.erau.edu/'],
        alpha_two_code: 'US',
        name: 'Embry-Riddle Aeronautical University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emerson.edu'],
        web_pages: ['http://www.emerson.edu/'],
        alpha_two_code: 'US',
        name: 'Emerson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emmanuel.edu'],
        web_pages: ['http://www.emmanuel.edu/'],
        alpha_two_code: 'US',
        name: 'Emmanuel College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ehc.edu'],
        web_pages: ['https://www.ehc.edu/'],
        alpha_two_code: 'US',
        name: 'Emory & Henry College',
        'state-province': 'VA',
    },
    {
        country: 'United States',
        domains: ['emory.edu'],
        web_pages: ['http://www.emory.edu/'],
        alpha_two_code: 'US',
        name: 'Emory University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emporia.edu'],
        web_pages: ['http://www.emporia.edu/'],
        alpha_two_code: 'US',
        name: 'Emporia State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['escc.edu'],
        web_pages: ['http://www.escc.edu'],
        alpha_two_code: 'US',
        name: 'Enterprise State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ecc.edu'],
        web_pages: ['http://www.ecc.edu/'],
        alpha_two_code: 'US',
        name: 'Erie Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['essex.edu'],
        web_pages: ['http://www.essex.edu'],
        alpha_two_code: 'US',
        name: 'Essex County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['emc.maricopa.edu'],
        web_pages: ['http://www.emc.maricopa.edu'],
        alpha_two_code: 'US',
        name: 'Estrella Mountain Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['everest.edu'],
        web_pages: ['http://www.everest.edu/'],
        alpha_two_code: 'US',
        name: 'Everest College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['everettcc.edu'],
        web_pages: ['http://www.everettcc.edu'],
        alpha_two_code: 'US',
        name: 'Everett Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['evergreen.edu'],
        web_pages: ['http://www.evergreen.edu/'],
        alpha_two_code: 'US',
        name: 'Evergreen State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['evc.edu'],
        web_pages: ['http://www.evc.edu'],
        alpha_two_code: 'US',
        name: 'Evergreen Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fdu.edu'],
        web_pages: ['http://www.fdu.edu/'],
        alpha_two_code: 'US',
        name: 'Fairleigh Dickinson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fairmontstate.edu'],
        web_pages: ['http://www.fairmontstate.edu/'],
        alpha_two_code: 'US',
        name: 'Fairmont State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uncfsu.edu'],
        web_pages: ['http://www.uncfsu.edu/'],
        alpha_two_code: 'US',
        name: 'Fayetteville State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['faytechcc.edu'],
        web_pages: ['http://www.faytechcc.edu'],
        alpha_two_code: 'US',
        name: 'Fayetteville Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['frc.edu'],
        web_pages: ['http://www.frc.edu'],
        alpha_two_code: 'US',
        name: 'Feather River Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ferris.edu'],
        web_pages: ['http://www.ferris.edu/'],
        alpha_two_code: 'US',
        name: 'Ferris State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fielding.edu'],
        web_pages: ['http://www.fielding.edu/'],
        alpha_two_code: 'US',
        name: 'Fielding Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['flcc.edu'],
        web_pages: ['http://www.flcc.edu'],
        alpha_two_code: 'US',
        name: 'Finger Lakes Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fisk.edu'],
        web_pages: ['http://www.fisk.edu/'],
        alpha_two_code: 'US',
        name: 'Fisk University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fsc.edu'],
        web_pages: ['http://www.fsc.edu/'],
        alpha_two_code: 'US',
        name: 'Fitchburg State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fvcc.edu'],
        web_pages: ['http://www.fvcc.edu'],
        alpha_two_code: 'US',
        name: 'Flathead Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fhtc.edu'],
        web_pages: ['http://www.fhtc.edu'],
        alpha_two_code: 'US',
        name: 'Flint Hills Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.fdtc.edu'],
        web_pages: ['http://WWW.FDTC.EDU'],
        alpha_two_code: 'US',
        name: 'Florence-​Darlington Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['famu.edu'],
        web_pages: ['http://www.famu.edu/'],
        alpha_two_code: 'US',
        name: 'Florida Agricultural and Mechanical University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fau.edu'],
        web_pages: ['http://www.fau.edu/'],
        alpha_two_code: 'US',
        name: 'Florida Atlantic University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fgcu.edu'],
        web_pages: ['http://www.fgcu.edu/'],
        alpha_two_code: 'US',
        name: 'Florida Gulf Coast University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fit.edu'],
        web_pages: ['http://www.fit.edu/'],
        alpha_two_code: 'US',
        name: 'Florida Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fiu.edu'],
        web_pages: ['http://www.fiu.edu/'],
        alpha_two_code: 'US',
        name: 'Florida International University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fkcc.edu'],
        web_pages: ['http://www.fkcc.edu'],
        alpha_two_code: 'US',
        name: 'Florida Keys Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['floridapoly.edu'],
        web_pages: ['https://floridapoly.edu/'],
        alpha_two_code: 'US',
        name: 'Florida Polytechnic University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fscj.edu'],
        web_pages: ['https://www.fscj.edu/'],
        alpha_two_code: 'US',
        name: 'Florida State College at Jacksonville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fsu.edu'],
        web_pages: ['http://www.fsu.edu/'],
        alpha_two_code: 'US',
        name: 'Florida State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['flc.losrios.edu'],
        web_pages: ['http://www.flc.losrios.edu/'],
        alpha_two_code: 'US',
        name: 'Folsom Lake College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fdltcc.edu'],
        web_pages: ['http://www.fdltcc.edu'],
        alpha_two_code: 'US',
        name: 'Fond du Lac Tribal and Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fontbonne.edu'],
        web_pages: ['http://www.fontbonne.edu/'],
        alpha_two_code: 'US',
        name: 'Fontbonne College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['foothill.edu'],
        web_pages: ['http://www.foothill.edu'],
        alpha_two_code: 'US',
        name: 'Foothill College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fordham.edu'],
        web_pages: ['http://www.fordham.edu/'],
        alpha_two_code: 'US',
        name: 'Fordham University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['forsythtech.edu'],
        web_pages: ['http://www.forsythtech.edu/'],
        alpha_two_code: 'US',
        name: 'Forsyth Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fhsu.edu'],
        web_pages: ['http://www.fhsu.edu/'],
        alpha_two_code: 'US',
        name: 'Fort Hays State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fortlewis.edu'],
        web_pages: ['http://www.fortlewis.edu/'],
        alpha_two_code: 'US',
        name: 'Fort Lewis College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fpcc.edu'],
        web_pages: ['http://www.fpcc.edu'],
        alpha_two_code: 'US',
        name: 'Fort Peck Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fortscott.edu'],
        web_pages: ['http://www.fortscott.edu'],
        alpha_two_code: 'US',
        name: 'Fort Scott Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fountainheadcollege.edu'],
        web_pages: ['http://fountainheadcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Fountainhead College of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['foxcollege.edu'],
        web_pages: ['http://www.foxcollege.edu'],
        alpha_two_code: 'US',
        name: 'Fox College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fvtc.edu'],
        web_pages: ['http://www.fvtc.edu'],
        alpha_two_code: 'US',
        name: 'Fox Valley Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fpctx.edu'],
        web_pages: ['http://www.fpctx.edu'],
        alpha_two_code: 'US',
        name: 'Frank Phillips College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fandm.edu'],
        web_pages: ['http://www.fandm.edu/'],
        alpha_two_code: 'US',
        name: 'Franklin and Marshall College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fplc.edu'],
        web_pages: ['http://www.fplc.edu/'],
        alpha_two_code: 'US',
        name: 'Franklin Pierce Law Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['franklin.edu'],
        web_pages: ['http://www.franklin.edu/'],
        alpha_two_code: 'US',
        name: 'Franklin University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['frederick.edu'],
        web_pages: ['http://www.frederick.edu/'],
        alpha_two_code: 'US',
        name: 'Frederick Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fresnocitycollege.edu'],
        web_pages: ['http://www.fresnocitycollege.edu'],
        alpha_two_code: 'US',
        name: 'Fresno City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fresno.edu'],
        web_pages: ['http://www.fresno.edu/'],
        alpha_two_code: 'US',
        name: 'Fresno Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['friends.edu'],
        web_pages: ['http://www.friends.edu/'],
        alpha_two_code: 'US',
        name: 'Friends University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['frontrange.edu'],
        web_pages: ['http://www.frontrange.edu'],
        alpha_two_code: 'US',
        name: 'Front Range Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['frostburg.edu'],
        web_pages: ['http://www.frostburg.edu/'],
        alpha_two_code: 'US',
        name: 'Frostburg State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fullsail.edu'],
        web_pages: ['http://www.fullsail.edu/'],
        alpha_two_code: 'US',
        name: 'Full Sail University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fuller.edu'],
        web_pages: ['http://www.fuller.edu/'],
        alpha_two_code: 'US',
        name: 'Fuller Theological Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fullcoll.edu'],
        web_pages: ['http://www.fullcoll.edu'],
        alpha_two_code: 'US',
        name: 'Fullerton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fmcc.edu'],
        web_pages: ['http://fmcc.edu'],
        alpha_two_code: 'US',
        name: 'Fulton-​Montgomery Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['furman.edu'],
        web_pages: ['http://www.furman.edu/'],
        alpha_two_code: 'US',
        name: 'Furman University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gadsdenstate.edu'],
        web_pages: ['http://www.gadsdenstate.edu'],
        alpha_two_code: 'US',
        name: 'Gadsden State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['galencollege.edu'],
        web_pages: ['http://www.galencollege.edu/louisville'],
        alpha_two_code: 'US',
        name: 'Galen College of Nursing-​Louisville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gallaudet.edu'],
        web_pages: ['http://www.gallaudet.edu/'],
        alpha_two_code: 'US',
        name: 'Gallaudet University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gc.edu'],
        web_pages: ['http://www.gc.edu'],
        alpha_two_code: 'US',
        name: 'Galveston College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gannon.edu'],
        web_pages: ['http://www.gannon.edu/'],
        alpha_two_code: 'US',
        name: 'Gannon University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gcccks.edu'],
        web_pages: ['http://www.gcccks.edu'],
        alpha_two_code: 'US',
        name: 'Garden City Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['garrettcollege.edu'],
        web_pages: ['http://www.garrettcollege.edu'],
        alpha_two_code: 'US',
        name: 'Garrett College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gaston.edu'],
        web_pages: ['http://www.gaston.edu'],
        alpha_two_code: 'US',
        name: 'Gaston College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gateway.kctcs.edu'],
        web_pages: ['http://www.gateway.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Gateway Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gwcc.commnet.edu'],
        web_pages: ['http://www.gwcc.commnet.edu/'],
        alpha_two_code: 'US',
        name: 'Gateway Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gatewaycc.edu'],
        web_pages: ['http://www.gatewaycc.edu'],
        alpha_two_code: 'US',
        name: 'GateWay Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gtc.edu'],
        web_pages: ['http://www.gtc.edu'],
        alpha_two_code: 'US',
        name: 'Gateway Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gavilan.edu'],
        web_pages: ['http://www.gavilan.edu'],
        alpha_two_code: 'US',
        name: 'Gavilan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['genesee.edu'],
        web_pages: ['http://www.genesee.edu'],
        alpha_two_code: 'US',
        name: 'Genesee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['geneva.edu'],
        web_pages: ['http://www.geneva.edu/'],
        alpha_two_code: 'US',
        name: 'Geneva College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wallace.edu'],
        web_pages: ['http://www.wallace.edu'],
        alpha_two_code: 'US',
        name: 'George C Wallace State Community College-​Dothan',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wallacestate.edu'],
        web_pages: ['http://www.wallacestate.edu'],
        alpha_two_code: 'US',
        name: 'George C Wallace State Community College-​Hanceville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wccs.edu'],
        web_pages: ['http://www.wccs.edu'],
        alpha_two_code: 'US',
        name: 'George C Wallace State Community College-​Selma',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gfc.edu'],
        web_pages: ['http://www.gfc.edu/'],
        alpha_two_code: 'US',
        name: 'George Fox College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gmu.edu'],
        web_pages: ['http://www.gmu.edu/'],
        alpha_two_code: 'US',
        name: 'George Mason University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gwu.edu'],
        web_pages: ['http://www.gwu.edu/'],
        alpha_two_code: 'US',
        name: 'George Washington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['georgetown.edu'],
        web_pages: ['http://www.georgetown.edu/'],
        alpha_two_code: 'US',
        name: 'Georgetown University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gcsu.edu'],
        web_pages: ['http://www.gcsu.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ggc.edu'],
        web_pages: ['https://ggc.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia Gwinnett College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['highlands.edu'],
        web_pages: ['http://www.highlands.edu'],
        alpha_two_code: 'US',
        name: 'Georgia Highlands College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gatech.edu'],
        web_pages: ['http://www.gatech.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gmc.cc.ga.us'],
        web_pages: ['http://www.gmc.cc.ga.us/'],
        alpha_two_code: 'US',
        name: 'Georgia Military College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gntc.edu'],
        web_pages: ['http://www.gntc.edu'],
        alpha_two_code: 'US',
        name: 'Georgia Northwestern Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gpc.edu'],
        web_pages: ['http://www.gpc.edu'],
        alpha_two_code: 'US',
        name: 'Georgia Perimeter College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gptc.edu'],
        web_pages: ['http://www.gptc.edu'],
        alpha_two_code: 'US',
        name: 'Georgia Piedmont Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['georgiasouthern.edu'],
        web_pages: ['http://www.georgiasouthern.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia Southern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gsw.edu'],
        web_pages: ['http://gsw.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia Southwestern State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gsu.edu'],
        web_pages: ['http://www.gsu.edu/'],
        alpha_two_code: 'US',
        name: 'Georgia State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['georgian.edu'],
        web_pages: ['http://www.georgian.edu/'],
        alpha_two_code: 'US',
        name: 'Georgian Court University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['germanna.edu'],
        web_pages: ['http://www.germanna.edu'],
        alpha_two_code: 'US',
        name: 'Germanna Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gettysburg.edu'],
        web_pages: ['http://www.gettysburg.edu/'],
        alpha_two_code: 'US',
        name: 'Gettysburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['glenoaks.cc.mi.us'],
        web_pages: ['http://www.glenoaks.cc.mi.us/Pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'Glen Oaks Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gccaz.edu'],
        web_pages: ['http://www.gccaz.edu'],
        alpha_two_code: 'US',
        name: 'Glendale Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msbcollege.edu'],
        web_pages: ['http://www.msbcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Globe University & Minnesota School of Business',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gccnj.edu'],
        web_pages: ['http://www.gccnj.edu'],
        alpha_two_code: 'US',
        name: 'Gloucester County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gmi.edu'],
        web_pages: ['http://www.gmi.edu/'],
        alpha_two_code: 'US',
        name: 'GMI Engineering and Management Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gogebic.edu'],
        web_pages: ['http://www.gogebic.edu'],
        alpha_two_code: 'US',
        name: 'Gogebic Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ggu.edu'],
        web_pages: ['http://www.ggu.edu/'],
        alpha_two_code: 'US',
        name: 'Golden Gate University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['goldenwestcollege.edu'],
        web_pages: ['http://www.goldenwestcollege.edu'],
        alpha_two_code: 'US',
        name: 'Golden West College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gbc.edu'],
        web_pages: ['http://www.gbc.edu/'],
        alpha_two_code: 'US',
        name: 'Goldey-Beacom College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gonzaga.edu'],
        web_pages: ['http://www.gonzaga.edu/'],
        alpha_two_code: 'US',
        name: 'Gonzaga University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['goshen.edu'],
        web_pages: ['http://www.goshen.edu/'],
        alpha_two_code: 'US',
        name: 'Goshen College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['goucher.edu'],
        web_pages: ['http://www.goucher.edu/'],
        alpha_two_code: 'US',
        name: 'Goucher College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['govst.edu'],
        web_pages: ['http://www.govst.edu/'],
        alpha_two_code: 'US',
        name: 'Governors State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['grace.edu'],
        web_pages: ['http://www.grace.edu/'],
        alpha_two_code: 'US',
        name: 'Grace College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['graceland.edu'],
        web_pages: ['http://www.graceland.edu/'],
        alpha_two_code: 'US',
        name: 'Graceland College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gcu.edu'],
        web_pages: ['http://www.gcu.edu/'],
        alpha_two_code: 'US',
        name: 'Grand Canyon University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['grcc.edu'],
        web_pages: ['http://www.grcc.edu'],
        alpha_two_code: 'US',
        name: 'Grand Rapids Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gvsu.edu'],
        web_pages: ['http://www.gvsu.edu/'],
        alpha_two_code: 'US',
        name: 'Grand Valley State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ghc.edu'],
        web_pages: ['http://www.ghc.edu'],
        alpha_two_code: 'US',
        name: 'Grays Harbor College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['grayson.edu'],
        web_pages: ['http://www.grayson.edu'],
        alpha_two_code: 'US',
        name: 'Grayson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['greatbay.edu'],
        web_pages: ['http://www.greatbay.edu'],
        alpha_two_code: 'US',
        name: 'Great Bay Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gfcmsu.edu'],
        web_pages: ['http://www.gfcmsu.edu'],
        alpha_two_code: 'US',
        name: 'Great Falls College Montana State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['greenriver.edu'],
        web_pages: ['http://www.greenriver.edu/'],
        alpha_two_code: 'US',
        name: 'Green River Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gcc.mass.edu'],
        web_pages: ['http://www.gcc.mass.edu'],
        alpha_two_code: 'US',
        name: 'Greenfield Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['greenleaf.edu'],
        web_pages: ['http://www.greenleaf.edu/'],
        alpha_two_code: 'US',
        name: 'Greenleaf University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gvltec.edu'],
        web_pages: ['http://www.gvltec.edu'],
        alpha_two_code: 'US',
        name: 'Greenville Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['grinnell.edu'],
        web_pages: ['http://www.grinnell.edu/'],
        alpha_two_code: 'US',
        name: 'Grinnell College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['grossmont.edu'],
        web_pages: ['http://www.grossmont.edu/'],
        alpha_two_code: 'US',
        name: 'Grossmont College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['guilford.edu'],
        web_pages: ['http://www.guilford.edu/'],
        alpha_two_code: 'US',
        name: 'Guilford College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gtcc.edu'],
        web_pages: ['http://www.gtcc.edu'],
        alpha_two_code: 'US',
        name: 'Guilford Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gulfcoast.edu'],
        web_pages: ['https://www.gulfcoast.edu/'],
        alpha_two_code: 'US',
        name: 'Gulf Coast State College',
        'state-province': 'Florida',
    },
    {
        country: 'United States',
        domains: ['gac.edu'],
        web_pages: ['http://www.gac.edu/'],
        alpha_two_code: 'US',
        name: 'Gustavus Adolphus College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gwinnetttech.edu'],
        web_pages: ['http://www.GwinnettTech.edu'],
        alpha_two_code: 'US',
        name: 'Gwinnett Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trenholmstate.edu'],
        web_pages: ['http://www.trenholmstate.edu'],
        alpha_two_code: 'US',
        name: 'H Councill Trenholm State Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hagerstowncc.edu'],
        web_pages: ['http://www.hagerstowncc.edu/'],
        alpha_two_code: 'US',
        name: 'Hagerstown Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['halifaxcc.edu'],
        web_pages: ['http://www.halifaxcc.edu'],
        alpha_two_code: 'US',
        name: 'Halifax Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hallmarkuniversity.edu'],
        web_pages: ['http://www.hallmarkuniversity.edu/'],
        alpha_two_code: 'US',
        name: 'Hallmark University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hamilton.edu'],
        web_pages: ['http://www.hamilton.edu/'],
        alpha_two_code: 'US',
        name: 'Hamilton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hamline.edu'],
        web_pages: ['http://www.hamline.edu/'],
        alpha_two_code: 'US',
        name: 'Hamline University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hsc.edu'],
        web_pages: ['http://www.hsc.edu/'],
        alpha_two_code: 'US',
        name: 'Hampden-Sydney College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hampshire.edu'],
        web_pages: ['http://www.hampshire.edu/'],
        alpha_two_code: 'US',
        name: 'Hampshire College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hamptonu.edu'],
        web_pages: ['http://www.hamptonu.edu/'],
        alpha_two_code: 'US',
        name: 'Hampton University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hanover.edu'],
        web_pages: ['http://www.hanover.edu/'],
        alpha_two_code: 'US',
        name: 'Hanover College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harcum.edu'],
        web_pages: ['http://www.harcum.edu'],
        alpha_two_code: 'US',
        name: 'Harcum College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harding.edu'],
        web_pages: ['http://www.harding.edu/'],
        alpha_two_code: 'US',
        name: 'Harding University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harford.edu'],
        web_pages: ['http://www.harford.edu/'],
        alpha_two_code: 'US',
        name: 'Harford Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harpercollege.edu'],
        web_pages: ['http://www.harpercollege.edu'],
        alpha_two_code: 'US',
        name: 'Harper College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hacc.edu'],
        web_pages: ['http://www.hacc.edu'],
        alpha_two_code: 'US',
        name: 'Harrisburg Area Community College-​Harrisburg',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hartnell.edu'],
        web_pages: ['http://www.hartnell.edu'],
        alpha_two_code: 'US',
        name: 'Hartnell College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hartwick.edu'],
        web_pages: ['http://www.hartwick.edu/'],
        alpha_two_code: 'US',
        name: 'Hartwick College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harvard.edu'],
        web_pages: ['http://www.harvard.edu/'],
        alpha_two_code: 'US',
        name: 'Harvard University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hmc.edu'],
        web_pages: ['http://www.hmc.edu/'],
        alpha_two_code: 'US',
        name: 'Harvey Mudd College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['haskell.edu'],
        web_pages: ['http://www.haskell.edu/'],
        alpha_two_code: 'US',
        name: 'Haskell Indian Nations University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hastings.edu'],
        web_pages: ['http://www.hastings.edu/'],
        alpha_two_code: 'US',
        name: 'Hastings College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['haverford.edu'],
        web_pages: ['http://www.haverford.edu/'],
        alpha_two_code: 'US',
        name: 'Haverford College in Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['hawaii.hawaii.edu'],
        web_pages: ['http://hawaii.hawaii.edu'],
        alpha_two_code: 'US',
        name: 'Hawaii Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hpu.edu'],
        web_pages: ['http://www.hpu.edu/'],
        alpha_two_code: 'US',
        name: 'Hawaii Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hawkeyecollege.edu'],
        web_pages: ['http://www.hawkeyecollege.edu'],
        alpha_two_code: 'US',
        name: 'Hawkeye Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['haywood.edu'],
        web_pages: ['http://www.haywood.edu'],
        alpha_two_code: 'US',
        name: 'Haywood Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hazard.kctcs.edu'],
        web_pages: ['http://www.hazard.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Hazard Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['heartland.edu'],
        web_pages: ['http://www.heartland.edu'],
        alpha_two_code: 'US',
        name: 'Heartland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['heidelberg.edu'],
        web_pages: ['http://www.heidelberg.edu/'],
        alpha_two_code: 'US',
        name: 'Heidelberg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umhelena.edu'],
        web_pages: ['http://www.umhelena.edu'],
        alpha_two_code: 'US',
        name: 'Helena College University of Montana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hencc.kctcs.edu'],
        web_pages: ['http://www.hencc.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Henderson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hendrix.edu'],
        web_pages: ['http://www.hendrix.edu/'],
        alpha_two_code: 'US',
        name: 'Hendrix College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hennepintech.edu'],
        web_pages: ['http://www.hennepintech.edu'],
        alpha_two_code: 'US',
        name: 'Hennepin Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hfcc.edu'],
        web_pages: ['http://www.hfcc.edu'],
        alpha_two_code: 'US',
        name: 'Henry Ford College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['herkimer.edu'],
        web_pages: ['http://www.herkimer.edu/'],
        alpha_two_code: 'US',
        name: 'Herkimer County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hesston.edu'],
        web_pages: ['http://www.hesston.edu/'],
        alpha_two_code: 'US',
        name: 'Hesston College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hibbing.edu'],
        web_pages: ['http://www.hibbing.edu'],
        alpha_two_code: 'US',
        name: 'Hibbing Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['highpoint.edu'],
        web_pages: ['http://www.highpoint.edu/'],
        alpha_two_code: 'US',
        name: 'High Point University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['highland.edu'],
        web_pages: ['http://www.highland.edu'],
        alpha_two_code: 'US',
        name: 'Highland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['highline.edu'],
        web_pages: ['http://www.highline.edu'],
        alpha_two_code: 'US',
        name: 'Highline Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hillcollege.edu'],
        web_pages: ['http://www.hillcollege.edu'],
        alpha_two_code: 'US',
        name: 'Hill College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hccfl.edu'],
        web_pages: ['http://www.hccfl.edu'],
        alpha_two_code: 'US',
        name: 'Hillsborough Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hillsdale.edu'],
        web_pages: ['http://www.hillsdale.edu/'],
        alpha_two_code: 'US',
        name: 'Hillsdale College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hindscc.edu'],
        web_pages: ['http://www.hindscc.edu'],
        alpha_two_code: 'US',
        name: 'Hinds Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hiram.edu'],
        web_pages: ['http://www.hiram.edu/'],
        alpha_two_code: 'US',
        name: 'Hiram College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hws.edu'],
        web_pages: ['http://www.hws.edu/'],
        alpha_two_code: 'US',
        name: 'Hobart and William Smith Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hocking.edu'],
        web_pages: ['http://www.hocking.edu'],
        alpha_two_code: 'US',
        name: 'Hocking College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hofstra.edu'],
        web_pages: ['http://www.hofstra.edu/'],
        alpha_two_code: 'US',
        name: 'Hofstra University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hollins.edu'],
        web_pages: ['http://www.hollins.edu/'],
        alpha_two_code: 'US',
        name: 'Hollins College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['holmescc.edu'],
        web_pages: ['http://www.holmescc.edu'],
        alpha_two_code: 'US',
        name: 'Holmes Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hcc.edu'],
        web_pages: ['http://www.hcc.edu'],
        alpha_two_code: 'US',
        name: 'Holyoke Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['honolulu.hawaii.edu'],
        web_pages: ['http://www.honolulu.hawaii.edu/'],
        alpha_two_code: 'US',
        name: 'Honolulu Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hood.edu'],
        web_pages: ['http://www.hood.edu/'],
        alpha_two_code: 'US',
        name: 'Hood College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hope.edu'],
        web_pages: ['http://www.hope.edu/'],
        alpha_two_code: 'US',
        name: 'Hope College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hopkinsville.kctcs.edu'],
        web_pages: ['http://hopkinsville.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Hopkinsville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hgtc.edu'],
        web_pages: ['http://www.hgtc.edu'],
        alpha_two_code: 'US',
        name: 'Horry-​Georgetown Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hcc.commnet.edu'],
        web_pages: ['http://www.hcc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Housatonic Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hbu.edu'],
        web_pages: ['https://www.hbu.edu/'],
        alpha_two_code: 'US',
        name: 'Houston Baptist University',
        'state-province': 'TX',
    },
    {
        country: 'United States',
        domains: ['hccs.edu'],
        web_pages: ['http://www.hccs.edu'],
        alpha_two_code: 'US',
        name: 'Houston Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['howardcollege.edu'],
        web_pages: ['http://www.howardcollege.edu'],
        alpha_two_code: 'US',
        name: 'Howard College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['howardcc.edu'],
        web_pages: ['http://www.howardcc.edu/'],
        alpha_two_code: 'US',
        name: 'Howard Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['howard.edu'],
        web_pages: ['http://www.howard.edu/'],
        alpha_two_code: 'US',
        name: 'Howard University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hccc.edu'],
        web_pages: ['http://www.hccc.edu'],
        alpha_two_code: 'US',
        name: 'Hudson County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hvcc.edu'],
        web_pages: ['http://www.hvcc.edu'],
        alpha_two_code: 'US',
        name: 'Hudson Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['humboldt.edu'],
        web_pages: ['http://www.humboldt.edu/'],
        alpha_two_code: 'US',
        name: 'Humboldt State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hunter.cuny.edu'],
        web_pages: ['http://www.hunter.cuny.edu/'],
        alpha_two_code: 'US',
        name: 'Hunter College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['huntingdon.edu'],
        web_pages: ['http://www.huntingdon.edu/'],
        alpha_two_code: 'US',
        name: 'Huntingdon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['huntingtonjuniorcollege.edu'],
        web_pages: ['http://www.huntingtonjuniorcollege.edu'],
        alpha_two_code: 'US',
        name: 'Huntington Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['huntington.edu'],
        web_pages: ['http://www.huntington.edu/'],
        alpha_two_code: 'US',
        name: 'Huntington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hutchcc.edu'],
        web_pages: ['http://www.hutchcc.edu'],
        alpha_two_code: 'US',
        name: 'Hutchinson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mssm.edu'],
        web_pages: ['http://icahn.mssm.edu/'],
        alpha_two_code: 'US',
        name: 'Icahn School of Medicine at Mount Sinai',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ici.edu'],
        web_pages: ['http://www.ici.edu/'],
        alpha_two_code: 'US',
        name: 'ICI University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['isu.edu'],
        web_pages: ['http://www.isu.edu/'],
        alpha_two_code: 'US',
        name: 'Idaho State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ilisagvik.edu'],
        web_pages: ['http://www.ilisagvik.edu'],
        alpha_two_code: 'US',
        name: 'Ilisagvik College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ibc.edu'],
        web_pages: ['http://www.ibc.edu/'],
        alpha_two_code: 'US',
        name: 'Illinois Benedictine College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['icc.edu'],
        web_pages: ['http://www.icc.edu'],
        alpha_two_code: 'US',
        name: 'Illinois Central College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iecc.edu'],
        web_pages: ['https://iecc.edu/'],
        alpha_two_code: 'US',
        name: 'Illinois Eastern Community Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iit.edu'],
        web_pages: ['http://www.iit.edu/'],
        alpha_two_code: 'US',
        name: 'Illinois Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['illinoisstate.edu', 'ilstu.edu'],
        web_pages: ['http://www.illinoisstate.edu/'],
        alpha_two_code: 'US',
        name: 'Illinois State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ivcc.edu'],
        web_pages: ['http://www.ivcc.edu'],
        alpha_two_code: 'US',
        name: 'Illinois Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['imperial.edu'],
        web_pages: ['http://www.imperial.edu'],
        alpha_two_code: 'US',
        name: 'Imperial Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indycc.edu'],
        web_pages: ['http://www.indycc.edu'],
        alpha_two_code: 'US',
        name: 'Independence Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indianhills.edu'],
        web_pages: ['http://www.indianhills.edu'],
        alpha_two_code: 'US',
        name: 'Indian Hills Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['irsc.edu'],
        web_pages: ['http://www.irsc.edu/'],
        alpha_two_code: 'US',
        name: 'Indian River State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indianatech.edu', 'indianatech.net'],
        web_pages: ['http://www.indianatech.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indstate.edu'],
        web_pages: ['http://www.indstate.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iu.edu'],
        web_pages: ['http://www.iu.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indiana.edu', 'iub.edu'],
        web_pages: ['http://www.indiana.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University at Bloomington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iusb.edu'],
        web_pages: ['http://www.iusb.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University at South Bend',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iup.edu'],
        web_pages: ['http://www.iup.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['ius.edu'],
        web_pages: ['http://www.ius.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University Southeast',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iupuc.edu'],
        web_pages: ['http://www.iupuc.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University/Purdue University at Columbus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ipfw.edu'],
        web_pages: ['http://www.ipfw.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University/Purdue University at Fort Wayne',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iupui.edu'],
        web_pages: ['http://www.iupui.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana University/Purdue University at Indianapolis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['indwes.edu'],
        web_pages: ['http://www.indwes.edu/'],
        alpha_two_code: 'US',
        name: 'Indiana Wesleyan University, Marion',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iwp.edu'],
        web_pages: ['http://www.iwp.edu/'],
        alpha_two_code: 'US',
        name: 'Institute for World Politics',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['itu.edu'],
        web_pages: ['https://itu.edu/'],
        alpha_two_code: 'US',
        name: 'International Technological University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['inverhills.edu'],
        web_pages: ['http://www.inverhills.edu'],
        alpha_two_code: 'US',
        name: 'Inver Hills Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iona.edu'],
        web_pages: ['http://www.iona.edu/'],
        alpha_two_code: 'US',
        name: 'Iona College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iowacentral.edu'],
        web_pages: ['http://www.iowacentral.edu'],
        alpha_two_code: 'US',
        name: 'Iowa Central Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iowalakes.edu'],
        web_pages: ['http://www.iowalakes.edu'],
        alpha_two_code: 'US',
        name: 'Iowa Lakes Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iastate.edu'],
        web_pages: ['http://www.iastate.edu/'],
        alpha_two_code: 'US',
        name: 'Iowa State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iwcc.edu'],
        web_pages: ['http://www.iwcc.edu/'],
        alpha_two_code: 'US',
        name: 'Iowa Western Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ivc.edu'],
        web_pages: ['http://www.ivc.edu/'],
        alpha_two_code: 'US',
        name: 'Irvine Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['isothermal.edu'],
        web_pages: ['http://www.isothermal.edu'],
        alpha_two_code: 'US',
        name: 'Isothermal Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['itascacc.edu'],
        web_pages: ['http://www.itascacc.edu/'],
        alpha_two_code: 'US',
        name: 'Itasca Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iccms.edu'],
        web_pages: ['http://www.iccms.edu/Default.aspx?tabid=55'],
        alpha_two_code: 'US',
        name: 'Itawamba Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ithaca.edu'],
        web_pages: ['http://www.ithaca.edu/'],
        alpha_two_code: 'US',
        name: 'Ithaca College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['itt-tech.info', 'itt-tech.edu'],
        web_pages: ['http://itt-tech.info/'],
        alpha_two_code: 'US',
        name: 'ITT Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ivytech.edu'],
        web_pages: ['http://www.ivytech.edu'],
        alpha_two_code: 'US',
        name: 'Ivy Tech Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['drakestate.edu'],
        web_pages: ['http://www.drakestate.edu'],
        alpha_two_code: 'US',
        name: 'J F Drake State Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['reynolds.edu'],
        web_pages: ['http://www.reynolds.edu'],
        alpha_two_code: 'US',
        name: 'J Sargeant Reynolds Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jccmi.edu'],
        web_pages: ['http://www.jccmi.edu'],
        alpha_two_code: 'US',
        name: 'Jackson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jscc.edu'],
        web_pages: ['http://www.jscc.edu'],
        alpha_two_code: 'US',
        name: 'Jackson State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jsums.edu'],
        web_pages: ['http://www.jsums.edu/'],
        alpha_two_code: 'US',
        name: 'Jackson State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jacksonville-college.edu'],
        web_pages: ['http://www.jacksonville-college.edu'],
        alpha_two_code: 'US',
        name: 'Jacksonville College-​Main Campus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jsu.edu'],
        web_pages: ['http://www.jsu.edu/'],
        alpha_two_code: 'US',
        name: 'Jacksonville State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ju.edu'],
        web_pages: ['http://www.ju.edu/'],
        alpha_two_code: 'US',
        name: 'Jacksonville University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rhodesstate.edu'],
        web_pages: ['http://www.rhodesstate.edu'],
        alpha_two_code: 'US',
        name: 'James A Rhodes State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['faulknerstate.edu'],
        web_pages: ['http://www.faulknerstate.edu'],
        alpha_two_code: 'US',
        name: 'James H Faulkner State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jmu.edu'],
        web_pages: ['http://www.jmu.edu/'],
        alpha_two_code: 'US',
        name: 'James Madison University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jamessprunt.edu'],
        web_pages: ['http://www.jamessprunt.edu'],
        alpha_two_code: 'US',
        name: 'James Sprunt Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyjcc.edu'],
        web_pages: ['http://www.sunyjcc.edu'],
        alpha_two_code: 'US',
        name: 'Jamestown Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jeffco.edu'],
        web_pages: ['http://www.jeffco.edu'],
        alpha_two_code: 'US',
        name: 'Jefferson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jefferson.kctcs.edu'],
        web_pages: ['http://www.jefferson.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Jefferson Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyjefferson.edu'],
        web_pages: ['http://www.sunyjefferson.edu'],
        alpha_two_code: 'US',
        name: 'Jefferson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jdcc.edu'],
        web_pages: ['http://www.jdcc.edu'],
        alpha_two_code: 'US',
        name: 'Jefferson Davis Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jeffstateonline.com'],
        web_pages: ['http://www.jeffstateonline.com'],
        alpha_two_code: 'US',
        name: 'Jefferson State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['guptoncollege.edu'],
        web_pages: ['http://www.guptoncollege.edu'],
        alpha_two_code: 'US',
        name: 'John A Gupton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jalc.edu'],
        web_pages: ['http://www.jalc.edu'],
        alpha_two_code: 'US',
        name: 'John A Logan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jbu.edu'],
        web_pages: ['http://www.jbu.edu/'],
        alpha_two_code: 'US',
        name: 'John Brown University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jfku.edu'],
        web_pages: ['http://www.jfku.edu/'],
        alpha_two_code: 'US',
        name: 'John F. Kennedy University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jtcc.edu'],
        web_pages: ['http://www.jtcc.edu'],
        alpha_two_code: 'US',
        name: 'John Tyler Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jwcc.edu'],
        web_pages: ['http://www.jwcc.edu'],
        alpha_two_code: 'US',
        name: 'John Wood Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jh.edu', 'jhu.edu', 'johnshopkins.edu'],
        web_pages: ['http://www.jhu.edu/'],
        alpha_two_code: 'US',
        name: 'Johns Hopkins University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jhuapl.edu'],
        web_pages: ['http://www.jhuapl.edu/'],
        alpha_two_code: 'US',
        name: 'Johns Hopkins University Applied Physics Laboratory',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jwu.edu'],
        web_pages: ['http://www.jwu.edu/'],
        alpha_two_code: 'US',
        name: 'Johnson & Wales University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jbc.edu'],
        web_pages: ['http://www.jbc.edu/'],
        alpha_two_code: 'US',
        name: 'Johnson Bible College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jcsu.edu'],
        web_pages: ['http://www.jcsu.edu/'],
        alpha_two_code: 'US',
        name: 'Johnson C. Smith University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jccc.edu'],
        web_pages: ['http://www.jccc.edu'],
        alpha_two_code: 'US',
        name: 'Johnson County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['johnstoncc.edu'],
        web_pages: ['http://www.johnstoncc.edu'],
        alpha_two_code: 'US',
        name: 'Johnston Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jjc.edu'],
        web_pages: ['http://www.jjc.edu'],
        alpha_two_code: 'US',
        name: 'Joliet Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jones.edu'],
        web_pages: ['http://www.jones.edu/'],
        alpha_two_code: 'US',
        name: 'Jones College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jcjc.edu'],
        web_pages: ['http://www.jcjc.edu'],
        alpha_two_code: 'US',
        name: 'Jones County Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['judson.edu'],
        web_pages: ['http://www.judson.edu/'],
        alpha_two_code: 'US',
        name: 'Judson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['juniata.edu'],
        web_pages: ['http://www.juniata.edu/'],
        alpha_two_code: 'US',
        name: 'Juniata College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kzoo.edu'],
        web_pages: ['http://www.kzoo.edu/'],
        alpha_two_code: 'US',
        name: 'Kalamazoo College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kvcc.edu'],
        web_pages: ['http://www.kvcc.edu'],
        alpha_two_code: 'US',
        name: 'Kalamazoo Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kvctc.edu'],
        web_pages: ['http://www.kvctc.edu'],
        alpha_two_code: 'US',
        name: 'Kanawha Valley Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kcc.edu'],
        web_pages: ['http://www.kcc.edu'],
        alpha_two_code: 'US',
        name: 'Kankakee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kckcc.edu'],
        web_pages: ['http://www.kckcc.edu'],
        alpha_two_code: 'US',
        name: 'Kansas City Kansas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ksu.edu'],
        web_pages: ['http://www.ksu.edu/'],
        alpha_two_code: 'US',
        name: 'Kansas State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kwu.edu'],
        web_pages: ['http://www.kwu.edu/'],
        alpha_two_code: 'US',
        name: 'Kansas Wesleyan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kapiolani.hawaii.edu'],
        web_pages: ['http://kapiolani.hawaii.edu/page/home'],
        alpha_two_code: 'US',
        name: 'Kapiolani Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kaplan.edu'],
        web_pages: ['http://www.kaplan.edu/'],
        alpha_two_code: 'US',
        name: 'Kaplan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kaskaskia.edu'],
        web_pages: ['http://www.kaskaskia.edu'],
        alpha_two_code: 'US',
        name: 'Kaskaskia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kauai.hawaii.edu'],
        web_pages: ['http://kauai.hawaii.edu'],
        alpha_two_code: 'US',
        name: 'Kauai Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kean.edu'],
        web_pages: ['http://www.kean.edu/'],
        alpha_two_code: 'US',
        name: 'Kean College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['keene.edu'],
        web_pages: ['http://www.keene.edu/'],
        alpha_two_code: 'US',
        name: 'Keene State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['keiseruniversity.edu'],
        web_pages: ['http://www.keiseruniversity.edu/'],
        alpha_two_code: 'US',
        name: 'Keiser University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['keller.edu'],
        web_pages: ['https://www.keller.edu/'],
        alpha_two_code: 'US',
        name: 'Keller Graduate School of Management',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kellogg.edu'],
        web_pages: ['http://www.kellogg.edu'],
        alpha_two_code: 'US',
        name: 'Kellogg Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kpc.alaska.edu'],
        web_pages: ['http://www.kpc.alaska.edu'],
        alpha_two_code: 'US',
        name: 'Kenai Peninsula College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kvcc.me.edu'],
        web_pages: ['http://www.kvcc.me.edu'],
        alpha_two_code: 'US',
        name: 'Kennebec Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kennesaw.edu'],
        web_pages: ['http://www.kennesaw.edu/'],
        alpha_two_code: 'US',
        name: 'Kennesaw State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kent.edu'],
        web_pages: ['http://www.kent.edu/'],
        alpha_two_code: 'US',
        name: 'Kent State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kctcs.edu'],
        web_pages: ['http://www.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Kentucky Community & Technical College System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kenyon.edu'],
        web_pages: ['http://www.kenyon.edu/'],
        alpha_two_code: 'US',
        name: 'Kenyon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kettering.edu'],
        web_pages: ['http://www.kettering.edu/'],
        alpha_two_code: 'US',
        name: 'Kettering University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kbocc.org'],
        web_pages: ['http://www.kbocc.org'],
        alpha_two_code: 'US',
        name: 'Keweenaw Bay Ojibwa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kilgore.edu'],
        web_pages: ['http://www.kilgore.edu'],
        alpha_two_code: 'US',
        name: 'Kilgore College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kilian.edu'],
        web_pages: ['http://www.kilian.edu'],
        alpha_two_code: 'US',
        name: 'Kilian Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['king.edu'],
        web_pages: ['https://king.edu/'],
        alpha_two_code: 'US',
        name: 'King University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kings.edu'],
        web_pages: ['http://www.kings.edu/'],
        alpha_two_code: 'US',
        name: "King's College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kirkwood.edu'],
        web_pages: ['http://www.kirkwood.edu'],
        alpha_two_code: 'US',
        name: 'Kirkwood Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kirtland.edu'],
        web_pages: ['http://www.kirtland.edu'],
        alpha_two_code: 'US',
        name: 'Kirtland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kishwaukeecollege.edu'],
        web_pages: ['http://www.kishwaukeecollege.edu'],
        alpha_two_code: 'US',
        name: 'Kishwaukee College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['klamathcc.edu'],
        web_pages: ['https://www.klamathcc.edu'],
        alpha_two_code: 'US',
        name: 'Klamath Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['knox.edu'],
        web_pages: ['http://www.knox.edu/'],
        alpha_two_code: 'US',
        name: 'Knox College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['koc.alaska.edu'],
        web_pages: ['http://koc.alaska.edu'],
        alpha_two_code: 'US',
        name: 'Kodiak College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kutztown.edu'],
        web_pages: ['http://www.kutztown.edu/'],
        alpha_two_code: 'US',
        name: 'Kutztown University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['fletcher.edu'],
        web_pages: ['http://www.fletcher.edu/'],
        alpha_two_code: 'US',
        name: 'L E Fletcher Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lasierra.edu'],
        web_pages: ['http://www.lasierra.edu/'],
        alpha_two_code: 'US',
        name: 'La Sierra University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['labette.edu'],
        web_pages: ['http://www.labette.edu'],
        alpha_two_code: 'US',
        name: 'Labette Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lco.edu'],
        web_pages: ['http://www.lco.edu'],
        alpha_two_code: 'US',
        name: 'Lac Courte Oreilles Ojibwa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lackawanna.edu'],
        web_pages: ['http://www.lackawanna.edu'],
        alpha_two_code: 'US',
        name: 'Lackawanna College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lafayette.edu'],
        web_pages: ['http://www.lafayette.edu/'],
        alpha_two_code: 'US',
        name: 'Lafayette College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lagrange.edu'],
        web_pages: ['http://www.lagrange.edu/'],
        alpha_two_code: 'US',
        name: 'LaGrange College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lakeareatech.edu'],
        web_pages: ['http://www.lakeareatech.edu'],
        alpha_two_code: 'US',
        name: 'Lake Area Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lecom.edu'],
        web_pages: ['https://lecom.edu/'],
        alpha_two_code: 'US',
        name: 'Lake Erie College of Osteopathic Medicine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lfc.edu'],
        web_pages: ['http://www.lfc.edu/'],
        alpha_two_code: 'US',
        name: 'Lake Forest College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lakeland.cc.il.us'],
        web_pages: ['http://www.lakeland.cc.il.us'],
        alpha_two_code: 'US',
        name: 'Lake Land College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lakemichigancollege.edu'],
        web_pages: ['http://www.lakemichigancollege.edu'],
        alpha_two_code: 'US',
        name: 'Lake Michigan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lrsc.edu'],
        web_pages: ['http://www.lrsc.edu'],
        alpha_two_code: 'US',
        name: 'Lake Region State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lsc.edu'],
        web_pages: ['http://www.lsc.edu/'],
        alpha_two_code: 'US',
        name: 'Lake Superior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lssu.edu'],
        web_pages: ['http://www.lssu.edu/'],
        alpha_two_code: 'US',
        name: 'Lake Superior State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ltcc.edu'],
        web_pages: ['http://www.ltcc.edu'],
        alpha_two_code: 'US',
        name: 'Lake Tahoe Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lakelandcc.edu'],
        web_pages: ['http://www.lakelandcc.edu'],
        alpha_two_code: 'US',
        name: 'Lakeland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lrcc.edu'],
        web_pages: ['http://www.lrcc.edu'],
        alpha_two_code: 'US',
        name: 'Lakes Region Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['gotoltc.edu'],
        web_pages: ['http://www.gotoltc.edu'],
        alpha_two_code: 'US',
        name: 'Lakeshore Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lamarcc.edu'],
        web_pages: ['http://www.lamarcc.edu'],
        alpha_two_code: 'US',
        name: 'Lamar Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lit.edu'],
        web_pages: ['http://www.lit.edu'],
        alpha_two_code: 'US',
        name: 'Lamar Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lsco.edu'],
        web_pages: ['http://www.lsco.edu'],
        alpha_two_code: 'US',
        name: 'Lamar State College-​Orange',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lamarpa.edu'],
        web_pages: ['http://www.lamarpa.edu'],
        alpha_two_code: 'US',
        name: 'Lamar State College-​Port Arthur',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lamar.edu'],
        web_pages: ['http://www.lamar.edu/'],
        alpha_two_code: 'US',
        name: 'Lamar University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lander.edu'],
        web_pages: ['http://www.lander.edu/'],
        alpha_two_code: 'US',
        name: 'Lander University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lanecc.edu'],
        web_pages: ['http://www.Lanecc.edu'],
        alpha_two_code: 'US',
        name: 'Lane Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laney.edu'],
        web_pages: ['http://www.laney.edu/wp/'],
        alpha_two_code: 'US',
        name: 'Laney College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['langston.edu'],
        web_pages: ['http://www.langston.edu/'],
        alpha_two_code: 'US',
        name: 'Langston University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laniertech.edu'],
        web_pages: ['http://www.laniertech.edu'],
        alpha_two_code: 'US',
        name: 'Lanier Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lcc.edu'],
        web_pages: ['http://www.lcc.edu'],
        alpha_two_code: 'US',
        name: 'Lansing Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lccc.wy.edu'],
        web_pages: ['http://www.lccc.wy.edu'],
        alpha_two_code: 'US',
        name: 'Laramie County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laredo.edu'],
        web_pages: ['http://www.laredo.edu'],
        alpha_two_code: 'US',
        name: 'Laredo Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laspositascollege.edu'],
        web_pages: ['http://www.laspositascollege.edu'],
        alpha_two_code: 'US',
        name: 'Las Positas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lasalle.edu'],
        web_pages: ['http://www.lasalle.edu/'],
        alpha_two_code: 'US',
        name: 'LaSalle University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lasell.edu'],
        web_pages: ['http://www.lasell.edu/'],
        alpha_two_code: 'US',
        name: 'Lasell College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lassencollege.edu'],
        web_pages: ['http://www.lassencollege.edu/'],
        alpha_two_code: 'US',
        name: 'Lassen Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ldsbc.edu'],
        web_pages: ['http://www.ldsbc.edu'],
        alpha_two_code: 'US',
        name: 'Latter-day Saints Business College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lauruscollege.edu'],
        web_pages: ['http://www.lauruscollege.edu/'],
        alpha_two_code: 'US',
        name: 'Laurus College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ltu.edu'],
        web_pages: ['http://www.ltu.edu/'],
        alpha_two_code: 'US',
        name: 'Lawrence Technological University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lawrence.edu'],
        web_pages: ['http://www.lawrence.edu/'],
        alpha_two_code: 'US',
        name: 'Lawrence University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['chefs.edu'],
        web_pages: ['http://www.chefs.edu/chicago'],
        alpha_two_code: 'US',
        name: 'Le Cordon Bleu College of Culinary Arts-​Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lemoyne.edu'],
        web_pages: ['http://www.lemoyne.edu/'],
        alpha_two_code: 'US',
        name: 'Le Moyne College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lvc.edu'],
        web_pages: ['http://www.lvc.edu/'],
        alpha_two_code: 'US',
        name: 'Lebanon Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lee.edu'],
        web_pages: ['http://www.lee.edu'],
        alpha_two_code: 'US',
        name: 'Lee College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lltc.edu'],
        web_pages: ['http://www.lltc.edu'],
        alpha_two_code: 'US',
        name: 'Leech Lake Tribal College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['leeward.hawaii.edu'],
        web_pages: ['http://www.leeward.hawaii.edu'],
        alpha_two_code: 'US',
        name: 'Leeward Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lccc.edu'],
        web_pages: ['http://www.lccc.edu'],
        alpha_two_code: 'US',
        name: 'Lehigh Carbon Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lehigh.edu'],
        web_pages: ['http://www.lehigh.edu/'],
        alpha_two_code: 'US',
        name: 'Lehigh University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lenoircc.edu'],
        web_pages: ['http://www.lenoircc.edu/'],
        alpha_two_code: 'US',
        name: 'Lenoir Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lrc.edu'],
        web_pages: ['http://www.lrc.edu/'],
        alpha_two_code: 'US',
        name: 'Lenoir-Rhyne College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lr.edu'],
        web_pages: ['https://www.lr.edu/'],
        alpha_two_code: 'US',
        name: 'Lenoir-Rhyne University',
        'state-province': 'North Carolina',
    },
    {
        country: 'United States',
        domains: ['lesley.edu'],
        web_pages: ['http://www.lesley.edu/'],
        alpha_two_code: 'US',
        name: 'Lesley University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['letu.edu'],
        web_pages: ['http://www.letu.edu/'],
        alpha_two_code: 'US',
        name: 'LeTourneau University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lclark.edu'],
        web_pages: ['http://www.lclark.edu/'],
        alpha_two_code: 'US',
        name: 'Lewis & Clark College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lc.edu'],
        web_pages: ['http://www.lc.edu'],
        alpha_two_code: 'US',
        name: 'Lewis and Clark Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lewisu.edu'],
        web_pages: ['http://www.lewisu.edu/'],
        alpha_two_code: 'US',
        name: 'Lewis University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lcsc.edu'],
        web_pages: ['http://www.lcsc.edu/'],
        alpha_two_code: 'US',
        name: 'Lewis-Clark State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['liberty.edu'],
        web_pages: ['http://www.liberty.edu/'],
        alpha_two_code: 'US',
        name: 'Liberty University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['llcc.edu'],
        web_pages: ['http://www.llcc.edu'],
        alpha_two_code: 'US',
        name: 'Lincoln Land Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lincoln.edu'],
        web_pages: ['http://www.lincoln.edu/'],
        alpha_two_code: 'US',
        name: 'Lincoln University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lindenwood.edu'],
        web_pages: ['http://www.lindenwood.edu/'],
        alpha_two_code: 'US',
        name: 'Lindenwood University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['linfield.edu'],
        web_pages: ['http://www.linfield.edu/'],
        alpha_two_code: 'US',
        name: 'Linfield College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['linnstate.edu'],
        web_pages: ['http://www.linnstate.edu'],
        alpha_two_code: 'US',
        name: 'Linn State Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['linnbenton.edu'],
        web_pages: ['http://www.linnbenton.edu'],
        alpha_two_code: 'US',
        name: 'Linn-​Benton Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lipscomb.edu'],
        web_pages: ['https://www.lipscomb.edu/'],
        alpha_two_code: 'US',
        name: 'Lipscomb University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lbhc.edu'],
        web_pages: ['http://www.lbhc.edu/'],
        alpha_two_code: 'US',
        name: 'Little Big Horn College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['littlepriest.edu'],
        web_pages: ['http://www.littlepriest.edu'],
        alpha_two_code: 'US',
        name: 'Little Priest Tribal College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lhup.edu', 'lockhaven.edu'],
        web_pages: ['https://lockhaven.edu/'],
        alpha_two_code: 'US',
        name: 'Lock Haven University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['llu.edu'],
        web_pages: ['http://www.llu.edu/'],
        alpha_two_code: 'US',
        name: 'Loma Linda University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lonestar.edu'],
        web_pages: ['http://www.lonestar.edu'],
        alpha_two_code: 'US',
        name: 'Lone Star College System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lbcc.edu'],
        web_pages: ['http://www.lbcc.edu'],
        alpha_two_code: 'US',
        name: 'Long Beach City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['liunet.edu'],
        web_pages: ['http://www.liu.edu/'],
        alpha_two_code: 'US',
        name: 'Long Island University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['longwood.edu'],
        web_pages: ['http://www.longwood.edu/'],
        alpha_two_code: 'US',
        name: 'Longwood University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lorainccc.edu'],
        web_pages: ['http://www.lorainccc.edu'],
        alpha_two_code: 'US',
        name: 'Lorain County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['loras.edu'],
        web_pages: ['http://www.loras.edu/'],
        alpha_two_code: 'US',
        name: 'Loras College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lfcc.edu'],
        web_pages: ['http://www.lfcc.edu'],
        alpha_two_code: 'US',
        name: 'Lord Fairfax Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lacitycollege.edu'],
        web_pages: ['http://www.lacitycollege.edu/'],
        alpha_two_code: 'US',
        name: 'Los Angeles City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laccd.edu'],
        web_pages: ['http://www.laccd.edu/'],
        alpha_two_code: 'US',
        name: 'Los Angeles Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ladhs.org'],
        web_pages: ['http://ladhs.org/wps/portal/CollegeofNursing'],
        alpha_two_code: 'US',
        name: 'Los Angeles County College of Nursing and Allied Health',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lahc.edu'],
        web_pages: ['http://www.lahc.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Harbor College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lamission.edu'],
        web_pages: ['http://www.lamission.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Mission College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['piercecollege.edu'],
        web_pages: ['http://www.piercecollege.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Pierce College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lasc.edu'],
        web_pages: ['http://www.lasc.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Southwest College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lattc.edu'],
        web_pages: ['http://www.lattc.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Trade Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lavc.edu'],
        web_pages: ['http://www.lavc.edu'],
        alpha_two_code: 'US',
        name: 'Los Angeles Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['losmedanos.edu'],
        web_pages: ['http://www.losmedanos.edu'],
        alpha_two_code: 'US',
        name: 'Los Medanos College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['losrios.edu'],
        web_pages: ['http://losrios.edu/'],
        alpha_two_code: 'US',
        name: 'Los Rios Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['louisburg.edu'],
        web_pages: ['http://www.louisburg.edu'],
        alpha_two_code: 'US',
        name: 'Louisburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lacollege.edu'],
        web_pages: ['http://www.lacollege.edu/'],
        alpha_two_code: 'US',
        name: 'Louisiana College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ladelta.edu'],
        web_pages: ['http://www.ladelta.edu'],
        alpha_two_code: 'US',
        name: 'Louisiana Delta Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lsu.edu'],
        web_pages: ['http://www.lsu.edu/'],
        alpha_two_code: 'US',
        name: 'Louisiana State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lsua.edu'],
        web_pages: ['http://www.lsua.edu/'],
        alpha_two_code: 'US',
        name: 'Louisiana State University at Alexandria',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lsue.edu'],
        web_pages: ['http://www.lsue.edu'],
        alpha_two_code: 'US',
        name: 'Louisiana State University-​Eunice',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['latech.edu'],
        web_pages: ['http://www.latech.edu/'],
        alpha_two_code: 'US',
        name: 'Louisiana Tech University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lowercolumbia.edu'],
        web_pages: ['http://lowercolumbia.edu'],
        alpha_two_code: 'US',
        name: 'Lower Columbia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['loyola.edu'],
        web_pages: ['http://www.loyola.edu/'],
        alpha_two_code: 'US',
        name: 'Loyola College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lmu.edu'],
        web_pages: ['http://www.lmu.edu/'],
        alpha_two_code: 'US',
        name: 'Loyola Marymount University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['luc.edu'],
        web_pages: ['http://www.luc.edu/'],
        alpha_two_code: 'US',
        name: 'Loyola University Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['luna.edu'],
        web_pages: ['http://www.luna.edu'],
        alpha_two_code: 'US',
        name: 'Luna Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lbwcc.edu'],
        web_pages: ['http://www.lbwcc.edu'],
        alpha_two_code: 'US',
        name: 'Lurleen B Wallace Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['luther.edu'],
        web_pages: ['http://www.luther.edu/'],
        alpha_two_code: 'US',
        name: 'Luther College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['luthersem.edu'],
        web_pages: ['http://www.luthersem.edu/'],
        alpha_two_code: 'US',
        name: 'Luther Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['luzerne.edu'],
        web_pages: ['http://www.luzerne.edu'],
        alpha_two_code: 'US',
        name: 'Luzerne County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lycoming.edu'],
        web_pages: ['http://www.lycoming.edu/'],
        alpha_two_code: 'US',
        name: 'Lycoming College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lynchburg.edu'],
        web_pages: ['http://www.lynchburg.edu/'],
        alpha_two_code: 'US',
        name: 'Lynchburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lyndonstate.edu'],
        web_pages: ['http://www.lyndonstate.edu/'],
        alpha_two_code: 'US',
        name: 'Lyndon State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lynn.edu'],
        web_pages: ['http://www.lynn.edu/'],
        alpha_two_code: 'US',
        name: 'Lynn University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['lyon.edu'],
        web_pages: ['http://www.lyon.edu/'],
        alpha_two_code: 'US',
        name: 'Lyon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['macalester.edu'],
        web_pages: ['http://www.macalester.edu/'],
        alpha_two_code: 'US',
        name: 'Macalester College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['maccormac.edu'],
        web_pages: ['http://www.maccormac.edu'],
        alpha_two_code: 'US',
        name: 'MacCormac College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['macomb.edu'],
        web_pages: ['http://www.macomb.edu'],
        alpha_two_code: 'US',
        name: 'Macomb Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['madisoncollege.edu'],
        web_pages: ['http://madisoncollege.edu'],
        alpha_two_code: 'US',
        name: 'Madison Area Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['madisonville.kctcs.edu'],
        web_pages: ['http://www.madisonville.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Madisonville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mum.edu'],
        web_pages: ['http://www.mum.edu/'],
        alpha_two_code: 'US',
        name: 'Maharishi University of Management',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['malone.edu'],
        web_pages: ['http://www.malone.edu/'],
        alpha_two_code: 'US',
        name: 'Malone College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcc.commnet.edu'],
        web_pages: ['http://www.mcc.commnet.edu/'],
        alpha_two_code: 'US',
        name: 'Manchester Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['manhattantech.edu'],
        web_pages: ['http://www.manhattantech.edu'],
        alpha_two_code: 'US',
        name: 'Manhattan Area Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['manhattan.edu'],
        web_pages: ['http://www.manhattan.edu/'],
        alpha_two_code: 'US',
        name: 'Manhattan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['manor.edu'],
        web_pages: ['http://www.manor.edu'],
        alpha_two_code: 'US',
        name: 'Manor College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mansfield.edu'],
        web_pages: ['http://www.mansfield.edu/'],
        alpha_two_code: 'US',
        name: 'Mansfield University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['maricopa.edu'],
        web_pages: ['http://www.maricopa.edu/'],
        alpha_two_code: 'US',
        name: 'Maricopa County Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marietta.edu'],
        web_pages: ['http://www.marietta.edu/'],
        alpha_two_code: 'US',
        name: 'Marietta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mbl.edu'],
        web_pages: ['http://www.mbl.edu/'],
        alpha_two_code: 'US',
        name: 'Marine Biological Laboratory',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marionmilitary.edu'],
        web_pages: ['http://www.marionmilitary.edu'],
        alpha_two_code: 'US',
        name: 'Marion Military Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtc.edu'],
        web_pages: ['http://www.mtc.edu'],
        alpha_two_code: 'US',
        name: 'Marion Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marist.edu'],
        web_pages: ['http://www.marist.edu/'],
        alpha_two_code: 'US',
        name: 'Marist College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marlboro.edu'],
        web_pages: ['http://www.marlboro.edu/'],
        alpha_two_code: 'US',
        name: 'Marlboro College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marquette.edu'],
        web_pages: ['http://www.marquette.edu/'],
        alpha_two_code: 'US',
        name: 'Marquette University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marshall.edu'],
        web_pages: ['http://www.marshall.edu/'],
        alpha_two_code: 'US',
        name: 'Marshall University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['iavalley.edu'],
        web_pages: ['http://www.iavalley.edu/mcc/index.html'],
        alpha_two_code: 'US',
        name: 'Marshalltown Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['martincc.edu'],
        web_pages: ['http://www.martincc.edu'],
        alpha_two_code: 'US',
        name: 'Martin Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mbc.edu'],
        web_pages: ['http://www.mbc.edu/'],
        alpha_two_code: 'US',
        name: 'Mary Baldwin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mwc.edu'],
        web_pages: ['http://www.mwc.edu/'],
        alpha_two_code: 'US',
        name: 'Mary Washington College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mmm.edu'],
        web_pages: ['http://www.mmm.edu/'],
        alpha_two_code: 'US',
        name: 'Marymount Manhattan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marymount.edu'],
        web_pages: ['http://www.marymount.edu/'],
        alpha_two_code: 'US',
        name: 'Marymount University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['maryville.edu'],
        web_pages: ['http://www.maryville.edu/'],
        alpha_two_code: 'US',
        name: 'Maryville University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marywood.edu'],
        web_pages: ['http://www.marywood.edu'],
        alpha_two_code: 'US',
        name: 'Marywood University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['massbay.edu'],
        web_pages: ['http://www.massbay.edu'],
        alpha_two_code: 'US',
        name: 'Massachusetts Bay Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mit.edu'],
        web_pages: ['http://web.mit.edu/'],
        alpha_two_code: 'US',
        name: 'Massachusetts Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['massasoit.mass.edu', 'massasoit.edu'],
        web_pages: ['http://www.massasoit.mass.edu'],
        alpha_two_code: 'US',
        name: 'Massasoit Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['matsu.alaska.edu'],
        web_pages: ['http://matsu.alaska.edu'],
        alpha_two_code: 'US',
        name: 'Mat-Su College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mayland.edu'],
        web_pages: ['http://www.mayland.edu'],
        alpha_two_code: 'US',
        name: 'Mayland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mayo.edu'],
        web_pages: ['https://www.mayo.edu/'],
        alpha_two_code: 'US',
        name: 'Mayo Clinic',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['maysville.kctcs.edu'],
        web_pages: ['http://maysville.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Maysville Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcdaniel.edu'],
        web_pages: ['http://www.mcdaniel.edu'],
        alpha_two_code: 'US',
        name: 'McDaniel College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcdowelltech.edu'],
        web_pages: ['http://www.mcdowelltech.edu'],
        alpha_two_code: 'US',
        name: 'McDowell Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mchenry.edu'],
        web_pages: ['http://www.mchenry.edu'],
        alpha_two_code: 'US',
        name: 'McHenry County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mclennan.edu'],
        web_pages: ['http://www.mclennan.edu'],
        alpha_two_code: 'US',
        name: 'McLennan Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcm.edu'],
        web_pages: ['http://www2.mcm.edu/'],
        alpha_two_code: 'US',
        name: 'McMurry University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcneese.edu'],
        web_pages: ['http://www.mcneese.edu/'],
        alpha_two_code: 'US',
        name: 'McNeese State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcpherson.edu'],
        web_pages: ['https://www.mcpherson.edu/'],
        alpha_two_code: 'US',
        name: 'McPherson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcg.edu'],
        web_pages: ['http://www.mcg.edu/'],
        alpha_two_code: 'US',
        name: 'Medical College of Georgia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcw.edu'],
        web_pages: ['http://www.mcw.edu/'],
        alpha_two_code: 'US',
        name: 'Medical College of Wisconsin',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['musc.edu'],
        web_pages: ['http://www.musc.edu/'],
        alpha_two_code: 'US',
        name: 'Medical University of South Carolina',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mendocino.edu'],
        web_pages: ['http://www.mendocino.edu'],
        alpha_two_code: 'US',
        name: 'Mendocino College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mccd.edu'],
        web_pages: ['http://www.mccd.edu'],
        alpha_two_code: 'US',
        name: 'Merced College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mccc.edu'],
        web_pages: ['http://www.mccc.edu/'],
        alpha_two_code: 'US',
        name: 'Mercer County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mercer.edu'],
        web_pages: ['http://www.mercer.edu/'],
        alpha_two_code: 'US',
        name: 'Mercer University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mercymavericks.edu', 'mercy.edu'],
        web_pages: ['http://www.mercy.edu/'],
        alpha_two_code: 'US',
        name: 'Mercy College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mercyhurst.edu'],
        web_pages: ['http://mercyhurst.edu/'],
        alpha_two_code: 'US',
        name: 'Mercyhurst College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['meredith.edu'],
        web_pages: ['http://www.meredith.edu/'],
        alpha_two_code: 'US',
        name: 'Meredith College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['meridiancc.edu'],
        web_pages: ['http://www.meridiancc.edu'],
        alpha_two_code: 'US',
        name: 'Meridian Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['merritt.edu'],
        web_pages: ['http://www.merritt.edu'],
        alpha_two_code: 'US',
        name: 'Merritt College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mesacc.edu', 'maricopa.edu'],
        web_pages: ['http://www.mesacc.edu'],
        alpha_two_code: 'US',
        name: 'Mesa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mesabirange.edu'],
        web_pages: ['http://www.mesabirange.edu'],
        alpha_two_code: 'US',
        name: 'Mesabi Range Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mesalands.edu'],
        web_pages: ['http://www.mesalands.edu'],
        alpha_two_code: 'US',
        name: 'Mesalands Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['messiah.edu'],
        web_pages: ['http://www.messiah.edu/'],
        alpha_two_code: 'US',
        name: 'Messiah College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcckc.edu'],
        web_pages: ['http://www.mcckc.edu/'],
        alpha_two_code: 'US',
        name: 'Metropolitan Community College (MO)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mccneb.edu'],
        web_pages: ['http://www.mccneb.edu/'],
        alpha_two_code: 'US',
        name: 'Metropolitan Community College (NE)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msudenver.edu'],
        web_pages: ['http://www.msudenver.edu/'],
        alpha_two_code: 'US',
        name: 'Metropolitan State College of Denver',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['metrostate.edu'],
        web_pages: ['http://www.metrostate.edu/'],
        alpha_two_code: 'US',
        name: 'Metropolitan State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['miamioh.edu'],
        web_pages: ['http://www.miamioh.edu/'],
        alpha_two_code: 'US',
        name: 'Miami University of Ohio',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msu.edu'],
        web_pages: ['http://www.msu.edu/'],
        alpha_two_code: 'US',
        name: 'Michigan State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtu.edu'],
        web_pages: ['http://www.mtu.edu/'],
        alpha_two_code: 'US',
        name: 'Michigan Technological University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['midmich.edu'],
        web_pages: ['http://www.midmich.edu'],
        alpha_two_code: 'US',
        name: 'Mid Michigan Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['manc.edu'],
        web_pages: ['http://www.manc.edu/'],
        alpha_two_code: 'US',
        name: 'Mid-America Nazarene College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mpcc.edu'],
        web_pages: ['http://www.mpcc.edu'],
        alpha_two_code: 'US',
        name: 'Mid-​Plains Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['midsouthcc.edu'],
        web_pages: ['http://www.midsouthcc.edu'],
        alpha_two_code: 'US',
        name: 'Mid-​South Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mstc.edu'],
        web_pages: ['http://www.mstc.edu'],
        alpha_two_code: 'US',
        name: 'Mid-​State Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mga.edu'],
        web_pages: ['http://www.mga.edu/'],
        alpha_two_code: 'US',
        name: 'Middle Georgia State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtsu.edu'],
        web_pages: ['http://www.mtsu.edu/'],
        alpha_two_code: 'US',
        name: 'Middle Tennessee State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['middlebury.edu'],
        web_pages: ['http://www.middlebury.edu/'],
        alpha_two_code: 'US',
        name: 'Middlebury College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mxcc.commnet.edu'],
        web_pages: ['http://www.mxcc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Middlesex Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['middlesexcc.edu'],
        web_pages: ['http://www.middlesexcc.edu'],
        alpha_two_code: 'US',
        name: 'Middlesex County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['midlandstech.edu'],
        web_pages: ['http://www.midlandstech.edu'],
        alpha_two_code: 'US',
        name: 'Midlands Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mwsu.edu'],
        web_pages: ['http://www.mwsu.edu/'],
        alpha_two_code: 'US',
        name: 'Midwestern State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['milescc.edu'],
        web_pages: ['http://milescc.edu/'],
        alpha_two_code: 'US',
        name: 'Miles Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['millersville.edu'],
        web_pages: ['http://www.millersville.edu/'],
        alpha_two_code: 'US',
        name: 'Millersville University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['milligan.edu'],
        web_pages: ['http://www.milligan.edu/'],
        alpha_two_code: 'US',
        name: 'Milligan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['millikin.edu'],
        web_pages: ['http://www.millikin.edu/'],
        alpha_two_code: 'US',
        name: 'Millikin University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['millsaps.edu'],
        web_pages: ['http://www.millsaps.edu/'],
        alpha_two_code: 'US',
        name: 'Millsaps College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['matc.edu'],
        web_pages: ['http://matc.edu'],
        alpha_two_code: 'US',
        name: 'Milwaukee Area Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msoe.edu'],
        web_pages: ['http://www.msoe.edu/'],
        alpha_two_code: 'US',
        name: 'Milwaukee School of Engineering',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mineralarea.edu'],
        web_pages: ['http://www.mineralarea.edu'],
        alpha_two_code: 'US',
        name: 'Mineral Area College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcad.edu'],
        web_pages: ['http://www.mcad.edu/'],
        alpha_two_code: 'US',
        name: 'Minneapolis College of Art and Design',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['minneapolis.edu'],
        web_pages: ['http://www.minneapolis.edu'],
        alpha_two_code: 'US',
        name: 'Minneapolis Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeastmn.edu'],
        web_pages: ['http://www.southeastmn.edu'],
        alpha_two_code: 'US',
        name: 'Minnesota State College-​Southeast Technical',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['minnesota.edu'],
        web_pages: ['http://www.minnesota.edu'],
        alpha_two_code: 'US',
        name: 'Minnesota State Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mnstate.edu'],
        web_pages: ['http://www.mnstate.edu/'],
        alpha_two_code: 'US',
        name: 'Minnesota State University Moorhead',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mnsu.edu'],
        web_pages: ['http://www.mnsu.edu/'],
        alpha_two_code: 'US',
        name: 'Minnesota State University, Mankato',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mnwest.edu'],
        web_pages: ['http://www.mnwest.edu'],
        alpha_two_code: 'US',
        name: 'Minnesota West Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['minotstateu.edu'],
        web_pages: ['http://www.minotstateu.edu/'],
        alpha_two_code: 'US',
        name: 'Minot State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['miracosta.edu'],
        web_pages: ['http://www.miracosta.edu'],
        alpha_two_code: 'US',
        name: 'MiraCosta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['missioncollege.edu'],
        web_pages: ['http://www.missioncollege.edu/'],
        alpha_two_code: 'US',
        name: 'Mission College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mc.edu'],
        web_pages: ['http://www.mc.edu/'],
        alpha_two_code: 'US',
        name: 'Mississippi College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msdelta.edu'],
        web_pages: ['http://www.msdelta.edu'],
        alpha_two_code: 'US',
        name: 'Mississippi Delta Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mgccc.edu'],
        web_pages: ['https://www.mgccc.edu'],
        alpha_two_code: 'US',
        name: 'Mississippi Gulf Coast Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msstate.edu'],
        web_pages: ['http://www.msstate.edu/'],
        alpha_two_code: 'US',
        name: 'Mississippi State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['muw.edu'],
        web_pages: ['http://www.muw.edu/'],
        alpha_two_code: 'US',
        name: 'Mississippi University for Women',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mvsu.edu'],
        web_pages: ['https://mvsu.edu/'],
        alpha_two_code: 'US',
        name: 'Mississippi Valley State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mssc.edu'],
        web_pages: ['http://www.mssc.edu/'],
        alpha_two_code: 'US',
        name: 'Missouri Southern State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['missouristate.edu'],
        web_pages: ['http://www.missouristate.edu'],
        alpha_two_code: 'US',
        name: 'Missouri State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wp.missouristate.edu'],
        web_pages: ['http://www.wp.missouristate.edu'],
        alpha_two_code: 'US',
        name: 'Missouri State University-​West Plains',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mst.edu'],
        web_pages: ['http://www.mst.edu/'],
        alpha_two_code: 'US',
        name: 'Missouri University of Science and Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mwsc.edu'],
        web_pages: ['http://www.mwsc.edu/'],
        alpha_two_code: 'US',
        name: 'Missouri Western State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mitchellcc.edu'],
        web_pages: ['http://www.mitchellcc.edu'],
        alpha_two_code: 'US',
        name: 'Mitchell Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mitchelltech.edu'],
        web_pages: ['http://www.mitchelltech.edu'],
        alpha_two_code: 'US',
        name: 'Mitchell Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['macc.edu'],
        web_pages: ['http://www.macc.edu'],
        alpha_two_code: 'US',
        name: 'Moberly Area Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mjc.edu'],
        web_pages: ['http://mjc.edu'],
        alpha_two_code: 'US',
        name: 'Modesto Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mohave.edu'],
        web_pages: ['http://www.mohave.edu'],
        alpha_two_code: 'US',
        name: 'Mohave Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mvcc.edu'],
        web_pages: ['http://www.mvcc.edu'],
        alpha_two_code: 'US',
        name: 'Mohawk Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['molloy.edu'],
        web_pages: ['http://www.molloy.edu/'],
        alpha_two_code: 'US',
        name: 'Molloy College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monmouthcollege.edu'],
        web_pages: ['http://www.monmouthcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Monmouth College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monmouth.edu'],
        web_pages: ['http://www.monmouth.edu/'],
        alpha_two_code: 'US',
        name: 'Monmouth University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monroecollege.edu'],
        web_pages: ['https://monroecollege.edu/'],
        alpha_two_code: 'US',
        name: 'Monroe College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monroecc.edu'],
        web_pages: ['http://www.monroecc.edu/'],
        alpha_two_code: 'US',
        name: 'Monroe Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['monroeccc.edu'],
        web_pages: ['http://www.monroeccc.edu'],
        alpha_two_code: 'US',
        name: 'Monroe County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msubillings.edu'],
        web_pages: ['http://www.msubillings.edu/'],
        alpha_two_code: 'US',
        name: 'Montana State University - Billings',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montana.edu'],
        web_pages: ['http://www.montana.edu/'],
        alpha_two_code: 'US',
        name: 'Montana State University - Bozeman',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msun.edu'],
        web_pages: ['http://www.msun.edu/'],
        alpha_two_code: 'US',
        name: 'Montana State University - Northern',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtech.edu'],
        web_pages: ['http://www.mtech.edu/'],
        alpha_two_code: 'US',
        name: 'Montana Tech',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montcalm.edu'],
        web_pages: ['http://www.montcalm.edu'],
        alpha_two_code: 'US',
        name: 'Montcalm Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montclair.edu'],
        web_pages: ['http://www.montclair.edu/'],
        alpha_two_code: 'US',
        name: 'Montclair State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mpc.edu'],
        web_pages: ['http://www.mpc.edu'],
        alpha_two_code: 'US',
        name: 'Monterey Peninsula College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montgomerycollege.edu'],
        web_pages: ['http://www.montgomerycollege.edu/'],
        alpha_two_code: 'US',
        name: 'Montgomery College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montgomery.edu'],
        web_pages: ['http://www.montgomery.edu'],
        alpha_two_code: 'US',
        name: 'Montgomery Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mc3.edu'],
        web_pages: ['http://www.mc3.edu'],
        alpha_two_code: 'US',
        name: 'Montgomery County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['montreat.edu'],
        web_pages: ['http://www.montreat.edu/'],
        alpha_two_code: 'US',
        name: 'Montreat College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['moorparkcollege.edu'],
        web_pages: ['http://www.moorparkcollege.edu/index.shtml'],
        alpha_two_code: 'US',
        name: 'Moorpark College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morainepark.edu'],
        web_pages: ['http://www.morainepark.edu'],
        alpha_two_code: 'US',
        name: 'Moraine Park Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morainevalley.edu'],
        web_pages: ['http://www.morainevalley.edu'],
        alpha_two_code: 'US',
        name: 'Moraine Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['moravian.edu'],
        web_pages: ['http://www.moravian.edu/'],
        alpha_two_code: 'US',
        name: 'Moravian College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['moreheadstate.edu'],
        web_pages: ['http://www.moreheadstate.edu/'],
        alpha_two_code: 'US',
        name: 'Morehead State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morehouse.edu'],
        web_pages: ['https://morehouse.edu/'],
        alpha_two_code: 'US',
        name: 'Morehouse',
        'state-province': 'GA',
    },
    {
        country: 'United States',
        domains: ['mvc.edu'],
        web_pages: ['http://www.mvc.edu/'],
        alpha_two_code: 'US',
        name: 'Moreno Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morgancc.edu'],
        web_pages: ['http://www.morgancc.edu'],
        alpha_two_code: 'US',
        name: 'Morgan Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morgan.edu'],
        web_pages: ['http://www.morgan.edu/'],
        alpha_two_code: 'US',
        name: 'Morgan State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['morton.edu'],
        web_pages: ['http://www.morton.edu'],
        alpha_two_code: 'US',
        name: 'Morton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mscc.edu'],
        web_pages: ['http://www.mscc.edu'],
        alpha_two_code: 'US',
        name: 'Motlow State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mcc.edu'],
        web_pages: ['http://www.mcc.edu/'],
        alpha_two_code: 'US',
        name: 'Mott Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['moultrietech.edu'],
        web_pages: ['http://www.moultrietech.edu'],
        alpha_two_code: 'US',
        name: 'Moultrie Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtholyoke.edu'],
        web_pages: ['http://www.mtholyoke.edu/'],
        alpha_two_code: 'US',
        name: 'Mount Holyoke College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msj.edu'],
        web_pages: ['http://www.msj.edu/'],
        alpha_two_code: 'US',
        name: 'Mount Saint Joseph College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msmc.edu'],
        web_pages: ['http://www.msmc.edu/'],
        alpha_two_code: 'US',
        name: 'Mount Saint Mary College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mscfs.edu'],
        web_pages: ['http://www.mscfs.edu/'],
        alpha_two_code: 'US',
        name: 'Mount Senario College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msmary.edu'],
        web_pages: ['http://www.msmary.edu/'],
        alpha_two_code: 'US',
        name: "Mount St. Mary's University",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['muc.edu'],
        web_pages: ['http://www.muc.edu/'],
        alpha_two_code: 'US',
        name: 'Mount Union College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mwcc.edu'],
        web_pages: ['http://MWCC.EDU'],
        alpha_two_code: 'US',
        name: 'Mount Wachusett Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mecc.edu'],
        web_pages: ['http://www.mecc.edu'],
        alpha_two_code: 'US',
        name: 'Mountain Empire Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mctc.edu'],
        web_pages: ['http://www.mctc.edu'],
        alpha_two_code: 'US',
        name: 'Mountwest Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mhcc.edu'],
        web_pages: ['http://www.mhcc.edu'],
        alpha_two_code: 'US',
        name: 'Mt. Hood Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mtsac.edu'],
        web_pages: ['http://www.mtsac.edu'],
        alpha_two_code: 'US',
        name: 'Mt. San Antonio College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['msjc.edu'],
        web_pages: ['http://www.msjc.edu'],
        alpha_two_code: 'US',
        name: 'Mt. San Jacinto Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sacramento.mticollege.edu'],
        web_pages: ['http://sacramento.mticollege.edu'],
        alpha_two_code: 'US',
        name: 'MTI College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mscok.edu'],
        web_pages: ['http://www.mscok.edu'],
        alpha_two_code: 'US',
        name: 'Murray State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mursuky.edu'],
        web_pages: ['http://www.mursuky.edu/'],
        alpha_two_code: 'US',
        name: 'Murray State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['muskegoncc.edu'],
        web_pages: ['http://www.muskegoncc.edu'],
        alpha_two_code: 'US',
        name: 'Muskegon Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['muskingum.edu'],
        web_pages: ['http://www.muskingum.edu/'],
        alpha_two_code: 'US',
        name: 'Muskingum College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['luther.wlu.ca'],
        web_pages: ['https://luther.wlu.ca/'],
        alpha_two_code: 'CA',
        name: 'Martin Luther University College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['napavalley.edu'],
        web_pages: ['http://www.napavalley.edu'],
        alpha_two_code: 'US',
        name: 'Napa Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nashcc.edu'],
        web_pages: ['http://www.nashcc.edu'],
        alpha_two_code: 'US',
        name: 'Nash Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nashuacc.edu'],
        web_pages: ['http://www.nashuacc.edu'],
        alpha_two_code: 'US',
        name: 'Nashua Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nscc.edu'],
        web_pages: ['http://www.nscc.edu/'],
        alpha_two_code: 'US',
        name: 'Nashville State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncc.edu'],
        web_pages: ['http://www.ncc.edu/'],
        alpha_two_code: 'US',
        name: 'Nassau Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ndu.edu'],
        web_pages: ['http://www.ndu.edu/'],
        alpha_two_code: 'US',
        name: 'National Defense University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['np.edu'],
        web_pages: ['http://www.np.edu/'],
        alpha_two_code: 'US',
        name: 'National Park College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['npcc.edu'],
        web_pages: ['http://www.npcc.edu'],
        alpha_two_code: 'US',
        name: 'National Park Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nrao.edu'],
        web_pages: ['http://www.nrao.edu/'],
        alpha_two_code: 'US',
        name: 'National Radio Astronomy Observatory',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ntu.edu'],
        web_pages: ['http://www.ntu.edu/'],
        alpha_two_code: 'US',
        name: 'National Technological University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nu.edu'],
        web_pages: ['http://www.nu.edu/'],
        alpha_two_code: 'US',
        name: 'National University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nl.edu'],
        web_pages: ['http://www.nl.edu/'],
        alpha_two_code: 'US',
        name: 'National-Louis University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nv.edu'],
        web_pages: ['http://www.nv.edu'],
        alpha_two_code: 'US',
        name: 'Naugatuck Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nps.edu'],
        web_pages: ['http://www.nps.edu/'],
        alpha_two_code: 'US',
        name: 'Naval Postgraduate School',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['navarrocollege.edu'],
        web_pages: ['http://www.navarrocollege.edu'],
        alpha_two_code: 'US',
        name: 'Navarro College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['naz.edu'],
        web_pages: ['http://www2.naz.edu/'],
        alpha_two_code: 'US',
        name: 'Nazareth College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncta.unl.edu'],
        web_pages: ['http://NCTA.UNL.EDU'],
        alpha_two_code: 'US',
        name: 'Nebraska College of Technical Agriculture',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['thenicc.edu'],
        web_pages: ['http://www.thenicc.edu'],
        alpha_two_code: 'US',
        name: 'Nebraska Indian Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['neosho.edu'],
        web_pages: ['http://www.neosho.edu'],
        alpha_two_code: 'US',
        name: 'Neosho County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['neumann.edu'],
        web_pages: ['https://www.neumann.edu/'],
        alpha_two_code: 'US',
        name: 'Neumann University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nevada.edu'],
        web_pages: ['http://system.nevada.edu/'],
        alpha_two_code: 'US',
        name: 'Nevada System of Higher Education',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['newcollege.edu'],
        web_pages: ['http://www.newcollege.edu/'],
        alpha_two_code: 'US',
        name: 'New College of California',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncf.edu'],
        web_pages: ['http://www.ncf.edu/'],
        alpha_two_code: 'US',
        name: 'New College of Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['neit.edu'],
        web_pages: ['http://www.neit.edu/'],
        alpha_two_code: 'US',
        name: 'New England Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nhc.edu'],
        web_pages: ['http://www.nhc.edu/'],
        alpha_two_code: 'US',
        name: 'New Hampshire College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['njcu.edu'],
        web_pages: ['http://www.njcu.edu/'],
        alpha_two_code: 'US',
        name: 'New Jersey City University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['njit.edu'],
        web_pages: ['http://www.njit.edu/'],
        alpha_two_code: 'US',
        name: 'New Jersey Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmhu.edu'],
        web_pages: ['http://www.nmhu.edu/'],
        alpha_two_code: 'US',
        name: 'New Mexico Highlands University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmt.edu'],
        web_pages: ['http://www.nmt.edu/'],
        alpha_two_code: 'US',
        name: 'New Mexico Institute of Mining & Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmjc.edu'],
        web_pages: ['http://www.nmjc.edu'],
        alpha_two_code: 'US',
        name: 'New Mexico Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmmi.edu'],
        web_pages: ['http://www.nmmi.edu'],
        alpha_two_code: 'US',
        name: 'New Mexico Military Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmsu.edu'],
        web_pages: ['http://www.nmsu.edu/'],
        alpha_two_code: 'US',
        name: 'New Mexico State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmsua.edu'],
        web_pages: ['http://nmsua.edu'],
        alpha_two_code: 'US',
        name: 'New Mexico State University-​Alamogordo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cavern.nmsu.edu'],
        web_pages: ['http://www.cavern.nmsu.edu/'],
        alpha_two_code: 'US',
        name: 'New Mexico State University-​Carlsbad',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dabcc.nmsu.edu'],
        web_pages: ['http://dabcc.nmsu.edu/'],
        alpha_two_code: 'US',
        name: 'New Mexico State University-​Dona Ana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['newriver.edu'],
        web_pages: ['http://www.newriver.edu'],
        alpha_two_code: 'US',
        name: 'New River Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nr.edu'],
        web_pages: ['http://www.nr.edu'],
        alpha_two_code: 'US',
        name: 'New River Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nyit.edu'],
        web_pages: ['http://www.nyit.edu/'],
        alpha_two_code: 'US',
        name: 'New York Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nyu.edu'],
        web_pages: ['http://www.nyu.edu/'],
        alpha_two_code: 'US',
        name: 'New York University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['newberry.edu'],
        web_pages: ['http://www.newberry.edu/'],
        alpha_two_code: 'US',
        name: 'Newberry College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nhti.edu'],
        web_pages: ['http://www.nhti.edu'],
        alpha_two_code: 'US',
        name: "NHTI-​Concord's Community College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['niagaracc.suny.edu'],
        web_pages: ['http://www.niagaracc.suny.edu'],
        alpha_two_code: 'US',
        name: 'Niagara County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['niagara.edu'],
        web_pages: ['http://www.niagara.edu/'],
        alpha_two_code: 'US',
        name: 'Niagara University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nicholls.edu'],
        web_pages: ['http://www.nicholls.edu/'],
        alpha_two_code: 'US',
        name: 'Nicholls State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nicoletcollege.edu'],
        web_pages: ['http://www.nicoletcollege.edu'],
        alpha_two_code: 'US',
        name: 'Nicolet Area Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rcc.edu'],
        web_pages: ['http://www.rcc.edu/norco/index.cfm'],
        alpha_two_code: 'US',
        name: 'Norco College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nsu.edu'],
        web_pages: ['http://www.nsu.edu/'],
        alpha_two_code: 'US',
        name: 'Norfolk State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['normandale.edu'],
        web_pages: ['http://www.normandale.edu'],
        alpha_two_code: 'US',
        name: 'Normandale Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['na.edu'],
        web_pages: ['http://www.na.edu/'],
        alpha_two_code: 'US',
        name: 'North American University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northark.edu'],
        web_pages: ['http://www.northark.edu'],
        alpha_two_code: 'US',
        name: 'North Arkansas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncat.edu'],
        web_pages: ['http://www.ncat.edu/'],
        alpha_two_code: 'US',
        name: 'North Carolina A&T State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nccu.edu'],
        web_pages: ['http://www.nccu.edu/'],
        alpha_two_code: 'US',
        name: 'North Carolina Central University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncsu.edu'],
        web_pages: ['http://www.ncsu.edu/'],
        alpha_two_code: 'US',
        name: 'North Carolina State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncwc.edu'],
        web_pages: ['http://www.ncwc.edu/'],
        alpha_two_code: 'US',
        name: 'North Carolina Wesleyan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncbc.edu'],
        web_pages: ['http://www.ncbc.edu/'],
        alpha_two_code: 'US',
        name: 'North Central Bible College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncktc.edu'],
        web_pages: ['http://www.ncktc.edu'],
        alpha_two_code: 'US',
        name: 'North Central Kansas Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncmich.edu'],
        web_pages: ['http://www.ncmich.edu'],
        alpha_two_code: 'US',
        name: 'North Central Michigan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncmissouri.edu'],
        web_pages: ['http://www.ncmissouri.edu'],
        alpha_two_code: 'US',
        name: 'North Central Missouri College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ncstatecollege.edu'],
        web_pages: ['http://www.ncstatecollege.edu'],
        alpha_two_code: 'US',
        name: 'North Central State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nctc.edu'],
        web_pages: ['http://www.nctc.edu'],
        alpha_two_code: 'US',
        name: 'North Central Texas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nccc.edu'],
        web_pages: ['http://www.nccc.edu'],
        alpha_two_code: 'US',
        name: 'North Country Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ndscs.edu'],
        web_pages: ['http://www.ndscs.edu'],
        alpha_two_code: 'US',
        name: 'North Dakota State College of Science',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ndsu.edu'],
        web_pages: ['http://www.ndsu.edu/'],
        alpha_two_code: 'US',
        name: 'North Dakota State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ndus.edu'],
        web_pages: ['http://www.ndus.edu/'],
        alpha_two_code: 'US',
        name: 'North Dakota University System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nfcc.edu'],
        web_pages: ['http://www.nfcc.edu'],
        alpha_two_code: 'US',
        name: 'North Florida Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northgatech.edu'],
        web_pages: ['http://www.northgatech.edu'],
        alpha_two_code: 'US',
        name: 'North Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nhcc.edu'],
        web_pages: ['http://www.nhcc.edu'],
        alpha_two_code: 'US',
        name: 'North Hennepin Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nic.edu'],
        web_pages: ['http://www.nic.edu/'],
        alpha_two_code: 'US',
        name: 'North Idaho College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['niacc.edu'],
        web_pages: ['http://www.niacc.edu'],
        alpha_two_code: 'US',
        name: 'North Iowa Area Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northlakecollege.edu'],
        web_pages: ['http://www.northlakecollege.edu/Pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'North Lake College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['npcts.edu'],
        web_pages: ['http://www.npcts.edu/'],
        alpha_two_code: 'US',
        name: 'North Park College and Theological Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northshore.edu'],
        web_pages: ['http://www.northshore.edu'],
        alpha_two_code: 'US',
        name: 'North Shore Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northampton.edu'],
        web_pages: ['http://www.northampton.edu/'],
        alpha_two_code: 'US',
        name: 'Northampton Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ntc.edu'],
        web_pages: ['http://www.ntc.edu'],
        alpha_two_code: 'US',
        name: 'Northcentral Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nacc.edu'],
        web_pages: ['http://www.nacc.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Alabama Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northeast.edu'],
        web_pages: ['http://www.northeast.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nicc.edu'],
        web_pages: ['http://www.nicc.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Iowa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nemcc.edu'],
        web_pages: ['http://www.nemcc.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Mississippi Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northeaststate.edu'],
        web_pages: ['http://www.NortheastState.edu'],
        alpha_two_code: 'US',
        name: 'Northeast State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ntcc.edu'],
        web_pages: ['http://www.ntcc.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Texas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwtc.edu'],
        web_pages: ['http://www.nwtc.edu'],
        alpha_two_code: 'US',
        name: 'Northeast Wisconsin Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['njc.edu'],
        web_pages: ['http://www.njc.edu'],
        alpha_two_code: 'US',
        name: 'Northeastern Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nlu.edu'],
        web_pages: ['http://www.nlu.edu/'],
        alpha_two_code: 'US',
        name: 'Northeastern Louisiana University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['neo.edu'],
        web_pages: ['http://www.neo.edu'],
        alpha_two_code: 'US',
        name: 'Northeastern Oklahoma A&M College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nsuok.edu'],
        web_pages: ['http://www.nsuok.edu/'],
        alpha_two_code: 'US',
        name: 'Northeastern State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['netc.edu'],
        web_pages: ['http://www.netc.edu'],
        alpha_two_code: 'US',
        name: 'Northeastern Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['neu.edu', 'northeastern.edu'],
        web_pages: ['http://www.northeastern.edu/'],
        alpha_two_code: 'US',
        name: 'Northeastern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nau.edu'],
        web_pages: ['http://www.nau.edu/'],
        alpha_two_code: 'US',
        name: 'Northern Arizona University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['necc.edu', 'necc.mass.edu'],
        web_pages: ['http://www.necc.mass.edu/'],
        alpha_two_code: 'US',
        name: 'Northern Essex Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['niu.edu'],
        web_pages: ['http://www.niu.edu/'],
        alpha_two_code: 'US',
        name: 'Northern Illinois University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nku.edu'],
        web_pages: ['http://www.nku.edu/'],
        alpha_two_code: 'US',
        name: 'Northern Kentucky University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmcc.edu'],
        web_pages: ['http://www.nmcc.edu'],
        alpha_two_code: 'US',
        name: 'Northern Maine Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nmu.edu'],
        web_pages: ['http://www.nmu.edu/'],
        alpha_two_code: 'US',
        name: 'Northern Michigan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['noc.edu'],
        web_pages: ['http://www.noc.edu'],
        alpha_two_code: 'US',
        name: 'Northern Oklahoma College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northern.edu'],
        web_pages: ['http://www.northern.edu/'],
        alpha_two_code: 'US',
        name: 'Northern State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nvcc.edu'],
        web_pages: ['http://www.nvcc.edu'],
        alpha_two_code: 'US',
        name: 'Northern Virginia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northland.edu'],
        web_pages: ['http://www.northland.edu/'],
        alpha_two_code: 'US',
        name: 'Northland College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northlandcollege.edu'],
        web_pages: ['http://www.northlandcollege.edu'],
        alpha_two_code: 'US',
        name: 'Northland Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['npc.edu'],
        web_pages: ['http://www.npc.edu'],
        alpha_two_code: 'US',
        name: 'Northland Pioneer College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwacc.edu'],
        web_pages: ['http://www.nwacc.edu'],
        alpha_two_code: 'US',
        name: 'NorthWest Arkansas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northwestcollege.edu'],
        web_pages: ['http://www.northwestcollege.edu'],
        alpha_two_code: 'US',
        name: 'Northwest College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwfsc.edu'],
        web_pages: ['http://www.nwfsc.edu/'],
        alpha_two_code: 'US',
        name: 'Northwest Florida State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwicc.edu'],
        web_pages: ['http://www.nwicc.edu'],
        alpha_two_code: 'US',
        name: 'Northwest Iowa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwktc.edu'],
        web_pages: ['http://www.nwktc.edu'],
        alpha_two_code: 'US',
        name: 'Northwest Kansas Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northwestms.edu'],
        web_pages: ['http://www.northwestms.edu'],
        alpha_two_code: 'US',
        name: 'Northwest Mississippi Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwmissouri.edu'],
        web_pages: ['http://www.nwmissouri.edu/'],
        alpha_two_code: 'US',
        name: 'Northwest Missouri State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nnc.edu'],
        web_pages: ['http://www.nnc.edu/'],
        alpha_two_code: 'US',
        name: 'Northwest Nazarene College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northweststate.edu'],
        web_pages: ['http://www.northweststate.edu'],
        alpha_two_code: 'US',
        name: 'Northwest State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ntcmn.edu'],
        web_pages: ['http://www.ntcmn.edu'],
        alpha_two_code: 'US',
        name: 'Northwest Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alamo.edu'],
        web_pages: ['http://www.alamo.edu/nvc/'],
        alpha_two_code: 'US',
        name: 'Northwest Vista College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwscc.edu'],
        web_pages: ['http://www.nwscc.edu'],
        alpha_two_code: 'US',
        name: 'Northwest-​Shoals Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwciowa.edu'],
        web_pages: ['http://www.nwciowa.edu/'],
        alpha_two_code: 'US',
        name: 'Northwestern College of Iowa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northwesterncollege.edu'],
        web_pages: ['http://www.NorthwesternCollege.edu'],
        alpha_two_code: 'US',
        name: 'Northwestern College-​Chicago Campus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nwcc.commnet.edu'],
        web_pages: ['http://www.nwcc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Northwestern Connecticut Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nsula.edu'],
        web_pages: ['http://www.nsula.edu/'],
        alpha_two_code: 'US',
        name: 'Northwestern State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northwestern.edu'],
        web_pages: ['http://www.northwestern.edu/'],
        alpha_two_code: 'US',
        name: 'Northwestern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['northwood.edu'],
        web_pages: ['https://northwood.edu/'],
        alpha_two_code: 'US',
        name: 'Northwood University',
        'state-province': 'Michigan',
    },
    {
        country: 'United States',
        domains: ['ncc.commnet.edu'],
        web_pages: ['http://www.ncc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Norwalk Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['norwich.edu'],
        web_pages: ['http://www.norwich.edu/'],
        alpha_two_code: 'US',
        name: 'Norwich University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nova.edu'],
        web_pages: ['http://www.nova.edu/'],
        alpha_two_code: 'US',
        name: 'Nova Southeastern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nunez.edu'],
        web_pages: ['http://www.nunez.edu'],
        alpha_two_code: 'US',
        name: 'Nunez Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oaklandcc.edu'],
        web_pages: ['http://www.oaklandcc.edu'],
        alpha_two_code: 'US',
        name: 'Oakland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oakland.edu'],
        web_pages: ['http://www.oakland.edu/'],
        alpha_two_code: 'US',
        name: 'Oakland University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oakton.edu'],
        web_pages: ['http://www.oakton.edu'],
        alpha_two_code: 'US',
        name: 'Oakton Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oakwood.edu'],
        web_pages: ['http://www.oakwood.edu/'],
        alpha_two_code: 'US',
        name: 'Oakwood University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oberlin.edu'],
        web_pages: ['http://www.oberlin.edu/'],
        alpha_two_code: 'US',
        name: 'Oberlin College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oxy.edu'],
        web_pages: ['http://www.oxy.edu/'],
        alpha_two_code: 'US',
        name: 'Occidental College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ocean.edu'],
        web_pages: ['http://www.ocean.edu/'],
        alpha_two_code: 'US',
        name: 'Ocean County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['odessa.edu'],
        web_pages: ['http://www.odessa.edu'],
        alpha_two_code: 'US',
        name: 'Odessa College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ogeecheetech.edu'],
        web_pages: ['http://www.ogeecheetech.edu'],
        alpha_two_code: 'US',
        name: 'Ogeechee Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['odc.edu'],
        web_pages: ['http://www.odc.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio Dominican College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['onu.edu'],
        web_pages: ['http://www.onu.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio Northern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ati.osu.edu'],
        web_pages: ['http://www.ati.osu.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio State University Agricultural Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['osu.edu'],
        web_pages: ['http://www.osu.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio State University, Columbus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ohio.edu'],
        web_pages: ['http://www.ohio.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['owu.edu'],
        web_pages: ['http://www.owu.edu/'],
        alpha_two_code: 'US',
        name: 'Ohio Wesleyan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ohlone.edu'],
        web_pages: ['http://www.ohlone.edu'],
        alpha_two_code: 'US',
        name: 'Ohlone College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['coastalpines.edu'],
        web_pages: ['http://www.coastalpines.edu/'],
        alpha_two_code: 'US',
        name: 'Okefenokee Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['okbu.edu'],
        web_pages: ['http://www.okbu.edu/'],
        alpha_two_code: 'US',
        name: 'Oklahoma Baptist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oc.edu'],
        web_pages: ['http://www.oc.edu/'],
        alpha_two_code: 'US',
        name: 'Oklahoma Christian University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['occc.edu'],
        web_pages: ['http://www.occc.edu'],
        alpha_two_code: 'US',
        name: 'Oklahoma City Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['okcu.edu'],
        web_pages: ['http://www.okcu.edu/'],
        alpha_two_code: 'US',
        name: 'Oklahoma City University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['okstate.edu'],
        web_pages: ['http://www.okstate.edu/'],
        alpha_two_code: 'US',
        name: 'Oklahoma State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['odu.edu'],
        web_pages: ['http://www.odu.edu/'],
        alpha_two_code: 'US',
        name: 'Old Dominion University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['olivet.edu'],
        web_pages: ['http://www.olivet.edu/'],
        alpha_two_code: 'US',
        name: 'Olivet Nazarene University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyocc.edu'],
        web_pages: ['http://www.sunyocc.edu'],
        alpha_two_code: 'US',
        name: 'Onondaga Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oru.edu'],
        web_pages: ['http://www.oru.edu/'],
        alpha_two_code: 'US',
        name: 'Oral Roberts University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['orangecoastcollege.edu'],
        web_pages: ['http://www.orangecoastcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Orange Coast College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyorange.edu'],
        web_pages: ['http://www.sunyorange.edu/'],
        alpha_two_code: 'US',
        name: 'Orange County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['octech.edu'],
        web_pages: ['http://www.octech.edu'],
        alpha_two_code: 'US',
        name: 'Orangeburg Calhoun Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ogi.edu'],
        web_pages: ['http://www.ogi.edu/'],
        alpha_two_code: 'US',
        name: 'Oregon Graduate Institute of Science and Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ohsu.edu'],
        web_pages: ['http://www.ohsu.edu/'],
        alpha_two_code: 'US',
        name: 'Oregon Health Sciences University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oit.edu'],
        web_pages: ['http://www.oit.edu/'],
        alpha_two_code: 'US',
        name: 'Oregon Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oregonstate.edu'],
        web_pages: ['http://www.oregonstate.edu/'],
        alpha_two_code: 'US',
        name: 'Oregon State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.ojc.edu'],
        web_pages: ['http://WWW.OJC.EDU'],
        alpha_two_code: 'US',
        name: 'Otero Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['otterbein.edu'],
        web_pages: ['http://www.otterbein.edu/'],
        alpha_two_code: 'US',
        name: 'Otterbein College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ollusa.edu'],
        web_pages: ['http://www.ollusa.edu/'],
        alpha_two_code: 'US',
        name: 'Our Lady of the Lake University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['owens.edu'],
        web_pages: ['https://www.owens.edu'],
        alpha_two_code: 'US',
        name: 'Owens Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['owensboro.kctcs.edu'],
        web_pages: ['http://www.owensboro.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Owensboro Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oxnardcollege.edu'],
        web_pages: ['http://www.oxnardcollege.edu'],
        alpha_two_code: 'US',
        name: 'Oxnard College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ozarka.edu'],
        web_pages: ['http://www.ozarka.edu'],
        alpha_two_code: 'US',
        name: 'Ozarka College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['otc.edu'],
        web_pages: ['http://www.otc.edu'],
        alpha_two_code: 'US',
        name: 'Ozarks Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pace.edu'],
        web_pages: ['http://www.pace.edu/'],
        alpha_two_code: 'US',
        name: 'Pace University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['plu.edu'],
        web_pages: ['http://www.plu.edu/'],
        alpha_two_code: 'US',
        name: 'Pacific Lutheran University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['puc.edu'],
        web_pages: ['http://www.puc.edu/'],
        alpha_two_code: 'US',
        name: 'Pacific Union College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pacificu.edu'],
        web_pages: ['http://www.pacificu.edu/'],
        alpha_two_code: 'US',
        name: 'Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pwu.com'],
        web_pages: ['http://www.pwu.com/'],
        alpha_two_code: 'US',
        name: 'Pacific Western University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pbac.edu'],
        web_pages: ['http://www.pbac.edu/'],
        alpha_two_code: 'US',
        name: 'Palm Beach Atlantic College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['palmbeachstate.edu'],
        web_pages: ['http://www.palmbeachstate.edu/'],
        alpha_two_code: 'US',
        name: 'Palm Beach State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alamo.edu'],
        web_pages: ['http://www.alamo.edu/pac/'],
        alpha_two_code: 'US',
        name: 'Palo Alto College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['paloverde.edu'],
        web_pages: ['http://www.paloverde.edu'],
        alpha_two_code: 'US',
        name: 'Palo Verde College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['palomar.edu'],
        web_pages: ['http://www.palomar.edu'],
        alpha_two_code: 'US',
        name: 'Palomar College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pamlicocc.edu'],
        web_pages: ['http://www.pamlicocc.edu'],
        alpha_two_code: 'US',
        name: 'Pamlico Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['panola.edu'],
        web_pages: ['http://www.panola.edu'],
        alpha_two_code: 'US',
        name: 'Panola College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pvc.maricopa.edu'],
        web_pages: ['http://www.pvc.maricopa.edu'],
        alpha_two_code: 'US',
        name: 'Paradise Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['parisjc.edu'],
        web_pages: ['http://www.parisjc.edu/'],
        alpha_two_code: 'US',
        name: 'Paris Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['park.edu'],
        web_pages: ['https://park.edu/'],
        alpha_two_code: 'US',
        name: 'Park University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['parkland.edu'],
        web_pages: ['http://www.parkland.edu'],
        alpha_two_code: 'US',
        name: 'Parkland College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pasadena.edu'],
        web_pages: ['http://www.pasadena.edu'],
        alpha_two_code: 'US',
        name: 'Pasadena City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['phcc.edu'],
        web_pages: ['http://www.phcc.edu'],
        alpha_two_code: 'US',
        name: 'Pasco-​Hernando Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['phsc.edu'],
        web_pages: ['http://www.phsc.edu/'],
        alpha_two_code: 'US',
        name: 'Pasco-Hernando State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pccc.edu'],
        web_pages: ['http://www.pccc.edu'],
        alpha_two_code: 'US',
        name: 'Passaic County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['patrickhenry.edu'],
        web_pages: ['http://www.patrickhenry.edu'],
        alpha_two_code: 'US',
        name: 'Patrick Henry Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pdc.edu'],
        web_pages: ['http://www.pdc.edu/'],
        alpha_two_code: 'US',
        name: 'Paul D Camp Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['peace.edu'],
        web_pages: ['http://www.peace.edu/'],
        alpha_two_code: 'US',
        name: 'Peace College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['prcc.edu'],
        web_pages: ['http://www.prcc.edu'],
        alpha_two_code: 'US',
        name: 'Pearl River Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pstcc.edu'],
        web_pages: ['http://www.pstcc.edu/'],
        alpha_two_code: 'US',
        name: 'Pellissippi State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pembroke.edu'],
        web_pages: ['http://www.pembroke.edu/'],
        alpha_two_code: 'US',
        name: 'Pembroke State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pct.edu'],
        web_pages: ['http://www.pct.edu/'],
        alpha_two_code: 'US',
        name: 'Pennsylvania College of Technology',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['pennhighlands.edu'],
        web_pages: ['http://www.pennhighlands.edu'],
        alpha_two_code: 'US',
        name: 'Pennsylvania Highlands Community College',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['pit.edu'],
        web_pages: ['http://www.pit.edu'],
        alpha_two_code: 'US',
        name: 'Pennsylvania Institute of Technology',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['psu.edu'],
        web_pages: ['http://www.psu.edu/'],
        alpha_two_code: 'US',
        name: 'Pennsylvania State University',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['sl.psu.edu'],
        web_pages: ['http://www.sl.psu.edu/'],
        alpha_two_code: 'US',
        name: 'Pennsylvania State University - Schuylkill Campus',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['pcci.edu'],
        web_pages: ['http://www.pcci.edu/'],
        alpha_two_code: 'US',
        name: 'Pensacola Christian College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pensacolastate.edu'],
        web_pages: ['http://www.pensacolastate.edu/'],
        alpha_two_code: 'US',
        name: 'Pensacola State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pepperdine.edu'],
        web_pages: ['http://www.pepperdine.edu/'],
        alpha_two_code: 'US',
        name: 'Pepperdine University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['peru.edu'],
        web_pages: ['http://www.peru.edu/'],
        alpha_two_code: 'US',
        name: 'Peru State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pcom.edu'],
        web_pages: ['https://www.pcom.edu/'],
        alpha_two_code: 'US',
        name: 'Philadelphia College of Osteopathic Medicine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['philau.edu'],
        web_pages: ['http://www.philau.edu/'],
        alpha_two_code: 'US',
        name: 'Philadelphia University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pccua.edu'],
        web_pages: ['http://www.pccua.edu'],
        alpha_two_code: 'US',
        name: 'Phillips Community College of the University of Arkansas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['phillips.edu'],
        web_pages: ['http://www.phillips.edu/'],
        alpha_two_code: 'US',
        name: 'Phillips University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['phoenixcollege.edu'],
        web_pages: ['http://www.phoenixcollege.edu'],
        alpha_two_code: 'US',
        name: 'Phoenix College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['piedmontcc.edu'],
        web_pages: ['http://www.piedmontcc.edu'],
        alpha_two_code: 'US',
        name: 'Piedmont Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ptc.edu'],
        web_pages: ['http://www.ptc.edu'],
        alpha_two_code: 'US',
        name: 'Piedmont Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pvcc.edu'],
        web_pages: ['http://www.pvcc.edu'],
        alpha_two_code: 'US',
        name: 'Piedmont Virginia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pierce.ctc.edu'],
        web_pages: ['http://www.pierce.ctc.edu/'],
        alpha_two_code: 'US',
        name: 'Pierce College at Puyallup',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pierpont.edu'],
        web_pages: ['http://www.pierpont.edu/'],
        alpha_two_code: 'US',
        name: 'Pierpont Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ppcc.edu'],
        web_pages: ['http://www.ppcc.edu'],
        alpha_two_code: 'US',
        name: 'Pikes Peak Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pima.edu'],
        web_pages: ['http://www.pima.edu'],
        alpha_two_code: 'US',
        name: 'Pima Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pinetech.edu'],
        web_pages: ['http://www.pinetech.edu'],
        alpha_two_code: 'US',
        name: 'Pine Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pittcc.edu'],
        web_pages: ['http://www.pittcc.edu'],
        alpha_two_code: 'US',
        name: 'Pitt Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pittstate.edu'],
        web_pages: ['http://www.pittstate.edu/'],
        alpha_two_code: 'US',
        name: 'Pittsburg State University',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['pti.edu'],
        web_pages: ['http://www.pti.edu'],
        alpha_two_code: 'US',
        name: 'Pittsburgh Technical Institute',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['pitzer.edu'],
        web_pages: ['http://www.pitzer.edu/'],
        alpha_two_code: 'US',
        name: 'Pitzer College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['platt.edu'],
        web_pages: ['http://www.platt.edu/'],
        alpha_two_code: 'US',
        name: 'Platt College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['plymouth.edu'],
        web_pages: ['http://www.plymouth.edu/'],
        alpha_two_code: 'US',
        name: 'Plymouth State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pointpark.edu'],
        web_pages: ['https://pointpark.edu/'],
        alpha_two_code: 'US',
        name: 'Point Park University',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['polk.edu'],
        web_pages: ['https://www.polk.edu/'],
        alpha_two_code: 'US',
        name: 'Polk State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['poly.edu'],
        web_pages: ['http://www.poly.edu/'],
        alpha_two_code: 'US',
        name: 'Polytechnic University of New York',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pupr.edu'],
        web_pages: ['http://www.pupr.edu/'],
        alpha_two_code: 'US',
        name: 'Polytechnic University of Puerto Rico',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pomona.edu'],
        web_pages: ['http://www.pomona.edu/'],
        alpha_two_code: 'US',
        name: 'Pomona College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['portervillecollege.edu'],
        web_pages: ['http://www.portervillecollege.edu'],
        alpha_two_code: 'US',
        name: 'Porterville College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pcc.edu'],
        web_pages: ['http://www.pcc.edu/'],
        alpha_two_code: 'US',
        name: 'Portland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pdx.edu'],
        web_pages: ['http://www.ee.pdx.edu/'],
        alpha_two_code: 'US',
        name: 'Portland State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['prairiestate.edu'],
        web_pages: ['http://www.prairiestate.edu'],
        alpha_two_code: 'US',
        name: 'Prairie State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pvamu.edu'],
        web_pages: ['http://www.pvamu.edu/'],
        alpha_two_code: 'US',
        name: 'Prairie View A&M University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['prattcc.edu'],
        web_pages: ['http://www.prattcc.edu'],
        alpha_two_code: 'US',
        name: 'Pratt Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pratt.edu'],
        web_pages: ['http://www.pratt.edu/'],
        alpha_two_code: 'US',
        name: 'Pratt Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['presby.edu'],
        web_pages: ['http://www.presby.edu/'],
        alpha_two_code: 'US',
        name: 'Presbyterian College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['prescott.edu'],
        web_pages: ['http://www.prescott.edu/'],
        alpha_two_code: 'US',
        name: 'Prescott College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pgcc.edu'],
        web_pages: ['http://www.pgcc.edu'],
        alpha_two_code: 'US',
        name: "Prince George's Community College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pwsc.alaska.edu'],
        web_pages: ['http://pwsc.alaska.edu'],
        alpha_two_code: 'US',
        name: 'Prince William Sound College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['princeton.edu'],
        web_pages: ['http://www.princeton.edu/'],
        alpha_two_code: 'US',
        name: 'Princeton University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['providence.edu'],
        web_pages: ['http://www.providence.edu/'],
        alpha_two_code: 'US',
        name: 'Providence College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pueblocc.edu'],
        web_pages: ['http://www.pueblocc.edu'],
        alpha_two_code: 'US',
        name: 'Pueblo Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pulaskitech.edu'],
        web_pages: ['http://www.pulaskitech.edu'],
        alpha_two_code: 'US',
        name: 'Pulaski Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['purdue.edu'],
        web_pages: ['http://www.purdue.edu/'],
        alpha_two_code: 'US',
        name: 'Purdue University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['purduecal.edu'],
        web_pages: ['http://webs.purduecal.edu/'],
        alpha_two_code: 'US',
        name: 'Purdue University Calumet',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pfw.edu'],
        web_pages: ['https://www.pdfw.edu/'],
        alpha_two_code: 'US',
        name: 'Purdue University Fort Wayne',
        'state-province': 'IN',
    },
    {
        country: 'United States',
        domains: ['pnc.edu'],
        web_pages: ['http://www.pnc.edu/'],
        alpha_two_code: 'US',
        name: 'Purdue University North Central',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pnw.edu'],
        web_pages: ['https://www.pnw.edu/'],
        alpha_two_code: 'US',
        name: 'Purdue University Northwest',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['quincycollege.edu'],
        web_pages: ['http://www.quincycollege.edu'],
        alpha_two_code: 'US',
        name: 'Quincy College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['quincy.edu'],
        web_pages: ['http://www.quincy.edu/'],
        alpha_two_code: 'US',
        name: 'Quincy University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['qvcc.edu'],
        web_pages: ['http://www.qvcc.edu'],
        alpha_two_code: 'US',
        name: 'Quinebaug Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['quinnipiac.edu'],
        web_pages: ['http://www.quinnipiac.edu/'],
        alpha_two_code: 'US',
        name: 'Quinnipiac College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['qcc.edu'],
        web_pages: ['http://www.qcc.edu'],
        alpha_two_code: 'US',
        name: 'Quinsigamond Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['radford.edu'],
        web_pages: ['http://www.radford.edu/'],
        alpha_two_code: 'US',
        name: 'Radford University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rrcc.mnscu.edu'],
        web_pages: ['http://www.rrcc.mnscu.edu'],
        alpha_two_code: 'US',
        name: 'Rainy River Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ramapo.edu'],
        web_pages: ['http://www.ramapo.edu/'],
        alpha_two_code: 'US',
        name: 'Ramapo College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['randolph.edu'],
        web_pages: ['http://www.randolph.edu'],
        alpha_two_code: 'US',
        name: 'Randolph Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rmc.edu'],
        web_pages: ['http://www.rmc.edu/'],
        alpha_two_code: 'US',
        name: 'Randolph-Macon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rmwc.edu'],
        web_pages: ['http://www.rmwc.edu/'],
        alpha_two_code: 'US',
        name: "Randolph-Macon Woman's College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rangercollege.edu'],
        web_pages: ['http://www.rangercollege.edu'],
        alpha_two_code: 'US',
        name: 'Ranger College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rappahannock.edu'],
        web_pages: ['http://www.rappahannock.edu/'],
        alpha_two_code: 'US',
        name: 'Rappahannock Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['raritanval.edu'],
        web_pages: ['http://www.raritanval.edu'],
        alpha_two_code: 'US',
        name: 'Raritan Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['racc.edu'],
        web_pages: ['http://www.racc.edu'],
        alpha_two_code: 'US',
        name: 'Reading Area Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rrcc.edu'],
        web_pages: ['http://www.rrcc.edu'],
        alpha_two_code: 'US',
        name: 'Red Rocks Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['redlandscc.edu'],
        web_pages: ['http://www.redlandscc.edu'],
        alpha_two_code: 'US',
        name: 'Redlands Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['reed.edu'],
        web_pages: ['http://www.reed.edu/'],
        alpha_two_code: 'US',
        name: 'Reed College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['reedleycollege.edu'],
        web_pages: ['http://www.reedleycollege.edu'],
        alpha_two_code: 'US',
        name: 'Reedley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['regent.edu'],
        web_pages: ['http://www.regent.edu/'],
        alpha_two_code: 'US',
        name: 'Regent University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['regis.edu'],
        web_pages: ['http://www.regis.edu/'],
        alpha_two_code: 'US',
        name: 'Regis University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rlc.edu'],
        web_pages: ['http://www.rlc.edu'],
        alpha_two_code: 'US',
        name: 'Rend Lake College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rpi.edu'],
        web_pages: ['http://www.rpi.edu/'],
        alpha_two_code: 'US',
        name: 'Rensselaer Polytechnic Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rtc.edu'],
        web_pages: ['http://www.rtc.edu'],
        alpha_two_code: 'US',
        name: 'Renton Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ric.edu'],
        web_pages: ['http://www.ric.edu/'],
        alpha_two_code: 'US',
        name: 'Rhode Island College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rhodes.edu'],
        web_pages: ['http://www.rhodes.edu/'],
        alpha_two_code: 'US',
        name: 'Rhodes College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rice.edu'],
        web_pages: ['http://www.rice.edu/'],
        alpha_two_code: 'US',
        name: 'Rice University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rmcc.edu'],
        web_pages: ['http://www.rmcc.edu'],
        alpha_two_code: 'US',
        name: 'Rich Mountain Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rbc.edu'],
        web_pages: ['http://www.rbc.edu'],
        alpha_two_code: 'US',
        name: 'Richard Bland College of the College of William and Mary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stockton.edu'],
        web_pages: ['http://www.stockton.edu/'],
        alpha_two_code: 'US',
        name: 'Richard Stockton College of New Jersey',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['richlandcollege.edu'],
        web_pages: ['http://www.richlandcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Richland College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['richland.edu'],
        web_pages: ['http://www.richland.edu'],
        alpha_two_code: 'US',
        name: 'Richland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['richmondcc.edu'],
        web_pages: ['http://www.richmondcc.edu'],
        alpha_two_code: 'US',
        name: 'Richmond Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rider.edu'],
        web_pages: ['http://www.rider.edu/'],
        alpha_two_code: 'US',
        name: 'Rider University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ridgewater.edu'],
        web_pages: ['http://www.ridgewater.edu/Pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'Ridgewater College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['riohondo.edu'],
        web_pages: ['http://www.riohondo.edu'],
        alpha_two_code: 'US',
        name: 'Rio Hondo College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rio.maricopa.edu'],
        web_pages: ['http://www.rio.maricopa.edu'],
        alpha_two_code: 'US',
        name: 'Rio Salado College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ripon.edu'],
        web_pages: ['http://www.ripon.edu/'],
        alpha_two_code: 'US',
        name: 'Ripon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rpcc.edu'],
        web_pages: ['http://www.rpcc.edu'],
        alpha_two_code: 'US',
        name: 'River Parishes Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rivervalley.edu'],
        web_pages: ['http://www.rivervalley.edu'],
        alpha_two_code: 'US',
        name: 'River Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['riverland.edu'],
        web_pages: ['http://www.riverland.edu'],
        alpha_two_code: 'US',
        name: 'Riverland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rcc.edu'],
        web_pages: ['http://www.rcc.edu/riverside/'],
        alpha_two_code: 'US',
        name: 'Riverside City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rccd.edu'],
        web_pages: ['http://www.rccd.edu/'],
        alpha_two_code: 'US',
        name: 'Riverside Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['riv.edu'],
        web_pages: ['http://www.riv.edu/'],
        alpha_two_code: 'US',
        name: 'Rivier College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roanestate.edu'],
        web_pages: ['http://www.roanestate.edu'],
        alpha_two_code: 'US',
        name: 'Roane State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roanoke.edu'],
        web_pages: ['http://www.roanoke.edu/'],
        alpha_two_code: 'US',
        name: 'Roanoke College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roanokechowan.edu'],
        web_pages: ['http://www.roanokechowan.edu'],
        alpha_two_code: 'US',
        name: 'Roanoke-​Chowan Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rmu.edu'],
        web_pages: ['http://www.rmu.edu/'],
        alpha_two_code: 'US',
        name: 'Robert Morris University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['robertmorris.edu'],
        web_pages: ['http://www.robertmorris.edu/'],
        alpha_two_code: 'US',
        name: 'Robert Morris University Illinois',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['robeson.edu'],
        web_pages: ['http://www.robeson.edu'],
        alpha_two_code: 'US',
        name: 'Robeson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rctc.edu'],
        web_pages: ['http://www.rctc.edu/'],
        alpha_two_code: 'US',
        name: 'Rochester Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rit.edu'],
        web_pages: ['http://www.rit.edu/'],
        alpha_two_code: 'US',
        name: 'Rochester Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rockvalleycollege.edu'],
        web_pages: ['http://www.rockvalleycollege.edu'],
        alpha_two_code: 'US',
        name: 'Rock Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rockefeller.edu'],
        web_pages: ['http://www.rockefeller.edu/'],
        alpha_two_code: 'US',
        name: 'Rockefeller University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rockford.edu'],
        web_pages: ['http://www.rockford.edu/'],
        alpha_two_code: 'US',
        name: 'Rockford College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rockhurst.edu'],
        web_pages: ['http://www.rockhurst.edu/'],
        alpha_two_code: 'US',
        name: 'Rockhurst College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rockinghamcc.edu'],
        web_pages: ['http://www.rockinghamcc.edu'],
        alpha_two_code: 'US',
        name: 'Rockingham Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyrockland.edu'],
        web_pages: ['http://www.sunyrockland.edu/'],
        alpha_two_code: 'US',
        name: 'Rockland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rocky.edu'],
        web_pages: ['http://www.rocky.edu/'],
        alpha_two_code: 'US',
        name: 'Rocky Mountain College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rwu.edu'],
        web_pages: ['http://www.rwu.edu/'],
        alpha_two_code: 'US',
        name: 'Roger Williams University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rsu.edu'],
        web_pages: ['https://www.rsu.edu/'],
        alpha_two_code: 'US',
        name: 'Rogers State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roguecc.edu'],
        web_pages: ['http://www.roguecc.edu'],
        alpha_two_code: 'US',
        name: 'Rogue Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rollins.edu'],
        web_pages: ['http://www.rollins.edu/'],
        alpha_two_code: 'US',
        name: 'Rollins College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['roosevelt.edu'],
        web_pages: ['https://www.roosevelt.edu/'],
        alpha_two_code: 'US',
        name: 'Roosevelt University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rosary.edu'],
        web_pages: ['http://www.rosary.edu/'],
        alpha_two_code: 'US',
        name: 'Rosary College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rose.edu'],
        web_pages: ['http://www.rose.edu'],
        alpha_two_code: 'US',
        name: 'Rose State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rose-hulman.edu'],
        web_pages: ['http://www.rose-hulman.edu/'],
        alpha_two_code: 'US',
        name: 'Rose-Hulman Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rowan.edu'],
        web_pages: ['http://www.rowan.edu/'],
        alpha_two_code: 'US',
        name: 'Rowan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rccc.edu'],
        web_pages: ['http://www.rccc.edu/'],
        alpha_two_code: 'US',
        name: 'Rowan-​Cabarrus Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rcc.mass.edu'],
        web_pages: ['http://www.rcc.mass.edu'],
        alpha_two_code: 'US',
        name: 'Roxbury Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rutgers.edu'],
        web_pages: ['http://www.rutgers.edu/'],
        alpha_two_code: 'US',
        name: 'Rutgers University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rutgers.edu'],
        web_pages: ['http://www.camden.rutgers.edu/'],
        alpha_two_code: 'US',
        name: 'Rutgers University, Camden',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rutgers.edu'],
        web_pages: ['http://www.newark.rutgers.edu/'],
        alpha_two_code: 'US',
        name: 'Rutgers University, Newark',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scc.losrios.edu'],
        web_pages: ['http://www.scc.losrios.edu/'],
        alpha_two_code: 'US',
        name: 'Sacramento City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sacredheart.edu'],
        web_pages: ['http://www.sacredheart.edu/'],
        alpha_two_code: 'US',
        name: 'Sacred Heart University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saddleback.edu'],
        web_pages: ['http://www.saddleback.edu'],
        alpha_two_code: 'US',
        name: 'Saddleback College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sage.edu'],
        web_pages: ['http://www.sage.edu/'],
        alpha_two_code: 'US',
        name: 'Sage Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sagchip.edu'],
        web_pages: ['http://www.sagchip.edu'],
        alpha_two_code: 'US',
        name: 'Saginaw Chippewa Tribal College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['svsu.edu'],
        web_pages: ['http://www.svsu.edu/'],
        alpha_two_code: 'US',
        name: 'Saginaw Valley State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['anselm.edu'],
        web_pages: ['http://www.anselm.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Anselm College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stcloudstate.edu'],
        web_pages: ['http://www.stcloudstate.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Cloud State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stedwards.edu'],
        web_pages: ['http://www.stedwards.edu/'],
        alpha_two_code: 'US',
        name: "Saint Edward's University",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['secon.edu'],
        web_pages: ['http://www.secon.edu'],
        alpha_two_code: 'US',
        name: 'Saint Elizabeth College of Nursing',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sfcpa.edu'],
        web_pages: ['http://www.sfcpa.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Francis College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['csbsju.edu'],
        web_pages: ['http://www.csbsju.edu/'],
        alpha_two_code: 'US',
        name: "Saint John's University (MN)",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stjohns.edu'],
        web_pages: ['http://www.stjohns.edu/'],
        alpha_two_code: 'US',
        name: "Saint John's University (NY)",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saintjoe.edu'],
        web_pages: ['http://www.saintjoe.edu/'],
        alpha_two_code: 'US',
        name: "Saint Joseph's College (IN)",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sju.edu'],
        web_pages: ['http://www.sju.edu/'],
        alpha_two_code: 'US',
        name: "Saint Joseph's University",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saintleo.edu'],
        web_pages: ['http://www.saintleo.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Leo University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['slu.edu'],
        web_pages: ['http://www.slu.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Louis University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smcks.edu'],
        web_pages: ['http://www.smcks.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Mary College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saintmarys.edu'],
        web_pages: ['http://www.saintmarys.edu/'],
        alpha_two_code: 'US',
        name: "Saint Mary's College (IN)",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stmarys-ca.edu'],
        web_pages: ['http://www.stmarys-ca.edu/'],
        alpha_two_code: 'US',
        name: "Saint Mary's College of California",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smumn.edu'],
        web_pages: ['http://www.smumn.edu/'],
        alpha_two_code: 'US',
        name: "Saint Mary's University of Minnesota",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smcvt.edu'],
        web_pages: ['http://www.smcvt.edu/'],
        alpha_two_code: 'US',
        name: "Saint Michael's College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stolaf.edu'],
        web_pages: ['http://www.stolaf.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Olaf College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saintpaul.edu'],
        web_pages: ['http://www.saintpaul.edu'],
        alpha_two_code: 'US',
        name: 'Saint Paul College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stvincent.edu'],
        web_pages: ['http://www.stvincent.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Vincent College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sxu.edu'],
        web_pages: ['http://www.sxu.edu/'],
        alpha_two_code: 'US',
        name: 'Saint Xavier University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['salemcc.edu'],
        web_pages: ['http://www.salemcc.edu'],
        alpha_two_code: 'US',
        name: 'Salem Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['salisbury.edu'],
        web_pages: ['http://www.salisbury.edu/'],
        alpha_two_code: 'US',
        name: 'Salisbury University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['skc.edu'],
        web_pages: ['http://www.skc.edu/'],
        alpha_two_code: 'US',
        name: 'Salish Kootenai College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['slcc.edu'],
        web_pages: ['http://www.slcc.edu'],
        alpha_two_code: 'US',
        name: 'Salt Lake Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shsu.edu'],
        web_pages: ['http://www.shsu.edu/'],
        alpha_two_code: 'US',
        name: 'Sam Houston State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['samford.edu'],
        web_pages: ['http://www.samford.edu/'],
        alpha_two_code: 'US',
        name: 'Samford University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sampsoncc.edu'],
        web_pages: ['http://www.sampsoncc.edu'],
        alpha_two_code: 'US',
        name: 'Sampson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alamo.edu'],
        web_pages: ['http://www.alamo.edu/sac'],
        alpha_two_code: 'US',
        name: 'San Antonio College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['valleycollege.edu'],
        web_pages: ['http://www.valleycollege.edu'],
        alpha_two_code: 'US',
        name: 'San Bernardino Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdcc.edu'],
        web_pages: ['http://www.sdcc.edu/'],
        alpha_two_code: 'US',
        name: 'San Diego Christian College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdcity.edu'],
        web_pages: ['http://www.sdcity.edu/'],
        alpha_two_code: 'US',
        name: 'San Diego City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdmesa.edu'],
        web_pages: ['http://www.sdmesa.edu/'],
        alpha_two_code: 'US',
        name: 'San Diego Mesa College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdmiramar.edu'],
        web_pages: ['http://www.sdmiramar.edu/'],
        alpha_two_code: 'US',
        name: 'San Diego Miramar College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdsu.edu'],
        web_pages: ['http://www.sdsu.edu/'],
        alpha_two_code: 'US',
        name: 'San Diego State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sfsu.edu'],
        web_pages: ['http://www.sfsu.edu/'],
        alpha_two_code: 'US',
        name: 'San Francisco State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['deltacollege.edu'],
        web_pages: ['http://www.deltacollege.edu'],
        alpha_two_code: 'US',
        name: 'San Joaquin Delta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjvc.edu'],
        web_pages: ['http://www.sjvc.edu'],
        alpha_two_code: 'US',
        name: 'San Joaquin Valley College-​Visalia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjcc.edu'],
        web_pages: ['http://www.sjcc.edu'],
        alpha_two_code: 'US',
        name: 'San Jose City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjsu.edu'],
        web_pages: ['http://www.sjsu.edu/'],
        alpha_two_code: 'US',
        name: 'San Jose State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sanjuancollege.edu'],
        web_pages: ['http://www.sanjuancollege.edu'],
        alpha_two_code: 'US',
        name: 'San Juan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smccd.edu'],
        web_pages: ['https://smccd.edu/'],
        alpha_two_code: 'US',
        name: 'San Mateo County Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sandhills.edu'],
        web_pages: ['http://www.sandhills.edu'],
        alpha_two_code: 'US',
        name: 'Sandhills Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sans.edu'],
        web_pages: ['http://www.sans.edu/'],
        alpha_two_code: 'US',
        name: 'SANS Technology Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sac.edu'],
        web_pages: ['http://www.sac.edu'],
        alpha_two_code: 'US',
        name: 'Santa Ana College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sbcc.edu'],
        web_pages: ['http://www.sbcc.edu'],
        alpha_two_code: 'US',
        name: 'Santa Barbara City College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scu.edu'],
        web_pages: ['http://www.scu.edu/'],
        alpha_two_code: 'US',
        name: 'Santa Clara University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sfcc.edu'],
        web_pages: ['http://www.sfcc.edu'],
        alpha_two_code: 'US',
        name: 'Santa Fe Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smc.edu'],
        web_pages: ['http://www.smc.edu'],
        alpha_two_code: 'US',
        name: 'Santa Monica College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['santarosa.edu'],
        web_pages: ['http://www.santarosa.edu'],
        alpha_two_code: 'US',
        name: 'Santa Rosa Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sccollege.edu'],
        web_pages: ['http://www.sccollege.edu/Pages/default.aspx'],
        alpha_two_code: 'US',
        name: 'Santiago Canyon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['slc.edu'],
        web_pages: ['http://www.slc.edu/'],
        alpha_two_code: 'US',
        name: 'Sarah Lawrence College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['svcc.edu'],
        web_pages: ['http://www.svcc.edu'],
        alpha_two_code: 'US',
        name: 'Sauk Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scad.edu', 'student.scad.edu'],
        web_pages: ['http://www.scad.edu/'],
        alpha_two_code: 'US',
        name: 'Savannah College of Art and Design',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['savannahtech.edu'],
        web_pages: ['http://www.savannahtech.edu'],
        alpha_two_code: 'US',
        name: 'Savannah Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunysccc.edu'],
        web_pages: ['http://www.sunysccc.edu'],
        alpha_two_code: 'US',
        name: 'Schenectady County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['saic.edu'],
        web_pages: ['http://www.saic.edu'],
        alpha_two_code: 'US',
        name: 'School of the Art Institute of Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['schoolcraft.edu'],
        web_pages: ['http://www.schoolcraft.edu'],
        alpha_two_code: 'US',
        name: 'Schoolcraft College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['schreiner.edu'],
        web_pages: ['https://schreiner.edu/'],
        alpha_two_code: 'US',
        name: 'Schreiner University',
        'state-province': 'Texas',
    },
    {
        country: 'United States',
        domains: ['scottsdalecc.edu'],
        web_pages: ['http://www.scottsdalecc.edu'],
        alpha_two_code: 'US',
        name: 'Scottsdale Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['seattlecentral.edu'],
        web_pages: ['http://seattlecentral.edu/'],
        alpha_two_code: 'US',
        name: 'Seattle Central College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['seattlecolleges.edu'],
        web_pages: ['https://www.seattlecolleges.edu/'],
        alpha_two_code: 'US',
        name: 'Seattle Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['spu.edu'],
        web_pages: ['http://www.spu.edu/'],
        alpha_two_code: 'US',
        name: 'Seattle Pacific University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['seattleu.edu'],
        web_pages: ['http://www.seattleu.edu/'],
        alpha_two_code: 'US',
        name: 'Seattle University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sscok.edu'],
        web_pages: ['http://www.sscok.edu'],
        alpha_two_code: 'US',
        name: 'Seminole State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shu.edu'],
        web_pages: ['http://www.shu.edu/'],
        alpha_two_code: 'US',
        name: 'Seton Hall University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sewanee.edu'],
        web_pages: ['http://www.sewanee.edu/'],
        alpha_two_code: 'US',
        name: 'Sewanee, University of the South',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sccc.edu'],
        web_pages: ['http://www.sccc.edu'],
        alpha_two_code: 'US',
        name: 'Seward County Community College and Area Technical School',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shastacollege.edu'],
        web_pages: ['http://www.shastacollege.edu'],
        alpha_two_code: 'US',
        name: 'Shasta College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shawneecc.edu'],
        web_pages: ['http://www.shawneecc.edu'],
        alpha_two_code: 'US',
        name: 'Shawnee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shawnee.edu'],
        web_pages: ['http://www.shawnee.edu/'],
        alpha_two_code: 'US',
        name: 'Shawnee State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sheltonstate.edu'],
        web_pages: ['http://www.sheltonstate.edu'],
        alpha_two_code: 'US',
        name: 'Shelton State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['su.edu'],
        web_pages: ['http://www.su.edu/'],
        alpha_two_code: 'US',
        name: 'Shenandoah University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sheridan.edu'],
        web_pages: ['http://www.sheridan.edu'],
        alpha_two_code: 'US',
        name: 'Sheridan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ship.edu'],
        web_pages: ['http://www.ship.edu/'],
        alpha_two_code: 'US',
        name: 'Shippensburg University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['shoreline.edu'],
        web_pages: ['http://www.shoreline.edu'],
        alpha_two_code: 'US',
        name: 'Shoreline Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shorter.edu'],
        web_pages: ['http://www.shorter.edu/'],
        alpha_two_code: 'US',
        name: 'Shorter College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sierracollege.edu'],
        web_pages: ['http://www.sierracollege.edu'],
        alpha_two_code: 'US',
        name: 'Sierra College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['simmons.edu'],
        web_pages: ['http://www.simmons.edu/'],
        alpha_two_code: 'US',
        name: 'Simmons College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['simons-rock.edu'],
        web_pages: ['http://www.simons-rock.edu/'],
        alpha_two_code: 'US',
        name: "Simon's Rock College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['simpson.edu'],
        web_pages: ['http://www.simpson.edu/'],
        alpha_two_code: 'US',
        name: 'Simpson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sinclair.edu'],
        web_pages: ['http://www.sinclair.edu/'],
        alpha_two_code: 'US',
        name: 'Sinclair Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swc.tc'],
        web_pages: ['http://www.swc.tc'],
        alpha_two_code: 'US',
        name: 'Sisseton Wahpeton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['skagit.edu'],
        web_pages: ['http://www.skagit.edu'],
        alpha_two_code: 'US',
        name: 'Skagit Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['skidmore.edu'],
        web_pages: ['http://www.skidmore.edu/'],
        alpha_two_code: 'US',
        name: 'Skidmore College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['skylinecollege.edu'],
        web_pages: ['http://skylinecollege.edu'],
        alpha_two_code: 'US',
        name: 'Skyline College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sru.edu'],
        web_pages: ['http://www.sru.edu/'],
        alpha_two_code: 'US',
        name: 'Slippery Rock University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['smith.edu'],
        web_pages: ['http://www.smith.edu/'],
        alpha_two_code: 'US',
        name: 'Smith College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['snead.edu'],
        web_pages: ['http://www.snead.edu'],
        alpha_two_code: 'US',
        name: 'Snead State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['solano.edu'],
        web_pages: ['http://www.solano.edu'],
        alpha_two_code: 'US',
        name: 'Solano Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['somerset.kctcs.edu'],
        web_pages: ['http://www.somerset.kctcs.edu/'],
        alpha_two_code: 'US',
        name: 'Somerset Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sonoma.edu'],
        web_pages: ['http://www.sonoma.edu/'],
        alpha_two_code: 'US',
        name: 'Sonoma State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southark.edu'],
        web_pages: ['http://www.southark.edu'],
        alpha_two_code: 'US',
        name: 'South Arkansas Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southcentral.edu'],
        web_pages: ['http://www.southcentral.edu'],
        alpha_two_code: 'US',
        name: 'South Central College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdsmt.edu'],
        web_pages: ['http://www.sdsmt.edu/'],
        alpha_two_code: 'US',
        name: 'South Dakota School of Mines and Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sdstate.edu'],
        web_pages: ['http://www.sdstate.edu/'],
        alpha_two_code: 'US',
        name: 'South Dakota State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southgatech.edu'],
        web_pages: ['http://www.southgatech.edu'],
        alpha_two_code: 'US',
        name: 'South Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['solacc.edu'],
        web_pages: ['http://www.solacc.edu/'],
        alpha_two_code: 'US',
        name: 'South Louisiana Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southmountaincc.edu'],
        web_pages: ['http://www.southmountaincc.edu'],
        alpha_two_code: 'US',
        name: 'South Mountain Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['spcc.edu'],
        web_pages: ['http://www.spcc.edu'],
        alpha_two_code: 'US',
        name: 'South Piedmont Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southplainscollege.edu'],
        web_pages: ['http://www.southplainscollege.edu/'],
        alpha_two_code: 'US',
        name: 'South Plains College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['spscc.ctc.edu'],
        web_pages: ['http://www.spscc.ctc.edu'],
        alpha_two_code: 'US',
        name: 'South Puget Sound Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ssc.edu'],
        web_pages: ['http://www.ssc.edu/'],
        alpha_two_code: 'US',
        name: 'South Suburban College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stcl.edu'],
        web_pages: ['http://www.stcl.edu/'],
        alpha_two_code: 'US',
        name: 'South Texas College of Law',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bowlinggreen.kctcs.edu'],
        web_pages: ['http://www.bowlinggreen.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Southcentral Kentucky Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['seark.edu'],
        web_pages: ['http://www.seark.edu'],
        alpha_two_code: 'US',
        name: 'Southeast Arkansas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeast.edu'],
        web_pages: ['http://www.southeast.edu'],
        alpha_two_code: 'US',
        name: 'Southeast Community College Area',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeast.kctcs.edu'],
        web_pages: ['http://www.southeast.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'Southeast Kentucky Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeastmissourihospitalcollege.edu'],
        web_pages: ['http://www.southeastmissourihospitalcollege.edu'],
        alpha_two_code: 'US',
        name: 'Southeast Missouri Hospital College of Nursing and Health Sciences',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['semo.edu'],
        web_pages: ['http://www.semo.edu/'],
        alpha_two_code: 'US',
        name: 'Southeast Missouri State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeasttech.edu'],
        web_pages: ['http://www.southeasttech.edu'],
        alpha_two_code: 'US',
        name: 'Southeast Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scciowa.edu'],
        web_pages: ['http://www.scciowa.edu'],
        alpha_two_code: 'US',
        name: 'Southeastern Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sic.edu'],
        web_pages: ['http://www.sic.edu'],
        alpha_two_code: 'US',
        name: 'Southeastern Illinois College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['selu.edu'],
        web_pages: ['http://www.selu.edu/'],
        alpha_two_code: 'US',
        name: 'Southeastern Louisiana University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southeasterntech.edu'],
        web_pages: ['http://www.southeasterntech.edu'],
        alpha_two_code: 'US',
        name: 'Southeastern Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sautech.edu'],
        web_pages: ['http://www.sautech.edu'],
        alpha_two_code: 'US',
        name: 'Southern Arkansas University Tech',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southern.edu'],
        web_pages: ['http://www.southern.edu/'],
        alpha_two_code: 'US',
        name: 'Southern College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sct.edu'],
        web_pages: ['http://www.sct.edu/'],
        alpha_two_code: 'US',
        name: 'Southern College of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southernct.edu'],
        web_pages: ['http://www.southernct.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Connecticut State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sctech.edu'],
        web_pages: ['http://www.sctech.edu'],
        alpha_two_code: 'US',
        name: 'Southern Crescent Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['siu.edu'],
        web_pages: ['http://www.siu.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Illinois University-Carbondale',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['siue.edu'],
        web_pages: ['http://www.siue.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Illinois University-Edwardsville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smccme.edu'],
        web_pages: ['http://www.smccME.edu'],
        alpha_two_code: 'US',
        name: 'Southern Maine Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smu.edu'],
        web_pages: ['http://www.smu.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Methodist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['snu.edu'],
        web_pages: ['http://www.snu.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Nazarene University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['snhu.edu'],
        web_pages: ['http://www.snhu.edu/'],
        alpha_two_code: 'US',
        name: 'Southern New Hampshire University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sou.edu'],
        web_pages: ['http://www.sou.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Oregon State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sscc.edu'],
        web_pages: ['http://www.sscc.edu'],
        alpha_two_code: 'US',
        name: 'Southern State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['suscc.edu'],
        web_pages: ['http://www.suscc.edu'],
        alpha_two_code: 'US',
        name: 'Southern Union State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['subr.edu'],
        web_pages: ['http://www.subr.edu/'],
        alpha_two_code: 'US',
        name: 'Southern University and A&M College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['susla.edu'],
        web_pages: ['http://www.susla.edu'],
        alpha_two_code: 'US',
        name: 'Southern University at Shreveport',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['suu.edu'],
        web_pages: ['http://www.suu.edu/'],
        alpha_two_code: 'US',
        name: 'Southern Utah University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southernwv.edu'],
        web_pages: ['http://www.southernwv.edu'],
        alpha_two_code: 'US',
        name: 'Southern West Virginia Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southside.edu'],
        web_pages: ['http://www.southside.edu'],
        alpha_two_code: 'US',
        name: 'Southside Virginia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sbuniv.edu'],
        web_pages: ['http://www.sbuniv.edu/'],
        alpha_two_code: 'US',
        name: 'Southwest Baptist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southwestgatech.edu'],
        web_pages: ['http://www.southwestgatech.edu/'],
        alpha_two_code: 'US',
        name: 'Southwest Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smcc.edu'],
        web_pages: ['http://www.smcc.edu'],
        alpha_two_code: 'US',
        name: 'Southwest Mississippi Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smsu.edu'],
        web_pages: ['http://www.smsu.edu/'],
        alpha_two_code: 'US',
        name: 'Southwest Missouri State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swri.edu'],
        web_pages: ['http://www.swri.edu/'],
        alpha_two_code: 'US',
        name: 'Southwest Research Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southwest.tn.edu'],
        web_pages: ['http://www.southwest.tn.edu'],
        alpha_two_code: 'US',
        name: 'Southwest Tennessee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swtjc.net'],
        web_pages: ['http://www.swtjc.net'],
        alpha_two_code: 'US',
        name: 'Southwest Texas Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swt.edu'],
        web_pages: ['http://www.swt.edu/'],
        alpha_two_code: 'US',
        name: 'Southwest Texas State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sw.edu'],
        web_pages: ['http://www.sw.edu'],
        alpha_two_code: 'US',
        name: 'Southwest Virginia Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swtc.edu'],
        web_pages: ['http://www.swtc.edu'],
        alpha_two_code: 'US',
        name: 'Southwest Wisconsin Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swac.edu'],
        web_pages: ['http://www.swac.edu/'],
        alpha_two_code: 'US',
        name: 'Southwestern Adventist College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sagu.edu'],
        web_pages: ['http://www.sagu.edu/'],
        alpha_two_code: 'US',
        name: 'Southwestern Assemblies of God University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swccd.edu'],
        web_pages: ['http://www.swccd.edu/'],
        alpha_two_code: 'US',
        name: 'Southwestern College (CA)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sckans.edu'],
        web_pages: ['http://www.sckans.edu/'],
        alpha_two_code: 'US',
        name: 'Southwestern College (KS)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swcciowa.edu'],
        web_pages: ['http://www.swcciowa.edu'],
        alpha_two_code: 'US',
        name: 'Southwestern Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swic.edu'],
        web_pages: ['http://www.swic.edu'],
        alpha_two_code: 'US',
        name: 'Southwestern Illinois College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sipi.edu'],
        web_pages: ['http://www.sipi.edu'],
        alpha_two_code: 'US',
        name: 'Southwestern Indian Polytechnic Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swmich.edu'],
        web_pages: ['http://www.swmich.edu'],
        alpha_two_code: 'US',
        name: 'Southwestern Michigan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['socc.edu'],
        web_pages: ['http://www.socc.edu'],
        alpha_two_code: 'US',
        name: 'Southwestern Oregon Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southwestern.edu'],
        web_pages: ['http://www.southwestern.edu/'],
        alpha_two_code: 'US',
        name: 'Southwestern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sowela.edu'],
        web_pages: ['http://www.sowela.edu'],
        alpha_two_code: 'US',
        name: 'SOWELA Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sccsc.edu'],
        web_pages: ['http://www.sccsc.edu'],
        alpha_two_code: 'US',
        name: 'Spartanburg Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smcsc.edu'],
        web_pages: ['http://www.smcsc.edu/'],
        alpha_two_code: 'US',
        name: 'Spartanburg Methodist College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['auc.edu'],
        web_pages: ['http://www.auc.edu/'],
        alpha_two_code: 'US',
        name: 'Spelman College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scc.spokane.edu'],
        web_pages: ['http://www.scc.spokane.edu'],
        alpha_two_code: 'US',
        name: 'Spokane Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['spokanefalls.edu'],
        web_pages: ['http://www.spokanefalls.edu'],
        alpha_two_code: 'US',
        name: 'Spokane Falls Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['src.edu'],
        web_pages: ['http://www.src.edu'],
        alpha_two_code: 'US',
        name: 'Spoon River College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['arbor.edu'],
        web_pages: ['http://www.arbor.edu/'],
        alpha_two_code: 'US',
        name: 'Spring Arbor College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['shc.edu'],
        web_pages: ['http://www.shc.edu/'],
        alpha_two_code: 'US',
        name: 'Spring Hill College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stcc.edu'],
        web_pages: ['http://www.stcc.edu'],
        alpha_two_code: 'US',
        name: 'Springfield Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stchas.edu'],
        web_pages: ['http://www.stchas.edu'],
        alpha_two_code: 'US',
        name: 'St Charles Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sctcc.edu'],
        web_pages: ['http://www.sctcc.edu'],
        alpha_two_code: 'US',
        name: 'St Cloud Technical and Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alamo.edu'],
        web_pages: ['http://www.alamo.edu/spc/'],
        alpha_two_code: 'US',
        name: "St Philip's College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sau.edu'],
        web_pages: ['http://www.sau.edu/'],
        alpha_two_code: 'US',
        name: 'St. Ambrose University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sapc.edu'],
        web_pages: ['http://www.sapc.edu/'],
        alpha_two_code: 'US',
        name: 'St. Andrews Presbyterian College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sbu.edu'],
        web_pages: ['http://www.sbu.edu/'],
        alpha_two_code: 'US',
        name: 'St. Bonaventure University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sc4.edu'],
        web_pages: ['http://www.sc4.edu'],
        alpha_two_code: 'US',
        name: 'St. Clair County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjca.edu'],
        web_pages: ['http://www.sjca.edu/'],
        alpha_two_code: 'US',
        name: "St. John's College - Annapolis",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjcsf.edu'],
        web_pages: ['http://www.sjcsf.edu/'],
        alpha_two_code: 'US',
        name: "St. John's College - Santa Fe",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjrstate.edu'],
        web_pages: ['http://www.sjrstate.edu/'],
        alpha_two_code: 'US',
        name: 'St. Johns River State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjc.edu'],
        web_pages: ['http://www.sjc.edu/'],
        alpha_two_code: 'US',
        name: 'St. Joseph College (CT)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sjcme.edu'],
        web_pages: ['http://www.sjcme.edu/'],
        alpha_two_code: 'US',
        name: "St. Joseph's College (ME)",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stlawu.edu'],
        web_pages: ['http://www.stlawu.edu/'],
        alpha_two_code: 'US',
        name: 'St. Lawrence University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stlcop.edu'],
        web_pages: ['http://www.stlcop.edu/'],
        alpha_two_code: 'US',
        name: 'St. Louis College of Pharmacy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stmartin.edu'],
        web_pages: ['http://www.stmartin.edu/'],
        alpha_two_code: 'US',
        name: "St. Martin's College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['smcm.edu'],
        web_pages: ['http://www.smcm.edu/'],
        alpha_two_code: 'US',
        name: "St. Mary's College of Maryland",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['spcollege.edu'],
        web_pages: ['http://www.spcollege.edu/'],
        alpha_two_code: 'US',
        name: 'St. Petersburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stu.edu'],
        web_pages: ['http://www.stu.edu/'],
        alpha_two_code: 'US',
        name: 'St. Thomas University (FL)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stanford.edu'],
        web_pages: ['http://www.stanford.edu/'],
        alpha_two_code: 'US',
        name: 'Stanford University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stanly.edu'],
        web_pages: ['http://www.stanly.edu'],
        alpha_two_code: 'US',
        name: 'Stanly Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['starkstate.edu'],
        web_pages: ['http://www.starkstate.edu'],
        alpha_two_code: 'US',
        name: 'Stark State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sfccmo.edu'],
        web_pages: ['http://www.sfccmo.edu'],
        alpha_two_code: 'US',
        name: 'State Fair Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['albany.edu'],
        web_pages: ['http://www.albany.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Albany',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['binghamton.edu'],
        web_pages: ['http://www.binghamton.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Binghamton',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['buffalo.edu'],
        web_pages: ['http://www.buffalo.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Buffalo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['farmingdale.edu'],
        web_pages: ['http://www.farmingdale.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Farmingdale',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['fredonia.edu'],
        web_pages: ['http://home.fredonia.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Fredonia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['oswego.edu'],
        web_pages: ['http://www.oswego.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Oswego',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['plattsburgh.edu'],
        web_pages: ['http://www.plattsburgh.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Plattsburgh',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stonybrook.edu'],
        web_pages: ['http://www.stonybrook.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York at Stony Brook',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['brockport.edu'],
        web_pages: ['http://www.brockport.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at Brockport',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['buffalostate.edu'],
        web_pages: ['http://suny.buffalostate.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at Buffalo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cortland.edu'],
        web_pages: ['http://www.cortland.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at Cortland',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['geneseo.edu'],
        web_pages: ['http://www.geneseo.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at Geneseo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['newpaltz.edu'],
        web_pages: ['http://www.newpaltz.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at New Paltz',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['potsdam.edu'],
        web_pages: ['http://www.potsdam.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College at Potsdam',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cobleskill.edu'],
        web_pages: ['http://www.cobleskill.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College of Agriculture and Technology at Cobleskill',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['esf.edu'],
        web_pages: ['http://www.esf.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College of Environmental Science and Forestry',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alfredtech.edu'],
        web_pages: ['http://www.alfredtech.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York College of Technology at Alfred',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunyit.edu'],
        web_pages: ['http://www.sunypoly.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York Polytechnic Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunycentral.edu'],
        web_pages: ['http://www.sunycentral.edu/'],
        alpha_two_code: 'US',
        name: 'State University of New York System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sfasu.edu'],
        web_pages: ['http://www.sfasu.edu/'],
        alpha_two_code: 'US',
        name: 'Stephen F. Austin State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stephens.edu'],
        web_pages: ['http://www.stephens.edu/'],
        alpha_two_code: 'US',
        name: 'Stephens College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stetson.edu'],
        web_pages: ['http://www.stetson.edu/'],
        alpha_two_code: 'US',
        name: 'Stetson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stevens.edu'],
        web_pages: ['http://www.stevens.edu/'],
        alpha_two_code: 'US',
        name: 'Stevens Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stevenson.edu'],
        web_pages: ['http://www.stevenson.edu/'],
        alpha_two_code: 'US',
        name: 'Stevenson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stonechild.edu'],
        web_pages: ['http://www.stonechild.edu'],
        alpha_two_code: 'US',
        name: 'Stone Child College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stratford.edu'],
        web_pages: ['http://www.stratford.edu/'],
        alpha_two_code: 'US',
        name: 'Stratford University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['strayer.edu'],
        web_pages: ['http://www.strayer.edu/'],
        alpha_two_code: 'US',
        name: 'Strayer College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www3.sunysuffolk.edu'],
        web_pages: ['http://www3.sunysuffolk.edu'],
        alpha_two_code: 'US',
        name: 'Suffolk County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['suffolk.edu'],
        web_pages: ['http://www.suffolk.edu/'],
        alpha_two_code: 'US',
        name: 'Suffolk University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sulross.edu'],
        web_pages: ['http://www.sulross.edu/'],
        alpha_two_code: 'US',
        name: 'Sul Ross State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunysullivan.edu'],
        web_pages: ['http://www.sunysullivan.edu/'],
        alpha_two_code: 'US',
        name: 'Sullivan County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sullivan.edu'],
        web_pages: ['https://sullivan.edu/'],
        alpha_two_code: 'US',
        name: 'Sullivan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['summitunivofla.edu'],
        web_pages: ['http://www.summitunivofla.edu/'],
        alpha_two_code: 'US',
        name: 'Summit University of Louisiana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.sunybroome.edu'],
        web_pages: ['http://WWW.SUNYBROOME.EDU'],
        alpha_two_code: 'US',
        name: 'SUNY Broome Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunymaritime.edu'],
        web_pages: ['http://www.sunymaritime.edu/'],
        alpha_two_code: 'US',
        name: 'SUNY Maritime College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sunywcc.edu'],
        web_pages: ['http://www.sunywcc.edu'],
        alpha_two_code: 'US',
        name: 'SUNY Westchester Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['surry.edu'],
        web_pages: ['http://www.surry.edu'],
        alpha_two_code: 'US',
        name: 'Surry Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['susqu.edu'],
        web_pages: ['http://www.susqu.edu/'],
        alpha_two_code: 'US',
        name: 'Susquehanna University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sussex.edu'],
        web_pages: ['http://www.sussex.edu'],
        alpha_two_code: 'US',
        name: 'Sussex County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swarthmore.edu'],
        web_pages: ['http://www.swarthmore.edu/'],
        alpha_two_code: 'US',
        name: 'Swarthmore College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sbc.edu'],
        web_pages: ['http://www.sbc.edu/'],
        alpha_two_code: 'US',
        name: 'Sweet Briar College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['syr.edu'],
        web_pages: ['http://www.syr.edu/'],
        alpha_two_code: 'US',
        name: 'Syracuse University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tabor.edu'],
        web_pages: ['http://www.tabor.edu/'],
        alpha_two_code: 'US',
        name: 'Tabor College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tacomacc.edu'],
        web_pages: ['http://www.tacomacc.edu'],
        alpha_two_code: 'US',
        name: 'Tacoma Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['taftcollege.edu'],
        web_pages: ['http://www.taftcollege.edu'],
        alpha_two_code: 'US',
        name: 'Taft College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcc.fl.edu'],
        web_pages: ['https://www.tcc.fl.edu'],
        alpha_two_code: 'US',
        name: 'Tallahassee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tarleton.edu'],
        web_pages: ['http://www.tarleton.edu/'],
        alpha_two_code: 'US',
        name: 'Tarleton State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tayloru.edu'],
        web_pages: ['http://www.tayloru.edu/'],
        alpha_two_code: 'US',
        name: 'Taylor University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcicollege.edu'],
        web_pages: ['http://www.tcicollege.edu'],
        alpha_two_code: 'US',
        name: 'Technical Career Institutes',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcl.edu'],
        web_pages: ['http://www.tcl.edu'],
        alpha_two_code: 'US',
        name: 'Technical College of the Lowcountry',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['templejc.edu'],
        web_pages: ['http://www.templejc.edu'],
        alpha_two_code: 'US',
        name: 'Temple College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['temple.edu'],
        web_pages: ['http://www.temple.edu/'],
        alpha_two_code: 'US',
        name: 'Temple University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tnstate.edu'],
        web_pages: ['http://www.tnstate.edu/'],
        alpha_two_code: 'US',
        name: 'Tennessee State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tntech.edu'],
        web_pages: ['http://www.tntech.edu/'],
        alpha_two_code: 'US',
        name: 'Tennessee Technological University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['terra.edu'],
        web_pages: ['http://www.terra.edu'],
        alpha_two_code: 'US',
        name: 'Terra State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tccd.edu'],
        web_pages: ['http://www.tccd.edu/'],
        alpha_two_code: 'US',
        name: 'Terrant County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['texarkanacollege.edu'],
        web_pages: ['http://www.texarkanacollege.edu'],
        alpha_two_code: 'US',
        name: 'Texarkana College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tamiu.edu'],
        web_pages: ['http://www.tamiu.edu/'],
        alpha_two_code: 'US',
        name: 'Texas A&M International University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tamu.edu'],
        web_pages: ['http://www.tamu.edu/'],
        alpha_two_code: 'US',
        name: 'Texas A&M University - College Station',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tamuc.edu'],
        web_pages: ['http://www.tamuc.edu/'],
        alpha_two_code: 'US',
        name: 'Texas A&M University - Commerce',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tamucc.edu'],
        web_pages: ['http://www.tamucc.edu/'],
        alpha_two_code: 'US',
        name: 'Texas A&M University - Corpus Christi',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tamuk.edu'],
        web_pages: ['http://www.tamuk.edu/'],
        alpha_two_code: 'US',
        name: 'Texas A&M University - Kingsville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcu.edu'],
        web_pages: ['http://www.tcu.edu/'],
        alpha_two_code: 'US',
        name: 'Texas Christian University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tsu.edu'],
        web_pages: ['http://www.tsu.edu/'],
        alpha_two_code: 'US',
        name: 'Texas Southern University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['harlingen.tstc.edu'],
        web_pages: ['http://www.harlingen.tstc.edu'],
        alpha_two_code: 'US',
        name: 'Texas State Technical College-​Harlingen',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['marshall.tstc.edu'],
        web_pages: ['http://www.marshall.tstc.edu'],
        alpha_two_code: 'US',
        name: 'Texas State Technical College-​Marshall',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waco.tstc.edu'],
        web_pages: ['http://www.waco.tstc.edu'],
        alpha_two_code: 'US',
        name: 'Texas State Technical College-​Waco',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westtexas.tstc.edu'],
        web_pages: ['http://www.westtexas.tstc.edu'],
        alpha_two_code: 'US',
        name: 'Texas State Technical College-​West Texas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['txstate.edu'],
        web_pages: ['http://www.txstate.edu/'],
        alpha_two_code: 'US',
        name: 'Texas State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ttu.edu'],
        web_pages: ['http://www.ttu.edu/'],
        alpha_two_code: 'US',
        name: 'Texas Tech University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ttuhsc.edu'],
        web_pages: ['http://www.ttuhsc.edu/'],
        alpha_two_code: 'US',
        name: 'Texas Tech University-Health Sciences Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['twu.edu'],
        web_pages: ['http://www.twu.edu/'],
        alpha_two_code: 'US',
        name: "Texas Woman's University",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stevenscollege.edu'],
        web_pages: ['http://www.stevenscollege.edu'],
        alpha_two_code: 'US',
        name: 'Thaddeus Stevens College of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['aii.edu'],
        web_pages: ['http://www.aii.edu/'],
        alpha_two_code: 'US',
        name: 'The Art Institutes',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['citadel.edu'],
        web_pages: ['http://www.citadel.edu/'],
        alpha_two_code: 'US',
        name: 'The Citadel',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcnj.edu'],
        web_pages: ['http://www.tcnj.edu/'],
        alpha_two_code: 'US',
        name: 'The College of New Jersey',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jtsa.edu'],
        web_pages: ['http://www.jtsa.edu/'],
        alpha_two_code: 'US',
        name: 'The Jewish Theological Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['principia.edu'],
        web_pages: ['http://www.principia.edu/'],
        alpha_two_code: 'US',
        name: 'The Principia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scripps.edu'],
        web_pages: ['https://scripps.edu/'],
        alpha_two_code: 'US',
        name: 'The Scripps Research Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['thomas.edu'],
        web_pages: ['http://www.thomas.edu/'],
        alpha_two_code: 'US',
        name: 'Thomas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tesc.edu', 'tesu.edu'],
        web_pages: ['http://www.tesc.edu/', 'http://www.tesu.edu/'],
        alpha_two_code: 'US',
        name: 'Thomas Edison State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tju.edu'],
        web_pages: ['http://www.tju.edu/'],
        alpha_two_code: 'US',
        name: 'Thomas Jefferson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['thomasmore.edu'],
        web_pages: ['http://www.thomasmore.edu/'],
        alpha_two_code: 'US',
        name: 'Thomas More College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tncc.edu'],
        web_pages: ['http://www.tncc.edu'],
        alpha_two_code: 'US',
        name: 'Thomas Nelson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trcc.commnet.edu'],
        web_pages: ['http://www.trcc.commnet.edu'],
        alpha_two_code: 'US',
        name: 'Three Rivers Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['thunderbird.edu'],
        web_pages: ['http://www.thunderbird.edu/'],
        alpha_two_code: 'US',
        name: 'Thunderbird School of Global Management',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tcc.edu'],
        web_pages: ['http://www.tcc.edu'],
        alpha_two_code: 'US',
        name: 'Tidewater Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tiffin.edu'],
        web_pages: ['http://www.tiffin.edu/'],
        alpha_two_code: 'US',
        name: 'Tiffin University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tbcc.cc.or.us'],
        web_pages: ['http://www.tbcc.cc.or.us/'],
        alpha_two_code: 'US',
        name: 'Tillamook Bay Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tocc.edu'],
        web_pages: ['http://www.tocc.edu'],
        alpha_two_code: 'US',
        name: "Tohono O'Odham Community College",
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tc3.edu'],
        web_pages: ['http://www.TC3.edu'],
        alpha_two_code: 'US',
        name: 'Tompkins Cortland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['touro.edu'],
        web_pages: ['http://www.touro.edu/'],
        alpha_two_code: 'US',
        name: 'Touro College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['towson.edu'],
        web_pages: ['http://www.towson.edu/'],
        alpha_two_code: 'US',
        name: 'Towson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['transy.edu'],
        web_pages: ['http://www.transy.edu/'],
        alpha_two_code: 'US',
        name: 'Transylvania University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tvcc.cc'],
        web_pages: ['http://www.tvcc.cc'],
        alpha_two_code: 'US',
        name: 'Treasure Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trenton.edu'],
        web_pages: ['http://www.trenton.edu/'],
        alpha_two_code: 'US',
        name: 'Trenton State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tricountycc.edu'],
        web_pages: ['http://www.tricountycc.edu'],
        alpha_two_code: 'US',
        name: 'Tri-​County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tctc.edu'],
        web_pages: ['http://www.tctc.edu'],
        alpha_two_code: 'US',
        name: 'Tri-​County Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tridenttech.edu'],
        web_pages: ['http://www.tridenttech.edu'],
        alpha_two_code: 'US',
        name: 'Trident Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trident.edu'],
        web_pages: ['https://www.trident.edu/'],
        alpha_two_code: 'US',
        name: 'Trident University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trine.edu'],
        web_pages: ['http://www.trine.edu/'],
        alpha_two_code: 'US',
        name: 'Trine University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trinidadstate.edu'],
        web_pages: ['http://www.trinidadstate.edu/'],
        alpha_two_code: 'US',
        name: 'Trinidad State Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trinitybiblecollege.edu'],
        web_pages: ['https://trinitybiblecollege.edu'],
        alpha_two_code: 'US',
        name: 'Trinity Bible College & Graduate School',
        'state-province': 'ND',
    },
    {
        country: 'United States',
        domains: ['trincoll.edu'],
        web_pages: ['http://www.trincoll.edu/'],
        alpha_two_code: 'US',
        name: 'Trinity College (CT)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trinitydc.edu'],
        web_pages: ['http://www.trinitydc.edu'],
        alpha_two_code: 'US',
        name: 'Trinity College (DC)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['trinity.edu'],
        web_pages: ['http://www.trinity.edu/'],
        alpha_two_code: 'US',
        name: 'Trinity University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tvcc.edu'],
        web_pages: ['http://www.tvcc.edu'],
        alpha_two_code: 'US',
        name: 'Trinity Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['triton.edu'],
        web_pages: ['http://www.triton.edu'],
        alpha_two_code: 'US',
        name: 'Triton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tsufl.edu'],
        web_pages: ['http://www.tsufl.edu/'],
        alpha_two_code: 'US',
        name: 'Troy State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['troy.edu'],
        web_pages: ['https://troy.edu/'],
        alpha_two_code: 'US',
        name: 'Troy University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tmcc.edu'],
        web_pages: ['http://www.tmcc.edu'],
        alpha_two_code: 'US',
        name: 'Truckee Meadows Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['truman.edu'],
        web_pages: ['http://www.truman.edu/'],
        alpha_two_code: 'US',
        name: 'Truman State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tucsonu.edu'],
        web_pages: ['http://www.tucsonu.edu/'],
        alpha_two_code: 'US',
        name: 'Tucson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tufts.edu'],
        web_pages: ['http://www.tufts.edu/'],
        alpha_two_code: 'US',
        name: 'Tufts University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tulane.edu'],
        web_pages: ['http://www.tulane.edu/'],
        alpha_two_code: 'US',
        name: 'Tulane University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tulsacc.edu'],
        web_pages: ['http://www.tulsacc.edu'],
        alpha_two_code: 'US',
        name: 'Tulsa Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tunxis.edu'],
        web_pages: ['http://www.tunxis.edu'],
        alpha_two_code: 'US',
        name: 'Tunxis Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tusculum.edu'],
        web_pages: ['https://home.tusculum.edu/'],
        alpha_two_code: 'US',
        name: 'Tusculum College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tuskegee.edu'],
        web_pages: ['http://www.tuskegee.edu/'],
        alpha_two_code: 'US',
        name: 'Tuskegee University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['www.tjc.edu'],
        web_pages: ['http://WWW.TJC.EDU'],
        alpha_two_code: 'US',
        name: 'Tyler Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uchastings.edu'],
        web_pages: ['http://www.uchastings.edu/'],
        alpha_two_code: 'US',
        name: 'UC Hastings College of the Law',
        'state-province': 'CA',
    },
    {
        country: 'United States',
        domains: ['www.sunyulster.edu'],
        web_pages: ['http://WWW.SUNYULSTER.EDU'],
        alpha_two_code: 'US',
        name: 'Ulster County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umpqua.edu'],
        web_pages: ['http://www.umpqua.edu/'],
        alpha_two_code: 'US',
        name: 'Umpqua Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usuhs.mil'],
        web_pages: ['http://www.usuhs.mil/'],
        alpha_two_code: 'US',
        name: 'Uniformed Services University of the Health Sciences',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['union.edu'],
        web_pages: ['http://www.union.edu/'],
        alpha_two_code: 'US',
        name: 'Union College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucc.edu'],
        web_pages: ['http://www.ucc.edu'],
        alpha_two_code: 'US',
        name: 'Union County College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['tui.edu'],
        web_pages: ['http://www.tui.edu/'],
        alpha_two_code: 'US',
        name: 'Union Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uu.edu'],
        web_pages: ['http://www.uu.edu/'],
        alpha_two_code: 'US',
        name: 'Union University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usafa.af.mil', 'usafa.edu'],
        web_pages: ['http://www.usafa.af.mil/', 'http://www.usafa.edu/'],
        alpha_two_code: 'US',
        name: 'United States Air Force Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uscga.edu'],
        web_pages: ['http://www.uscga.edu/'],
        alpha_two_code: 'US',
        name: 'United States Coast Guard Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usiu.edu'],
        web_pages: ['http://www.usiu.edu/'],
        alpha_two_code: 'US',
        name: 'United States International University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usmma.edu'],
        web_pages: ['http://www.usmma.edu/'],
        alpha_two_code: 'US',
        name: 'United States Merchant Marine Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usma.edu'],
        web_pages: ['http://www.usma.edu/'],
        alpha_two_code: 'US',
        name: 'United States Military Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usna.edu'],
        web_pages: ['http://www.usna.edu/'],
        alpha_two_code: 'US',
        name: 'United States Naval Academy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uat.edu'],
        web_pages: ['http://www.uat.edu/'],
        alpha_two_code: 'US',
        name: 'University of Advancing Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uakron.edu'],
        web_pages: ['http://www.uakron.edu/'],
        alpha_two_code: 'US',
        name: 'University of Akron',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wayne.uakron.edu'],
        web_pages: ['http://www.wayne.uakron.edu'],
        alpha_two_code: 'US',
        name: 'University of Akron Wayne College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uab.edu'],
        web_pages: ['http://www.uab.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alabama at Birmingham',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uah.edu'],
        web_pages: ['http://www.uah.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alabama at Huntsville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ua.edu'],
        web_pages: ['http://www.ua.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alabama at Tuscaloosa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['alaska.edu'],
        web_pages: ['http://www.alaska.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alaska',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uaa.alaska.edu'],
        web_pages: ['http://www.uaa.alaska.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alaska - Anchorage',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uaf.edu'],
        web_pages: ['http://www.uaf.edu'],
        alpha_two_code: 'US',
        name: 'University of Alaska - Fairbanks',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uas.alaska.edu'],
        web_pages: ['http://www.uas.alaska.edu/'],
        alpha_two_code: 'US',
        name: 'University of Alaska - Southeast',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['arizona.edu'],
        web_pages: ['http://www.arizona.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arizona',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uark.edu'],
        web_pages: ['http://www.uark.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas - Fayetteville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uafs.edu'],
        web_pages: ['http://www.uafs.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas - Fort Smith',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ualr.edu'],
        web_pages: ['http://www.ualr.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas - Little Rock',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uamont.edu'],
        web_pages: ['http://www.uamont.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas - Monticello',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uaccb.edu'],
        web_pages: ['http://www.uaccb.edu'],
        alpha_two_code: 'US',
        name: 'University of Arkansas Community College-​Batesville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uacch.edu'],
        web_pages: ['http://www.uacch.edu'],
        alpha_two_code: 'US',
        name: 'University of Arkansas Community College-​Hope',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uaccm.edu'],
        web_pages: ['http://www.uaccm.edu'],
        alpha_two_code: 'US',
        name: 'University of Arkansas Community College-​Morrilton',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uams.edu'],
        web_pages: ['http://www.uams.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas for Medical Sciences',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uasys.edu'],
        web_pages: ['https://www.uasys.edu/'],
        alpha_two_code: 'US',
        name: 'University of Arkansas System eVersity',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ubalt.edu'],
        web_pages: ['http://www.ubalt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Baltimore',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bridgeport.edu'],
        web_pages: ['http://www.bridgeport.edu/'],
        alpha_two_code: 'US',
        name: 'University of Bridgeport',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['berkeley.edu'],
        web_pages: ['http://www.berkeley.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Berkeley',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucdavis.edu'],
        web_pages: ['http://www.ucdavis.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Davis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uci.edu'],
        web_pages: ['http://www.uci.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Irvine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucla.edu'],
        web_pages: ['http://www.ucla.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Los Angeles',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucmerced.edu'],
        web_pages: ['http://www.ucmerced.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Merced',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucop.edu'],
        web_pages: ['https://www.ucop.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Office of the President',
        'state-province': 'CA',
    },
    {
        country: 'United States',
        domains: ['ucr.edu'],
        web_pages: ['http://www.ucr.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Riverside',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucsd.edu'],
        web_pages: ['http://www.ucsd.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, San Diego',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucsf.edu'],
        web_pages: ['http://www.ucsf.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, San Francisco',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucsb.edu'],
        web_pages: ['http://www.ucsb.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Santa Barbara',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucsc.edu'],
        web_pages: ['http://www.ucsc.edu/'],
        alpha_two_code: 'US',
        name: 'University of California, Santa Cruz',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uca.edu'],
        web_pages: ['http://www.uca.edu/'],
        alpha_two_code: 'US',
        name: 'University of Central Arkansas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucf.edu'],
        web_pages: ['http://www.ucf.edu/'],
        alpha_two_code: 'US',
        name: 'University of Central Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucmo.edu'],
        web_pages: ['http://www.ucmo.edu/'],
        alpha_two_code: 'US',
        name: 'University of Central Missouri',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uco.edu'],
        web_pages: ['http://www.uco.edu/'],
        alpha_two_code: 'US',
        name: 'University of Central Oklahoma',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uchaswv.edu'],
        web_pages: ['http://www.uchaswv.edu/'],
        alpha_two_code: 'US',
        name: 'University of Charleston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uchicago.edu'],
        web_pages: ['http://www.uchicago.edu/'],
        alpha_two_code: 'US',
        name: 'University of Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uc.edu'],
        web_pages: ['http://www.uc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Cincinnati',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['cuanschutz.edu'],
        web_pages: ['https://www.cuanschutz.edu/'],
        alpha_two_code: 'US',
        name: 'University of Colorado Anschutz Medical Campus',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['colorado.edu'],
        web_pages: ['http://www.colorado.edu/'],
        alpha_two_code: 'US',
        name: 'University of Colorado at Boulder',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uccs.edu'],
        web_pages: ['http://www.uccs.edu/'],
        alpha_two_code: 'US',
        name: 'University of Colorado at Colorado Springs',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ucdenver.edu'],
        web_pages: ['http://www.ucdenver.edu/'],
        alpha_two_code: 'US',
        name: 'University of Colorado at Denver',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hsc.colorado.edu'],
        web_pages: ['http://www.hsc.colorado.edu/'],
        alpha_two_code: 'US',
        name: 'University of Colorado Health Sciences Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uconn.edu'],
        web_pages: ['http://www.uconn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Connecticut',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['udallas.edu'],
        web_pages: ['http://www.udallas.edu/'],
        alpha_two_code: 'US',
        name: 'University of Dallas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['udayton.edu'],
        web_pages: ['http://www.udayton.edu/'],
        alpha_two_code: 'US',
        name: 'University of Dayton',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['udel.edu'],
        web_pages: ['http://www.udel.edu/'],
        alpha_two_code: 'US',
        name: 'University of Delaware',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['du.edu'],
        web_pages: ['http://www.du.edu/'],
        alpha_two_code: 'US',
        name: 'University of Denver',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['udmercy.edu'],
        web_pages: ['http://www.udmercy.edu/'],
        alpha_two_code: 'US',
        name: 'University of Detroit Mercy',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['dbq.edu'],
        web_pages: ['http://www.dbq.edu/'],
        alpha_two_code: 'US',
        name: 'University of Dubuque',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['evansville.edu'],
        web_pages: ['http://www.evansville.edu/'],
        alpha_two_code: 'US',
        name: 'University of Evansville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['findlay.edu'],
        web_pages: ['https://www.findlay.edu/'],
        alpha_two_code: 'US',
        name: 'University of Findlay',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ufl.edu'],
        web_pages: ['http://www.ufl.edu/'],
        alpha_two_code: 'US',
        name: 'University of Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uga.edu'],
        web_pages: ['http://www.uga.edu/'],
        alpha_two_code: 'US',
        name: 'University of Georgia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ugf.edu'],
        web_pages: ['http://www.ugf.edu/'],
        alpha_two_code: 'US',
        name: 'University of Great Falls',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uog.edu'],
        web_pages: ['http://www.uog.edu/'],
        alpha_two_code: 'US',
        name: 'University of Guam',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hartford.edu'],
        web_pages: ['http://www.hartford.edu/'],
        alpha_two_code: 'US',
        name: 'University of Hartford',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hilo.hawaii.edu'],
        web_pages: ['http://hilo.hawaii.edu/'],
        alpha_two_code: 'US',
        name: 'University of Hawaii at Hilo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['manoa.hawaii.edu'],
        web_pages: ['http://manoa.hawaii.edu/'],
        alpha_two_code: 'US',
        name: 'University of Hawaii at Manoa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hawaii.edu'],
        web_pages: ['http://www.hawaii.edu/'],
        alpha_two_code: 'US',
        name: 'University of Hawaii System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uh.edu'],
        web_pages: ['http://www.uh.edu/'],
        alpha_two_code: 'US',
        name: 'University of Houston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uhd.edu'],
        web_pages: ['http://www.uhd.edu/'],
        alpha_two_code: 'US',
        name: 'University of Houston-Downtown',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uidaho.edu'],
        web_pages: ['http://www.uidaho.edu/'],
        alpha_two_code: 'US',
        name: 'University of Idaho',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uic.edu'],
        web_pages: ['http://www.uic.edu/'],
        alpha_two_code: 'US',
        name: 'University of Illinois at Chicago',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uis.edu'],
        web_pages: ['http://www.uis.edu/'],
        alpha_two_code: 'US',
        name: 'University of Illinois at Springfield',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uiuc.edu', 'illinois.edu'],
        web_pages: ['http://www.illinois.edu/'],
        alpha_two_code: 'US',
        name: 'University of Illinois at Urbana-Champaign',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uindy.edu'],
        web_pages: ['http://www.uindy.edu/'],
        alpha_two_code: 'US',
        name: 'University of Indianapolis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uiowa.edu'],
        web_pages: ['http://www.uiowa.edu/'],
        alpha_two_code: 'US',
        name: 'University of Iowa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uj.edu'],
        web_pages: ['http://www.uj.edu/'],
        alpha_two_code: 'US',
        name: 'University of Jamestown',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ku.edu'],
        web_pages: ['http://www.ku.edu'],
        alpha_two_code: 'US',
        name: 'University of Kansas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['kumc.edu'],
        web_pages: ['http://www.kumc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Kansas School of Medicine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uky.edu'],
        web_pages: ['http://www.uky.edu/'],
        alpha_two_code: 'US',
        name: 'University of Kentucky',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['laverne.edu'],
        web_pages: ['http://www.laverne.edu/'],
        alpha_two_code: 'US',
        name: 'University of La Verne',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['louisiana.edu'],
        web_pages: ['http://www.louisiana.edu/'],
        alpha_two_code: 'US',
        name: 'University of Louisiana at Lafeyette',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ulm.edu'],
        web_pages: ['http://www.ulm.edu/'],
        alpha_two_code: 'US',
        name: 'University of Louisiana at Monroe',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['louisville.edu'],
        web_pages: ['http://www.louisville.edu/'],
        alpha_two_code: 'US',
        name: 'University of Louisville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umaine.edu'],
        web_pages: ['http://www.umaine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umf.maine.edu'],
        web_pages: ['http://www.umf.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine at Farmington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umfk.maine.edu'],
        web_pages: ['http://www.umfk.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine at Fort Kent',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umm.maine.edu'],
        web_pages: ['http://www.umm.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine at Machias',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umpi.maine.edu'],
        web_pages: ['http://www.umpi.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine at Presque Island',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['maine.edu'],
        web_pages: ['http://www.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maine System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umw.edu'],
        web_pages: ['https://www.umw.edu/'],
        alpha_two_code: 'US',
        name: 'University of Mary Washington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umuc.edu'],
        web_pages: ['http://www.umuc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maryland - University College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umes.edu'],
        web_pages: ['http://www.umes.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maryland Eastern Shore',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umaryland.edu'],
        web_pages: ['http://www.umaryland.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maryland, Baltimore',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umbc.edu'],
        web_pages: ['http://www.umbc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maryland, Baltimore County',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umd.edu'],
        web_pages: ['http://www.umd.edu/'],
        alpha_two_code: 'US',
        name: 'University of Maryland, College Park',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umass.edu'],
        web_pages: ['http://www.umass.edu/'],
        alpha_two_code: 'US',
        name: 'University of Massachusetts at Amherst',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umassd.edu'],
        web_pages: ['http://www.umassd.edu/'],
        alpha_two_code: 'US',
        name: 'University of Massachusetts at Dartmouth',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uml.edu', 'student.uml.edu'],
        web_pages: ['http://www.uml.edu/'],
        alpha_two_code: 'US',
        name: 'University of Massachusetts at Lowell',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umb.edu'],
        web_pages: ['https://www.umb.edu/'],
        alpha_two_code: 'US',
        name: 'University of Massachusetts Boston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['memphis.edu'],
        web_pages: ['http://www.memphis.edu/'],
        alpha_two_code: 'US',
        name: 'University of Memphis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['miami.edu'],
        web_pages: ['http://welcome.miami.edu/'],
        alpha_two_code: 'US',
        name: 'University of Miami',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umich.edu'],
        web_pages: ['http://www.umich.edu/'],
        alpha_two_code: 'US',
        name: 'University of Michigan - Ann Arbor',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umdearborn.edu'],
        web_pages: ['http://www.umdearborn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Michigan - Dearborn',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umflint.edu'],
        web_pages: ['http://www.umflint.edu'],
        alpha_two_code: 'US',
        name: 'University of Michigan-Flint',
        'state-province': 'MI',
    },
    {
        country: 'United States',
        domains: ['umn.edu'],
        web_pages: ['http://www.umn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Minnesota',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['crk.umn.edu'],
        web_pages: ['http://www.crk.umn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Minnesota - Crookston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['d.umn.edu'],
        web_pages: ['http://www.d.umn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Minnesota - Duluth',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['mrs.umn.edu'],
        web_pages: ['http://www.mrs.umn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Minnesota - Morris',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umn.edu'],
        web_pages: ['http://twin-cities.umn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Minnesota - Twin Cities',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['olemiss.edu'],
        web_pages: ['http://www.olemiss.edu/'],
        alpha_two_code: 'US',
        name: 'University of Mississippi',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umc.edu'],
        web_pages: ['http://www.umc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Mississippi Medical Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['missouri.edu', 'umsystem.edu'],
        web_pages: ['http://www.missouri.edu/'],
        alpha_two_code: 'US',
        name: 'University of Missouri',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umkc.edu'],
        web_pages: ['http://www.umkc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Missouri - Kansas City',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umr.edu'],
        web_pages: ['http://www.umr.edu/'],
        alpha_two_code: 'US',
        name: 'University of Missouri - Rolla',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umsl.edu'],
        web_pages: ['http://www.umsl.edu/'],
        alpha_two_code: 'US',
        name: 'University of Missouri - Saint Louis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['umt.edu'],
        web_pages: ['http://www.umt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Montana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unk.edu'],
        web_pages: ['http://www.unk.edu/'],
        alpha_two_code: 'US',
        name: 'University of Nebraska, Kearney',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unl.edu'],
        web_pages: ['http://www.unl.edu/'],
        alpha_two_code: 'US',
        name: 'University of Nebraska, Lincoln',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unomaha.edu'],
        web_pages: ['http://www.unomaha.edu/'],
        alpha_two_code: 'US',
        name: 'University of Nebraska, Omaha',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unlv.edu'],
        web_pages: ['http://www.unlv.edu/'],
        alpha_two_code: 'US',
        name: 'University of Nevada, Las Vegas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unr.edu'],
        web_pages: ['http://www.unr.edu/'],
        alpha_two_code: 'US',
        name: 'University of Nevada, Reno',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['une.edu'],
        web_pages: ['http://www.une.edu/'],
        alpha_two_code: 'US',
        name: 'University of New England',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unh.edu'],
        web_pages: ['http://www.unh.edu/'],
        alpha_two_code: 'US',
        name: 'University of New Hampshire, Durham',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['newhaven.edu'],
        web_pages: ['http://www.newhaven.edu/'],
        alpha_two_code: 'US',
        name: 'University of New Haven',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unm.edu'],
        web_pages: ['http://www.unm.edu/'],
        alpha_two_code: 'US',
        name: 'University of New Mexico',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uno.edu'],
        web_pages: ['http://www.uno.edu/'],
        alpha_two_code: 'US',
        name: 'University of New Orleans',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unca.edu'],
        web_pages: ['http://www.unca.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Carolina at Asheville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unc.edu', 'ad.unc.edu'],
        web_pages: ['http://www.unc.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Carolina at Chapel Hill',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uncc.edu'],
        web_pages: ['http://www.uncc.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Carolina at Charlotte',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uncg.edu'],
        web_pages: ['http://www.uncg.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Carolina at Greensboro',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uncw.edu'],
        web_pages: ['http://uncw.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Carolina at Wilmington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['und.edu'],
        web_pages: ['http://und.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Dakota',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unf.edu'],
        web_pages: ['http://www.unf.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ung.edu'],
        web_pages: ['http://www.ung.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Georgia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unt.edu'],
        web_pages: ['http://www.unt.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Texas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['hsc.unt.edu', 'unthsc.edu'],
        web_pages: ['http://www.hsc.unt.edu/'],
        alpha_two_code: 'US',
        name: 'University of North Texas Health Science Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['unco.edu'],
        web_pages: ['http://www.unco.edu/'],
        alpha_two_code: 'US',
        name: 'University of Northern Colorado',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uni.edu'],
        web_pages: ['http://www.uni.edu/'],
        alpha_two_code: 'US',
        name: 'University of Northern Iowa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['nd.edu'],
        web_pages: ['http://www.nd.edu/'],
        alpha_two_code: 'US',
        name: 'University of Notre Dame',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ou.edu'],
        web_pages: ['http://www.ou.edu/'],
        alpha_two_code: 'US',
        name: 'University of Oklahoma',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uoregon.edu'],
        web_pages: ['http://www.uoregon.edu/'],
        alpha_two_code: 'US',
        name: 'University of Oregon',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['upenn.edu', 'seas.upenn.edu'],
        web_pages: ['http://www.upenn.edu/'],
        alpha_two_code: 'US',
        name: 'University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['phoenix.edu'],
        web_pages: ['http://www.phoenix.edu/'],
        alpha_two_code: 'US',
        name: 'University of Phoenix',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['pitt.edu'],
        web_pages: ['http://www.pitt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Pittsburgh',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['upb.pitt.edu'],
        web_pages: ['https://www.upb.pitt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Pittsburgh at Bradford',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['upj.pitt.edu'],
        web_pages: ['http://www.upj.pitt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Pittsburgh at Johnstown',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['upmc.edu', 'upmc.com'],
        web_pages: ['https://www.upmc.com/'],
        alpha_two_code: 'US',
        name: 'University of Pittsburgh Medical Center',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['upt.pitt.edu'],
        web_pages: ['http://www.upt.pitt.edu'],
        alpha_two_code: 'US',
        name: 'University of Pittsburgh-​Titusville',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['up.edu'],
        web_pages: ['http://www.up.edu/'],
        alpha_two_code: 'US',
        name: 'University of Portland',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['upr.edu'],
        web_pages: ['http://www.upr.edu/'],
        alpha_two_code: 'US',
        name: 'University of Puerto Rico',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ups.edu'],
        web_pages: ['http://www.ups.edu/'],
        alpha_two_code: 'US',
        name: 'University of Puget Sound',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uor.edu'],
        web_pages: ['http://www.uor.edu/'],
        alpha_two_code: 'US',
        name: 'University of Redlands',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uri.edu'],
        web_pages: ['http://www.uri.edu/'],
        alpha_two_code: 'US',
        name: 'University of Rhode Island',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['urich.edu'],
        web_pages: ['http://www.urich.edu/'],
        alpha_two_code: 'US',
        name: 'University of Richmond',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['rochester.edu'],
        web_pages: ['http://www.rochester.edu/'],
        alpha_two_code: 'US',
        name: 'University of Rochester',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stthomas.edu'],
        web_pages: ['http://www.stthomas.edu/'],
        alpha_two_code: 'US',
        name: 'University of Saint Thomas (MN)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['stthom.edu'],
        web_pages: ['http://www.stthom.edu/'],
        alpha_two_code: 'US',
        name: 'University of Saint Thomas (TX)',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sandiego.edu'],
        web_pages: ['http://www.sandiego.edu/'],
        alpha_two_code: 'US',
        name: 'University of San Diego',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usfca.edu'],
        web_pages: ['http://www.usfca.edu/'],
        alpha_two_code: 'US',
        name: 'University of San Francisco',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usao.edu'],
        web_pages: ['http://usao.edu/'],
        alpha_two_code: 'US',
        name: 'University of Science & Arts of Oklahoma',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['scranton.edu'],
        web_pages: ['http://www.scranton.edu/'],
        alpha_two_code: 'US',
        name: 'University of Scranton',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usouixfalls.edu'],
        web_pages: ['http://www.usouixfalls.edu/'],
        alpha_two_code: 'US',
        name: 'University of Sioux Falls',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['southalabama.edu'],
        web_pages: ['http://www.southalabama.edu/'],
        alpha_two_code: 'US',
        name: 'University of South Alabama',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['sc.edu'],
        web_pages: ['http://www.sc.edu/'],
        alpha_two_code: 'US',
        name: 'University of South Carolina',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usca.edu'],
        web_pages: ['http://www.usca.edu/'],
        alpha_two_code: 'US',
        name: 'University of South Carolina - Aiken',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usd.edu'],
        web_pages: ['http://www.usd.edu/'],
        alpha_two_code: 'US',
        name: 'University of South Dakota',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usf.edu'],
        web_pages: ['http://www.usf.edu/'],
        alpha_two_code: 'US',
        name: 'University of South Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usc.edu'],
        web_pages: ['http://www.usc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Southern California',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usi.edu'],
        web_pages: ['http://www.usi.edu/'],
        alpha_two_code: 'US',
        name: 'University of Southern Indiana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usm.maine.edu'],
        web_pages: ['http://www.usm.maine.edu/'],
        alpha_two_code: 'US',
        name: 'University of Southern Maine',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usm.edu'],
        web_pages: ['http://www.usm.edu/'],
        alpha_two_code: 'US',
        name: 'University of Southern Mississippi',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usl.edu'],
        web_pages: ['http://www.usl.edu/'],
        alpha_two_code: 'US',
        name: 'University of Southwestern Louisiana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ut.edu'],
        web_pages: ['http://www.ut.edu/'],
        alpha_two_code: 'US',
        name: 'University of Tampa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utc.edu'],
        web_pages: ['http://www.utc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Tennessee at Chattanooga',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utk.edu'],
        web_pages: ['http://www.utk.edu/'],
        alpha_two_code: 'US',
        name: 'University of Tennessee, Knoxville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utm.edu'],
        web_pages: ['http://www.utm.edu/'],
        alpha_two_code: 'US',
        name: 'University of Tennessee, Martin',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['panam.edu'],
        web_pages: ['http://www.panam.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas - Pan American',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uta.edu'],
        web_pages: ['http://www.uta.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at Arlington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utexas.edu'],
        web_pages: ['http://www.utexas.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at Austin',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utb.edu'],
        web_pages: ['http://www.utb.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at Brownsville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utd.edu', 'utdallas.edu'],
        web_pages: ['http://www.utdallas.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at Dallas',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utep.edu'],
        web_pages: ['http://www.utep.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at El Paso',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utsa.edu'],
        web_pages: ['http://www.utsa.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at San Antonio',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uttyler.edu'],
        web_pages: ['http://www.uttyler.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas at Tyler',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utmb.edu'],
        web_pages: ['http://www.utmb.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas Medical Branch',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utpb.edu'],
        web_pages: ['http://www.utpb.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas Permian Basin',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utrgv.edu'],
        web_pages: ['http://www.utrgv.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas Rio Grande Valley',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['swmed.edu', 'utsouthwestern.edu'],
        web_pages: ['http://www.swmed.edu/', 'http://www.utsouthwestern.edu/'],
        alpha_two_code: 'US',
        name: 'University of Texas Southwestern Medical Center',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['udc.edu'],
        web_pages: ['http://www.udc.edu/'],
        alpha_two_code: 'US',
        name: 'University of the District of Columbia',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uiw.edu', 'uiwtx.edu'],
        web_pages: ['http://www.uiw.edu/', 'http://www.uiwtx.edu/'],
        alpha_two_code: 'US',
        name: 'University of the Incarnate Word',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ozarks.edu'],
        web_pages: ['http://www.ozarks.edu/'],
        alpha_two_code: 'US',
        name: 'University of the Ozarks',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uop.edu', 'pacific.edu'],
        web_pages: ['http://www.uop.edu/', 'http://www.pacific.edu/'],
        alpha_two_code: 'US',
        name: 'University of the Pacific',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uopeople.edu'],
        web_pages: ['http://www.uopeople.edu/'],
        alpha_two_code: 'US',
        name: 'University of the People',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uvi.edu'],
        web_pages: ['http://www.uvi.edu/'],
        alpha_two_code: 'US',
        name: 'University of the Virgin Islands',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utoledo.edu'],
        web_pages: ['http://www.utoledo.edu/'],
        alpha_two_code: 'US',
        name: 'University of Toledo',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utulsa.edu'],
        web_pages: ['http://utulsa.edu/'],
        alpha_two_code: 'US',
        name: 'University of Tulsa',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utah.edu'],
        web_pages: ['http://www.utah.edu/'],
        alpha_two_code: 'US',
        name: 'University of Utah',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uvm.edu'],
        web_pages: ['http://www.uvm.edu/'],
        alpha_two_code: 'US',
        name: 'University of Vermont',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['virginia.edu'],
        web_pages: ['http://www.virginia.edu/'],
        alpha_two_code: 'US',
        name: 'University of Virginia, Charlottesville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uw.edu', 'washington.edu'],
        web_pages: ['http://www.washington.edu/'],
        alpha_two_code: 'US',
        name: 'University of Washington',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westal.edu'],
        web_pages: ['http://www.westal.edu/'],
        alpha_two_code: 'US',
        name: 'University of West Alabama',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwf.edu'],
        web_pages: ['http://www.uwf.edu/'],
        alpha_two_code: 'US',
        name: 'University of West Florida',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwec.edu'],
        web_pages: ['http://www.uwec.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Eau Claire',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwgb.edu'],
        web_pages: ['http://www.uwgb.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Green Bay',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwlax.edu'],
        web_pages: ['http://www.uwlax.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - LaCrosse',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wisc.edu'],
        web_pages: ['http://www.wisc.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Madison',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwm.edu'],
        web_pages: ['http://www.uwm.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Milwaukee',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwosh.edu'],
        web_pages: ['http://www.uwosh.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Oshkosh',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwp.edu'],
        web_pages: ['http://www.uwp.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Parkside',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwplatt.edu'],
        web_pages: ['http://www.uwplatt.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Platteville',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwrf.edu'],
        web_pages: ['http://www.uwrf.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - River Falls',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwsp.edu'],
        web_pages: ['http://www.uwsp.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Stevens Point',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwstout.edu'],
        web_pages: ['http://www.uwstout.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Stout',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwsuper.edu'],
        web_pages: ['http://www.uwsuper.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Superior',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uww.edu'],
        web_pages: ['http://www.uww.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin - Whitewater',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwc.edu'],
        web_pages: ['http://www.uwc.edu'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin Colleges',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwsa.edu'],
        web_pages: ['http://www.uwsa.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wisconsin System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uwyo.edu'],
        web_pages: ['http://www.uwyo.edu/'],
        alpha_two_code: 'US',
        name: 'University of Wyoming',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uiu.edu'],
        web_pages: ['http://www.uiu.edu/'],
        alpha_two_code: 'US',
        name: 'Upper Iowa University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['urbancollege.edu'],
        web_pages: ['http://www.urbancollege.edu'],
        alpha_two_code: 'US',
        name: 'Urban College of Boston',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ursinus.edu'],
        web_pages: ['http://www.ursinus.edu/'],
        alpha_two_code: 'US',
        name: 'Ursinus College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['usu.edu'],
        web_pages: ['http://www.usu.edu/'],
        alpha_two_code: 'US',
        name: 'Utah State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uvsc.edu'],
        web_pages: ['http://www.uvsc.edu/'],
        alpha_two_code: 'US',
        name: 'Utah Valley State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['uvu.edu'],
        web_pages: ['https://uvu.edu/'],
        alpha_two_code: 'US',
        name: 'Utah Valley Uniersity',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['utica.edu'],
        web_pages: ['http://www.utica.edu/'],
        alpha_two_code: 'US',
        name: 'Utica College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['valdosta.edu'],
        web_pages: ['http://www.valdosta.edu/'],
        alpha_two_code: 'US',
        name: 'Valdosta State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['valenciacollege.edu'],
        web_pages: ['http://www.valenciacollege.edu/'],
        alpha_two_code: 'US',
        name: 'Valencia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vcsu.nodak.edu'],
        web_pages: ['http://www.vcsu.nodak.edu/home.html'],
        alpha_two_code: 'US',
        name: 'Valley City State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vfmac.edu'],
        web_pages: ['http://www.vfmac.edu'],
        alpha_two_code: 'US',
        name: 'Valley Forge Military Academy and College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['valpo.edu'],
        web_pages: ['http://www.valpo.edu/'],
        alpha_two_code: 'US',
        name: 'Valparaiso University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vgcc.edu'],
        web_pages: ['http://www.vgcc.edu/'],
        alpha_two_code: 'US',
        name: 'Vance-Granville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vanderbilt.edu'],
        web_pages: ['http://www.vanderbilt.edu/'],
        alpha_two_code: 'US',
        name: 'Vanderbilt University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vassar.edu'],
        web_pages: ['http://www.vassar.edu/'],
        alpha_two_code: 'US',
        name: 'Vassar College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['venturacollege.edu'],
        web_pages: ['http://www.venturacollege.edu/'],
        alpha_two_code: 'US',
        name: 'Ventura College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vcc.edu'],
        web_pages: ['http://www.vcc.edu'],
        alpha_two_code: 'US',
        name: 'Vermilion Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vtc.edu'],
        web_pages: ['http://www.vtc.edu/'],
        alpha_two_code: 'US',
        name: 'Vermont Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vernoncollege.edu'],
        web_pages: ['http://www.vernoncollege.edu'],
        alpha_two_code: 'US',
        name: 'Vernon College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vvc.edu'],
        web_pages: ['http://www.vvc.edu'],
        alpha_two_code: 'US',
        name: 'Victor Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['victoriacollege.edu'],
        web_pages: ['http://www.victoriacollege.edu'],
        alpha_two_code: 'US',
        name: 'Victoria College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vjc.edu'],
        web_pages: ['http://www.vjc.edu/'],
        alpha_two_code: 'US',
        name: 'Villa Julie College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['villanova.edu'],
        web_pages: ['http://www.villanova.edu/'],
        alpha_two_code: 'US',
        name: 'Villanova University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vcu.edu'],
        web_pages: ['http://vcu.vcu.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Commonwealth University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vccs.edu'],
        web_pages: ['http://www.vccs.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Community College System',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vhcc.edu'],
        web_pages: ['http://www.vhcc.edu'],
        alpha_two_code: 'US',
        name: 'Virginia Highlands Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vic.edu'],
        web_pages: ['http://www.vic.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Intermont College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vmi.edu'],
        web_pages: ['http://www.vmi.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Military Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vt.edu'],
        web_pages: ['http://www.vt.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Polytechnic Institute and State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vsu.edu'],
        web_pages: ['http://www.vsu.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vwc.edu'],
        web_pages: ['http://www.vwc.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Wesleyan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['virginiawestern.edu'],
        web_pages: ['http://virginiawestern.edu/'],
        alpha_two_code: 'US',
        name: 'Virginia Western Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['volstate.edu'],
        web_pages: ['http://www.volstate.edu'],
        alpha_two_code: 'US',
        name: 'Volunteer State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wabash.edu'],
        web_pages: ['http://www.wabash.edu/'],
        alpha_two_code: 'US',
        name: 'Wabash College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wagner.edu'],
        web_pages: ['https://wagner.edu/'],
        alpha_two_code: 'US',
        name: 'Wagner College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wakehealth.edu'],
        web_pages: ['http://www.wakehealth.edu/'],
        alpha_two_code: 'US',
        name: 'Wake Forest Baptist Health',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wfu.edu'],
        web_pages: ['http://www.wfu.edu/'],
        alpha_two_code: 'US',
        name: 'Wake Forest University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waketech.edu'],
        web_pages: ['http://www.waketech.edu/'],
        alpha_two_code: 'US',
        name: 'Wake Technical Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waldenu.edu'],
        web_pages: ['http://www.waldenu.edu/'],
        alpha_two_code: 'US',
        name: 'Walden University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wwcc.edu'],
        web_pages: ['http://www.wwcc.edu/'],
        alpha_two_code: 'US',
        name: 'Walla Walla Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wallawalla.edu'],
        web_pages: ['http://www.wallawalla.edu/'],
        alpha_two_code: 'US',
        name: 'Walla Walla University',
        'state-province': 'Washington',
    },
    {
        country: 'United States',
        domains: ['walshcollege.edu'],
        web_pages: ['http://www.walshcollege.edu/'],
        alpha_two_code: 'US',
        name: 'Walsh College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ws.edu'],
        web_pages: ['http://www.ws.edu'],
        alpha_two_code: 'US',
        name: 'Walters State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['warren.edu'],
        web_pages: ['http://www.warren.edu'],
        alpha_two_code: 'US',
        name: 'Warren County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['warren-wilson.edu'],
        web_pages: ['http://www.warren-wilson.edu/'],
        alpha_two_code: 'US',
        name: 'Warren Wilson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wartburg.edu'],
        web_pages: ['http://www.wartburg.edu/'],
        alpha_two_code: 'US',
        name: 'Wartburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wuacc.edu'],
        web_pages: ['http://www.wuacc.edu/'],
        alpha_two_code: 'US',
        name: 'Washburn University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['washjeff.edu'],
        web_pages: ['http://www.washjeff.edu/'],
        alpha_two_code: 'US',
        name: 'Washington & Jefferson College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wlu.edu'],
        web_pages: ['http://www.wlu.edu/'],
        alpha_two_code: 'US',
        name: 'Washington & Lee University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['bible.edu'],
        web_pages: ['http://www.bible.edu/'],
        alpha_two_code: 'US',
        name: 'Washington Bible College/Capital Bible Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['washcoll.edu'],
        web_pages: ['http://www.washcoll.edu/'],
        alpha_two_code: 'US',
        name: 'Washington College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wccc.me.edu'],
        web_pages: ['http://www.wccc.me.edu'],
        alpha_two_code: 'US',
        name: 'Washington County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wscc.edu'],
        web_pages: ['http://www.wscc.edu'],
        alpha_two_code: 'US',
        name: 'Washington State Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wsu.edu'],
        web_pages: ['http://www.wsu.edu/'],
        alpha_two_code: 'US',
        name: 'Washington State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wsu.edu'],
        web_pages: ['http://www.tricity.wsu.edu/'],
        alpha_two_code: 'US',
        name: 'Washington State University at Tri-Cities',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['vancouver.wsu.edu'],
        web_pages: ['http://www.vancouver.wsu.edu/'],
        alpha_two_code: 'US',
        name: 'Washington State University at Vancouver',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wustl.edu'],
        web_pages: ['http://www.wustl.edu/'],
        alpha_two_code: 'US',
        name: 'Washington University, Saint Louis',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wccnet.edu'],
        web_pages: ['http://www.wccnet.edu'],
        alpha_two_code: 'US',
        name: 'Washtenaw Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waubonsee.edu'],
        web_pages: ['http://www.waubonsee.edu/'],
        alpha_two_code: 'US',
        name: 'Waubonsee Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wctc.edu'],
        web_pages: ['http://www.wctc.edu'],
        alpha_two_code: 'US',
        name: 'Waukesha County Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wbu.edu'],
        web_pages: ['http://www.wbu.edu'],
        alpha_two_code: 'US',
        name: 'Wayland Baptist University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waynecc.edu'],
        web_pages: ['http://www.waynecc.edu'],
        alpha_two_code: 'US',
        name: 'Wayne Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcccd.edu'],
        web_pages: ['http://www.wcccd.edu'],
        alpha_two_code: 'US',
        name: 'Wayne County Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wayne.edu'],
        web_pages: ['http://www.wayne.edu/'],
        alpha_two_code: 'US',
        name: 'Wayne State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['waynesburg.edu'],
        web_pages: ['http://waynesburg.edu/'],
        alpha_two_code: 'US',
        name: 'Waynesburg College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wc.edu'],
        web_pages: ['http://www.wc.edu'],
        alpha_two_code: 'US',
        name: 'Weatherford College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['weber.edu'],
        web_pages: ['http://www.weber.edu/'],
        alpha_two_code: 'US',
        name: 'Weber State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['webster.edu'],
        web_pages: ['http://www.webster.edu/'],
        alpha_two_code: 'US',
        name: 'Webster University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wellesley.edu'],
        web_pages: ['http://www.wellesley.edu/'],
        alpha_two_code: 'US',
        name: 'Wellesley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wells.edu'],
        web_pages: ['http://www.wells.edu/'],
        alpha_two_code: 'US',
        name: 'Wells College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wvc.edu'],
        web_pages: ['http://www.wvc.edu'],
        alpha_two_code: 'US',
        name: 'Wenatchee Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wit.edu'],
        web_pages: ['http://www.wit.edu/'],
        alpha_two_code: 'US',
        name: 'Wentworth Institute of Technology',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wma.edu'],
        web_pages: ['http://www.wma.edu'],
        alpha_two_code: 'US',
        name: 'Wentworth Military Academy & Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wesley.edu'],
        web_pages: ['http://www.wesley.edu/'],
        alpha_two_code: 'US',
        name: 'Wesley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wesleyan.edu'],
        web_pages: ['http://www.wesleyan.edu/'],
        alpha_two_code: 'US',
        name: 'Wesleyan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcupa.edu'],
        web_pages: ['http://www.wcupa.edu/'],
        alpha_two_code: 'US',
        name: 'West Chester University of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['westcoastuniversity.edu'],
        web_pages: ['http://westcoastuniversity.edu/'],
        alpha_two_code: 'US',
        name: 'West Coast University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westga.edu'],
        web_pages: ['http://www.westga.edu/'],
        alpha_two_code: 'US',
        name: 'West Georgia College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westgatech.edu'],
        web_pages: ['http://www.westgatech.edu'],
        alpha_two_code: 'US',
        name: 'West Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westhillscollege.com'],
        web_pages: ['http://www.westhillscollege.com'],
        alpha_two_code: 'US',
        name: 'West Hills College-​Coalinga',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westkentucky.kctcs.edu'],
        web_pages: ['http://www.westkentucky.kctcs.edu'],
        alpha_two_code: 'US',
        name: 'West Kentucky Community and Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wlsc.wvnet.edu'],
        web_pages: ['http://www.wlsc.wvnet.edu/'],
        alpha_two_code: 'US',
        name: 'West Liberty State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wlac.edu'],
        web_pages: ['http://www.wlac.edu'],
        alpha_two_code: 'US',
        name: 'West Los Angeles College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westshore.edu'],
        web_pages: ['http://www.westshore.edu'],
        alpha_two_code: 'US',
        name: 'West Shore Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wtamu.edu'],
        web_pages: ['http://www.wtamu.edu/'],
        alpha_two_code: 'US',
        name: 'West Texas A&M University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westvalley.edu'],
        web_pages: ['http://www.westvalley.edu'],
        alpha_two_code: 'US',
        name: 'West Valley College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wvncc.edu'],
        web_pages: ['http://www.wvncc.edu/'],
        alpha_two_code: 'US',
        name: 'West Virginia Northern Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wvu.edu'],
        web_pages: ['http://www.wvu.edu/'],
        alpha_two_code: 'US',
        name: 'West Virginia University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westliberty.edu'],
        web_pages: ['http://www.westliberty.edu/'],
        alpha_two_code: 'US',
        name: 'West Virginia University at Parkersburg',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wvwc.edu'],
        web_pages: ['http://www.wvwc.edu/'],
        alpha_two_code: 'US',
        name: 'West Virginia Wesleyan College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcu.edu'],
        web_pages: ['http://www.wcu.edu/'],
        alpha_two_code: 'US',
        name: 'Western Carolina University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcsu.edu'],
        web_pages: ['http://www.wcsu.edu/'],
        alpha_two_code: 'US',
        name: 'Western Connecticut State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wdt.edu'],
        web_pages: ['https://www.wdt.edu'],
        alpha_two_code: 'US',
        name: 'Western Dakota Technical Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wgu.edu'],
        web_pages: ['http://www.wgu.edu/'],
        alpha_two_code: 'US',
        name: 'Western Governors University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wiu.edu'],
        web_pages: ['http://www.wiu.edu/'],
        alpha_two_code: 'US',
        name: 'Western Illinois University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['witcc.edu'],
        web_pages: ['http://www.witcc.edu'],
        alpha_two_code: 'US',
        name: 'Western Iowa Tech Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wku.edu'],
        web_pages: ['http://www.wku.edu/'],
        alpha_two_code: 'US',
        name: 'Western Kentucky University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmich.edu'],
        web_pages: ['http://www.wmich.edu/'],
        alpha_two_code: 'US',
        name: 'Western Michigan University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmc.edu'],
        web_pages: ['http://www.wmc.edu/'],
        alpha_two_code: 'US',
        name: 'Western Montana College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wncc.edu'],
        web_pages: ['http://www.wncc.edu'],
        alpha_two_code: 'US',
        name: 'Western Nebraska Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wnec.edu'],
        web_pages: ['http://www.wnec.edu/'],
        alpha_two_code: 'US',
        name: 'Western New England College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wne.edu'],
        web_pages: ['http://www1.wne.edu/'],
        alpha_two_code: 'US',
        name: 'Western New England University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wnmu.edu'],
        web_pages: ['http://www.wnmu.edu/'],
        alpha_two_code: 'US',
        name: 'Western New Mexico University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wosc.edu'],
        web_pages: ['http://www.wosc.edu'],
        alpha_two_code: 'US',
        name: 'Western Oklahoma State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wpcc.edu'],
        web_pages: ['http://www.wpcc.edu'],
        alpha_two_code: 'US',
        name: 'Western Piedmont Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['western.edu'],
        web_pages: ['http://www.western.edu/'],
        alpha_two_code: 'US',
        name: 'Western State Colorado University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westerntc.edu'],
        web_pages: ['http://www.westerntc.edu'],
        alpha_two_code: 'US',
        name: 'Western Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wtc.edu'],
        web_pages: ['http://www.wtc.edu'],
        alpha_two_code: 'US',
        name: 'Western Texas College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wwu.edu'],
        web_pages: ['http://www.wwu.edu/'],
        alpha_two_code: 'US',
        name: 'Western Washington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wwcc.wy.edu'],
        web_pages: ['http://www.wwcc.wy.edu'],
        alpha_two_code: 'US',
        name: 'Western Wyoming Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westfield.mass.edu'],
        web_pages: ['http://www.westfield.mass.edu/'],
        alpha_two_code: 'US',
        name: 'Westfield State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westminster.edu'],
        web_pages: ['http://www.westminster.edu/'],
        alpha_two_code: 'US',
        name: 'Westminster College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcslc.edu'],
        web_pages: ['http://www.wcslc.edu/'],
        alpha_two_code: 'US',
        name: 'Westminster College of Salt Lake City',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wts.edu'],
        web_pages: ['http://www.wts.edu/'],
        alpha_two_code: 'US',
        name: 'Westminster Theological Seminary',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['westmont.edu'],
        web_pages: ['http://www.westmont.edu/'],
        alpha_two_code: 'US',
        name: 'Westmont College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wccc.edu'],
        web_pages: ['http://wccc.edu'],
        alpha_two_code: 'US',
        name: 'Westmoreland County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcjc.edu'],
        web_pages: ['http://www.wcjc.edu'],
        alpha_two_code: 'US',
        name: 'Wharton County Junior College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['whatcom.ctc.edu'],
        web_pages: ['http://www.whatcom.ctc.edu'],
        alpha_two_code: 'US',
        name: 'Whatcom Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wheaton.edu'],
        web_pages: ['http://www.wheaton.edu/'],
        alpha_two_code: 'US',
        name: 'Wheaton College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wheatonma.edu'],
        web_pages: ['http://www.wheatonma.edu/'],
        alpha_two_code: 'US',
        name: 'Wheaton College, Norton MA',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wjc.edu'],
        web_pages: ['http://www.wjc.edu/'],
        alpha_two_code: 'US',
        name: 'Wheeling Jesuit College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wetcc.edu'],
        web_pages: ['http://www.wetcc.edu'],
        alpha_two_code: 'US',
        name: 'White Earth Tribal and Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmcc.edu'],
        web_pages: ['http://www.wmcc.edu'],
        alpha_two_code: 'US',
        name: 'White Mountains Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['whitman.edu'],
        web_pages: ['http://www.whitman.edu/'],
        alpha_two_code: 'US',
        name: 'Whitman College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['whittier.edu'],
        web_pages: ['http://www.whittier.edu/'],
        alpha_two_code: 'US',
        name: 'Whittier College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['whitworth.edu'],
        web_pages: ['http://www.whitworth.edu/'],
        alpha_two_code: 'US',
        name: 'Whitworth College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['watc.edu'],
        web_pages: ['http://www.watc.edu'],
        alpha_two_code: 'US',
        name: 'Wichita Area Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wichita.edu'],
        web_pages: ['http://www.wichita.edu/'],
        alpha_two_code: 'US',
        name: 'Wichita State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['widener.edu'],
        web_pages: ['http://www.widener.edu/'],
        alpha_two_code: 'US',
        name: 'Widener University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilberforce.edu'],
        web_pages: ['http://www.wilberforce.edu/'],
        alpha_two_code: 'US',
        name: 'Wilberforce University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilkescc.edu'],
        web_pages: ['http://www.wilkescc.edu'],
        alpha_two_code: 'US',
        name: 'Wilkes Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilkes.edu'],
        web_pages: ['http://www.wilkes.edu/'],
        alpha_two_code: 'US',
        name: 'Wilkes University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['willamette.edu'],
        web_pages: ['http://www.willamette.edu/'],
        alpha_two_code: 'US',
        name: 'Willamette University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['taftu.edu'],
        web_pages: ['http://www.taftu.edu/'],
        alpha_two_code: 'US',
        name: 'William Howard Taft University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['jewell.edu'],
        web_pages: ['http://www.jewell.edu/'],
        alpha_two_code: 'US',
        name: 'William Jewell College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmitchell.edu'],
        web_pages: ['http://www.wmitchell.edu/'],
        alpha_two_code: 'US',
        name: 'William Mitchell College of Law',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wpunj.edu'],
        web_pages: ['http://www.wpunj.edu/'],
        alpha_two_code: 'US',
        name: 'William Paterson University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmpenn.edu'],
        web_pages: ['http://www.wmpenn.edu/'],
        alpha_two_code: 'US',
        name: 'William Penn College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wmwoods.edu'],
        web_pages: ['http://www.wmwoods.edu/'],
        alpha_two_code: 'US',
        name: 'William Woods University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['williams.edu'],
        web_pages: ['http://www.williams.edu/'],
        alpha_two_code: 'US',
        name: 'Williams College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wiltech.edu'],
        web_pages: ['http://www.wiltech.edu'],
        alpha_two_code: 'US',
        name: 'Williamsburg Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['willistonstate.edu'],
        web_pages: ['http://www.willistonstate.edu'],
        alpha_two_code: 'US',
        name: 'Williston State College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilmington.edu'],
        web_pages: ['http://www.wilmington.edu/'],
        alpha_two_code: 'US',
        name: 'Wilmington College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilmu.edu'],
        web_pages: ['https://www.wilmu.edu/'],
        alpha_two_code: 'US',
        name: 'Wilmington University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wilsoncc.edu'],
        web_pages: ['http://www.wilsoncc.edu'],
        alpha_two_code: 'US',
        name: 'Wilson Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['windward.hawaii.edu'],
        web_pages: ['http://windward.hawaii.edu'],
        alpha_two_code: 'US',
        name: 'Windward Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['winona.edu'],
        web_pages: ['https://www.winona.edu/'],
        alpha_two_code: 'US',
        name: 'Winona State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['winthrop.edu'],
        web_pages: ['http://www.winthrop.edu/'],
        alpha_two_code: 'US',
        name: 'Winthrop University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wiregrass.edu'],
        web_pages: ['http://www.wiregrass.edu'],
        alpha_two_code: 'US',
        name: 'Wiregrass Georgia Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['witc.edu'],
        web_pages: ['http://www.witc.edu'],
        alpha_two_code: 'US',
        name: 'Wisconsin Indianhead Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wlc.edu'],
        web_pages: ['http://www.wlc.edu/'],
        alpha_two_code: 'US',
        name: 'Wisconsin Lutheran College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wittenberg.edu'],
        web_pages: ['http://www.wittenberg.edu/'],
        alpha_two_code: 'US',
        name: 'Wittenberg University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wofford.edu'],
        web_pages: ['http://www.wofford.edu/'],
        alpha_two_code: 'US',
        name: 'Wofford College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['woodbury.edu'],
        web_pages: ['http://www.woodbury.edu/'],
        alpha_two_code: 'US',
        name: 'Woodbury University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcc.yccd.edu'],
        web_pages: ['http://wcc.yccd.edu'],
        alpha_two_code: 'US',
        name: 'Woodland Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['worwic.edu'],
        web_pages: ['http://www.worwic.edu'],
        alpha_two_code: 'US',
        name: 'Wor-​Wic Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wpi.edu'],
        web_pages: ['http://www.wpi.edu/'],
        alpha_two_code: 'US',
        name: 'Worcester Polytechnic Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wright.edu'],
        web_pages: ['http://www.wright.edu/'],
        alpha_two_code: 'US',
        name: 'Wright State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['wcc.vccs.edu'],
        web_pages: ['http://www.wcc.vccs.edu'],
        alpha_two_code: 'US',
        name: 'Wytheville Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['xavier.edu'],
        web_pages: ['https://www.xavier.edu/'],
        alpha_two_code: 'US',
        name: 'Xavier University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['xula.edu'],
        web_pages: ['http://www.xula.edu/'],
        alpha_two_code: 'US',
        name: 'Xavier University of Louisiana',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yvcc.edu'],
        web_pages: ['http://www.yvcc.edu'],
        alpha_two_code: 'US',
        name: 'Yakima Valley Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yale.edu'],
        web_pages: ['http://www.yale.edu/'],
        alpha_two_code: 'US',
        name: 'Yale University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yc.edu'],
        web_pages: ['http://www.YC.EDU'],
        alpha_two_code: 'US',
        name: 'Yavapai College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yu.edu'],
        web_pages: ['http://www.yu.edu/'],
        alpha_two_code: 'US',
        name: 'Yeshiva University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ycp.edu'],
        web_pages: ['http://www.ycp.edu/'],
        alpha_two_code: 'US',
        name: 'York College of Pennsylvania',
        'state-province': 'Pennsylvania',
    },
    {
        country: 'United States',
        domains: ['yccc.edu'],
        web_pages: ['http://www.yccc.edu'],
        alpha_two_code: 'US',
        name: 'York County Community College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yorktech.edu'],
        web_pages: ['http://www.yorktech.edu'],
        alpha_two_code: 'US',
        name: 'York Technical College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yosemite.edu'],
        web_pages: ['https://www.yosemite.edu/'],
        alpha_two_code: 'US',
        name: 'Yosemite Community College District',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yhc.edu'],
        web_pages: ['https://www.yhc.edu/'],
        alpha_two_code: 'US',
        name: 'Young Harris College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['ysu.edu'],
        web_pages: ['http://www.ysu.edu/'],
        alpha_two_code: 'US',
        name: 'Youngstown State University',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yti.edu'],
        web_pages: ['http://www.yti.edu/'],
        alpha_two_code: 'US',
        name: 'YTI Career Institute',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['yc.yccd.edu'],
        web_pages: ['http://yc.yccd.edu'],
        alpha_two_code: 'US',
        name: 'Yuba College',
        'state-province': null,
    },
    {
        country: 'United States',
        domains: ['zanestate.edu'],
        web_pages: ['http://www.zanestate.edu'],
        alpha_two_code: 'US',
        name: 'Zane State College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['lambtoncollege.ca', 'mylambton.ca'],
        web_pages: ['https://www.lambtoncollege.ca'],
        alpha_two_code: 'CA',
        name: 'Lambton College',
        'state-province': 'Sarnia',
    },
    {
        country: 'Canada',
        domains: ['acadiau.ca'],
        web_pages: ['http://www.acadiau.ca/'],
        alpha_two_code: 'CA',
        name: 'Acadia University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['algonquincollege.com'],
        web_pages: ['http://www.algonquincollege.com/'],
        alpha_two_code: 'CA',
        name: 'Algonquin College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ashtoncollege.com'],
        web_pages: ['http://www.ashtoncollege.com/'],
        alpha_two_code: 'CA',
        name: 'Ashton College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['assumptionu.ca'],
        web_pages: ['http://www.assumptionu.ca/'],
        alpha_two_code: 'CA',
        name: 'Assumption University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['athabascau.ca'],
        web_pages: ['http://www.athabascau.ca/'],
        alpha_two_code: 'CA',
        name: 'Athabasca University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['augustana.ab.ca'],
        web_pages: ['http://www.augustana.ab.ca/'],
        alpha_two_code: 'CA',
        name: 'Augustana University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['bcit.ca'],
        web_pages: ['http://www.bcit.ca/'],
        alpha_two_code: 'CA',
        name: 'British Columbia Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['bcou.ca'],
        web_pages: ['http://www.bcou.ca/'],
        alpha_two_code: 'CA',
        name: 'British Columbia Open University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['boothcollege.ca'],
        web_pages: ['http://www.boothcollege.ca/'],
        alpha_two_code: 'CA',
        name: 'William and Catherine Booth College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['borealc.on.ca'],
        web_pages: ['http://www.borealc.on.ca/'],
        alpha_two_code: 'CA',
        name: 'Coll\u00e8ge Bor\u00e9al',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['bowvalleycollege.ca'],
        web_pages: ['http://www.bowvalleycollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Bow Valley College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['brandonu.ca'],
        web_pages: ['http://www.brandonu.ca/'],
        alpha_two_code: 'CA',
        name: 'Brandon University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['brocku.ca'],
        web_pages: ['http://www.brocku.ca/'],
        alpha_two_code: 'CA',
        name: 'Brock University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cal.devry.ca'],
        web_pages: ['http://www.cal.devry.ca/'],
        alpha_two_code: 'CA',
        name: 'DeVry Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['camosun.bc.ca'],
        web_pages: ['http://www.camosun.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Camosun College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['capcollege.bc.ca'],
        web_pages: ['http://www.capcollege.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Capilano College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cariboo.bc.ca'],
        web_pages: ['http://www.cariboo.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'University College of the Cariboo',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['carleton.ca'],
        web_pages: ['http://www.carleton.ca/'],
        alpha_two_code: 'CA',
        name: 'Carleton University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ccbc.ca'],
        web_pages: ['http://www.ccbc.ca/'],
        alpha_two_code: 'CA',
        name: 'Canadian College of Business & Computers',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['centennialcollege.ca'],
        web_pages: ['http://www.centennialcollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Centennial College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cmu.ca'],
        web_pages: ['http://www.cmu.ca/'],
        alpha_two_code: 'CA',
        name: 'Canadian Mennonite University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cnc.bc.ca'],
        web_pages: ['http://www.cnc.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'College of New Caledonia',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['columbiacollege.ca'],
        web_pages: ['http://www.columbiacollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Columbia College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['concordia.ab.ca'],
        web_pages: ['http://www.concordia.ab.ca/'],
        alpha_two_code: 'CA',
        name: 'Concordia University College of Alberta',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['concordia.ca'],
        web_pages: ['http://www.concordia.ca/'],
        alpha_two_code: 'CA',
        name: 'Concordia University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['conestogac.on.ca'],
        web_pages: ['http://www.conestogac.on.ca/'],
        alpha_two_code: 'CA',
        name: 'Conestoga College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cotr.bc.ca'],
        web_pages: ['http://www.cotr.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'College of the Rockies',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cus.ca'],
        web_pages: ['http://www.cus.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Moncton, Shippagan',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cuslm.ca'],
        web_pages: ['http://www.cuslm.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Moncton, Edmundston',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['dal.ca'],
        web_pages: ['http://www.dal.ca/'],
        alpha_two_code: 'CA',
        name: 'Dalhousie University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['douglas.bc.ca'],
        web_pages: ['http://www.douglas.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Douglas College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['dcmail.ca'],
        web_pages: ['https://durhamcollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Durham College',
        'state-province': 'Ontario',
    },
    {
        country: 'Canada',
        domains: ['eciad.bc.ca'],
        web_pages: ['http://www.eciad.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Emily Carr Institute of Art + Design',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['enap.uquebec.ca'],
        web_pages: ['http://www.enap.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: "\u00c9cole nationale d'administration publique, Universit\u00e9 du Qu\u00e9bec",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['etsmtl.ca'],
        web_pages: ['http://www.etsmtl.ca/'],
        alpha_two_code: 'CA',
        name: '\u00c9cole de technologie sup\u00e9rieure, Universit\u00e9 du Qu\u00e9bec',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['firstnationsuniversity.ca'],
        web_pages: ['http://www.firstnationsuniversity.ca/'],
        alpha_two_code: 'CA',
        name: 'First Nations University of Canada',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['gbrownc.on.ca'],
        web_pages: ['http://www.gbrownc.on.ca/'],
        alpha_two_code: 'CA',
        name: 'George Brown College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['hec.ca'],
        web_pages: ['http://www.hec.ca/'],
        alpha_two_code: 'CA',
        name: '\u00c9cole des Hautes \u00c9tudes Commerciales',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['humber.ca', 'humbermail.ca'],
        web_pages: ['http://www.humber.ca/'],
        alpha_two_code: 'CA',
        name: 'Humber College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['huronuc.on.ca'],
        web_pages: ['http://www.huronuc.on.ca/'],
        alpha_two_code: 'CA',
        name: 'Huron University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['iaf.inrs.ca'],
        web_pages: ['http://www.iaf.inrs.ca/'],
        alpha_two_code: 'CA',
        name: 'Institut Armand-Frappier, Universit\u00e9 du Qu\u00e9bec',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['inrs.uquebec.ca'],
        web_pages: ['http://www.inrs.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'Institut National de la Recherche Scientifique, Universit\u00e9 du Qu\u00e9bec',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['johnabbott.qc.ca'],
        web_pages: ['http://johnabbott.qc.ca/'],
        alpha_two_code: 'CA',
        name: 'John Abbott College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['kingston.edu'],
        web_pages: ['http://www.kingston.edu/'],
        alpha_two_code: 'CA',
        name: 'Kingston College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['kingsu.ab.ca'],
        web_pages: ['http://www.kingsu.ab.ca/'],
        alpha_two_code: 'CA',
        name: "King's University College",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['kwantlen.bc.ca'],
        web_pages: ['http://www.kwantlen.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Kwantleen University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['lakeheadu.ca'],
        web_pages: ['http://www.lakeheadu.ca/'],
        alpha_two_code: 'CA',
        name: 'Lakehead University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['langara.bc.ca', 'langara.ca'],
        web_pages: ['http://www.langara.bc.ca/', 'https://langara.ca/'],
        alpha_two_code: 'CA',
        name: 'Langara College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['lansbridge.com'],
        web_pages: ['http://www.lansbridge.com/'],
        alpha_two_code: 'CA',
        name: 'Lansbridge University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['laurentian.ca'],
        web_pages: ['http://www.laurentian.ca/'],
        alpha_two_code: 'CA',
        name: 'Laurentian University of Sudbury',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['macewan.ca'],
        web_pages: ['http://www.macewan.ca/'],
        alpha_two_code: 'CA',
        name: 'MacEwan University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mala.bc.ca'],
        web_pages: ['http://www.mala.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Malaspina University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mcgill.ca'],
        web_pages: ['http://www.mcgill.ca/'],
        alpha_two_code: 'CA',
        name: 'McGill University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mcmaster.ca'],
        web_pages: ['http://www.mcmaster.ca/'],
        alpha_two_code: 'CA',
        name: 'McMaster University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['msvu.ca'],
        web_pages: ['http://www.msvu.ca/'],
        alpha_two_code: 'CA',
        name: 'Mount Saint Vincent University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mta.ca'],
        web_pages: ['http://www.mta.ca/'],
        alpha_two_code: 'CA',
        name: 'Mount Allison University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mtroyal.ca'],
        web_pages: ['http://www.mtroyal.ca/'],
        alpha_two_code: 'CA',
        name: 'Mount Royal University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nait.ca'],
        web_pages: ['http://www.nait.ca/'],
        alpha_two_code: 'CA',
        name: 'Northern Alberta Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nic.bc.ca'],
        web_pages: ['http://www.nic.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'North Island College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nipissingu.ca'],
        web_pages: ['http://www.nipissingu.ca/'],
        alpha_two_code: 'CA',
        name: 'Nipissing University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nlc.bc.ca'],
        web_pages: ['http://www.nlc.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Northern Lights College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nsac.ns.ca'],
        web_pages: ['http://www.nsac.ns.ca/'],
        alpha_two_code: 'CA',
        name: 'Nova Scotia Agricultural College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nscad.ns.ca'],
        web_pages: ['http://www.nscad.ns.ca/'],
        alpha_two_code: 'CA',
        name: 'Nova Scotia College of Art and Design',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['nvit.bc.ca'],
        web_pages: ['http://www.nvit.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Nicola Valley Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ocad.ca'],
        web_pages: ['http://www.ocad.ca/'],
        alpha_two_code: 'CA',
        name: 'Ontario College of Art and Design',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['okanagan.bc.ca'],
        web_pages: ['http://www.okanagan.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Okanagan University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['op.org'],
        web_pages: ['http://www.op.org/canada/college.htm'],
        alpha_two_code: 'CA',
        name: 'Dominican College of Philosophy and Theology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['picollege.ca'],
        web_pages: ['http://www.picollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Pacific International College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['polymtl.ca'],
        web_pages: ['http://www.polymtl.ca/'],
        alpha_two_code: 'CA',
        name: '\u00c9cole Polytechnique de Montr\u00e9al, Universit\u00e9 de Montr\u00e9al',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['queensu.ca'],
        web_pages: ['http://www.queensu.ca/'],
        alpha_two_code: 'CA',
        name: "Queen's University",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['questu.ca'],
        web_pages: ['http://www.questu.ca/'],
        alpha_two_code: 'CA',
        name: 'Quest University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['redeemer.ca'],
        web_pages: ['http://www.redeemer.ca/'],
        alpha_two_code: 'CA',
        name: 'Redeemer College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['regent-college.edu'],
        web_pages: ['http://www.regent-college.edu/'],
        alpha_two_code: 'CA',
        name: 'Regent College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['rmc.ca'],
        web_pages: ['http://www.rmc.ca/'],
        alpha_two_code: 'CA',
        name: 'Royal Military College of Canada',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['royalroads.ca'],
        web_pages: ['http://www.royalroads.ca/'],
        alpha_two_code: 'CA',
        name: 'Royal Roads University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ryerson.ca'],
        web_pages: ['http://www.ryerson.ca/'],
        alpha_two_code: 'CA',
        name: 'Ryerson Polytechnic University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['sait.ca'],
        web_pages: ['http://www.sait.ca/'],
        alpha_two_code: 'CA',
        name: 'Southern Alberta Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['saskweb.com'],
        web_pages: ['http://www.saskweb.com/luthercollege/'],
        alpha_two_code: 'CA',
        name: 'Luther College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['sauder.ubc.ca'],
        web_pages: ['http://www.sauder.ubc.ca/'],
        alpha_two_code: 'CA',
        name: 'Sauder School of Business',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['scar.utoronto.ca'],
        web_pages: ['http://www.scar.utoronto.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Toronto, Scarborough',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['selkirk.bc.ca'],
        web_pages: ['http://www.selkirk.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'Selkirk College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['senecacollege.ca', 'myseneca.ca'],
        web_pages: ['http://www.senecacollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Seneca College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['sfu.ca'],
        web_pages: ['http://www.sfu.ca/'],
        alpha_two_code: 'CA',
        name: 'Simon Fraser University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['sheridancollege.ca'],
        web_pages: ['http://www.sheridancollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Sheridan College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['sifc.edu'],
        web_pages: ['http://www.sifc.edu/'],
        alpha_two_code: 'CA',
        name: 'Saskatchewan Indian Federated College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['stclairc.on.ca', 'stclairconnect.ca', 'myscc.ca'],
        web_pages: ['http://www.stclairc.on.ca/'],
        alpha_two_code: 'CA',
        name: 'St. Clair College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['stfx.ca'],
        web_pages: ['http://www.stfx.ca/'],
        alpha_two_code: 'CA',
        name: 'St. Francis Xavier University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['stmarys.ca', 'smu.ca'],
        web_pages: ['http://www.stmarys.ca/', 'https://smu.ca/'],
        alpha_two_code: 'CA',
        name: "St. Mary's University",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['stthomasu.ca'],
        web_pages: ['http://www.stthomasu.ca/'],
        alpha_two_code: 'CA',
        name: 'St. Thomas University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['teluq.uquebec.ca'],
        web_pages: ['http://www.teluq.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'T\u00e9l\u00e9-universit\u00e9, Universit\u00e9 du Qu\u00e9bec',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['trentu.ca'],
        web_pages: ['http://www.trentu.ca/'],
        alpha_two_code: 'CA',
        name: 'Trent University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['trinity.utoronto.ca'],
        web_pages: ['http://www.trinity.utoronto.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Trinity College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['tru.ca'],
        web_pages: ['http://www.tru.ca/'],
        alpha_two_code: 'CA',
        name: 'Thompson Rivers University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['twu.ca'],
        web_pages: ['http://www.twu.ca/'],
        alpha_two_code: 'CA',
        name: 'Trinity Western University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ualberta.ca'],
        web_pages: ['http://www.ualberta.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Alberta',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ubc.ca'],
        web_pages: ['http://www.ubc.ca/'],
        alpha_two_code: 'CA',
        name: 'University of British Columbia',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ubishops.ca'],
        web_pages: ['http://www.ubishops.ca/'],
        alpha_two_code: 'CA',
        name: "Bishop's University",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ucalgary.ca'],
        web_pages: ['http://www.ucalgary.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Calgary',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uccb.ns.ca'],
        web_pages: ['http://www.uccb.ns.ca/'],
        alpha_two_code: 'CA',
        name: 'University College of Cape Breton',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ucfv.bc.ca'],
        web_pages: ['http://www.ucfv.bc.ca/'],
        alpha_two_code: 'CA',
        name: 'University College of the Fraser Valley',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ucs.mun.ca'],
        web_pages: ['http://www.ucs.mun.ca/'],
        alpha_two_code: 'CA',
        name: 'Memorial University of Newfoundland',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ukings.ns.ca'],
        web_pages: ['http://www.ukings.ns.ca/'],
        alpha_two_code: 'CA',
        name: "University of King's College",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ulaval.ca'],
        web_pages: ['http://www.ulaval.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 Laval',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uleth.ca'],
        web_pages: ['http://www.uleth.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Lethbridge',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['umanitoba.ca'],
        web_pages: ['http://www.umanitoba.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Manitoba',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['umoncton.ca'],
        web_pages: ['http://www.umoncton.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Moncton',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['umontreal.ca'],
        web_pages: ['http://www.umontreal.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 de Montr\u00e9al',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['unb.ca'],
        web_pages: ['http://www.unb.ca/'],
        alpha_two_code: 'CA',
        name: 'University of New Brunswick',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['unbc.ca'],
        web_pages: ['http://www.unbc.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Northern British Columbia',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['unbsj.ca'],
        web_pages: ['http://www.unbsj.ca/'],
        alpha_two_code: 'CA',
        name: 'University of New Brunswick, Saint John',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['universitycanadawest.ca'],
        web_pages: ['http://www.universitycanadawest.ca/'],
        alpha_two_code: 'CA',
        name: 'University Canada West',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uoguelph.ca'],
        web_pages: ['http://www.uoguelph.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Guelph',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uoit.ca'],
        web_pages: ['http://www.uoit.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Ontario Institute of Technology',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uottawa.ca'],
        web_pages: ['http://www.uottawa.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Ottawa',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['upei.ca'],
        web_pages: ['http://www.upei.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Prince Edward Island',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqac.ca'],
        web_pages: ['http://www.uqac.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec \u00e0 Chicoutimi',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqam.ca'],
        web_pages: ['http://www.uqam.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec \u00e0 Montr\u00e9al',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqar.uquebec.ca'],
        web_pages: ['http://www.uqar.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec \u00e0 Rimouski',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqat.uquebec.ca'],
        web_pages: ['http://www.uqat.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec en Abitibi-T\u00e9miscamingue',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqo.ca'],
        web_pages: ['http://www.uqo.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec en Outaouais',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uqtr.uquebec.ca'],
        web_pages: ['http://www.uqtr.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 du Qu\u00e9bec \u00e0 Trois-Rivi\u00e8res',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uquebec.ca'],
        web_pages: ['http://www.uquebec.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Qu\u00e9bec',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uregina.ca'],
        web_pages: ['http://www.uregina.ca/campion/'],
        alpha_two_code: 'CA',
        name: 'Campion College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uregina.ca'],
        web_pages: ['http://www.uregina.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Regina',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['usask.ca'],
        web_pages: ['http://www.usask.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Saskatchewan',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['usherb.ca'],
        web_pages: ['http://www.usherb.ca/'],
        alpha_two_code: 'CA',
        name: 'Universit\u00e9 de Sherbrooke',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['usjc.uwaterloo.ca'],
        web_pages: ['http://www.usjc.uwaterloo.ca/'],
        alpha_two_code: 'CA',
        name: "University of St. Jerome's College",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ustanne.ednet.ns.ca'],
        web_pages: ['http://www.ustanne.ednet.ns.ca/'],
        alpha_two_code: 'CA',
        name: 'St. Anne University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ustboniface.mb.ca'],
        web_pages: ['http://www.ustboniface.mb.ca/'],
        alpha_two_code: 'CA',
        name: 'University College of Saint-Boniface',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ustpaul.ca'],
        web_pages: ['http://www.ustpaul.ca/'],
        alpha_two_code: 'CA',
        name: 'St. Paul University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['usudbury.com'],
        web_pages: ['http://www.usudbury.com/'],
        alpha_two_code: 'CA',
        name: 'University of Sudbury',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['utm.utoronto.ca'],
        web_pages: ['http://www.utm.utoronto.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Toronto, Mississauga',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['utoronto.ca'],
        web_pages: ['http://www.utoronto.ca/stmikes/'],
        alpha_two_code: 'CA',
        name: "University of St. Michael's College",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['utoronto.ca'],
        web_pages: ['http://www.utoronto.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Toronto',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uvic.ca'],
        web_pages: ['http://www.uvic.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Victoria',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwaterloo.ca'],
        web_pages: ['http://www.uwaterloo.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Waterloo',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwindsor.ca'],
        web_pages: ['http://www.uwindsor.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Windsor',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwinnipeg.ca'],
        web_pages: ['http://www.uwinnipeg.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Winnipeg',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwo.ca'],
        web_pages: ['http://brescia.uwo.ca/'],
        alpha_two_code: 'CA',
        name: 'Brescia University College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwo.ca'],
        web_pages: ['http://www.uwo.ca/kings/'],
        alpha_two_code: 'CA',
        name: "King's College",
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['uwo.ca'],
        web_pages: ['http://www.uwo.ca/'],
        alpha_two_code: 'CA',
        name: 'University of Western Ontario',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['vcc.ca'],
        web_pages: ['http://www.vcc.ca/'],
        alpha_two_code: 'CA',
        name: 'Vancouver Community College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['vicu.utoronto.ca'],
        web_pages: ['http://vicu.utoronto.ca/'],
        alpha_two_code: 'CA',
        name: 'Victoria University Toronto, University of Toronto',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['wlu.ca', 'mylaurier.ca'],
        web_pages: ['http://www.wlu.ca/'],
        alpha_two_code: 'CA',
        name: 'Wilfrid Laurier University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['yorku.ca'],
        web_pages: ['http://www.yorku.ca/'],
        alpha_two_code: 'CA',
        name: 'York University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['yukoncollege.yk.ca'],
        web_pages: ['http://www.yukoncollege.yk.ca/'],
        alpha_two_code: 'CA',
        name: 'Yukon College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['mohawkcollege.ca'],
        web_pages: ['https://www.mohawkcollege.ca/'],
        alpha_two_code: 'CA',
        name: 'Mohawk College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['bdeb.qc.ca'],
        web_pages: ['https://www.bdeb.qc.ca/'],
        alpha_two_code: 'CA',
        name: 'College of Bois-de-Boulogne',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['fanshawec.ca', 'fanshaweonline.ca'],
        web_pages: ['https://www.fanshawec.ca/'],
        alpha_two_code: 'CA',
        name: 'Fanshawe College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['vaniercollege.qc.ca'],
        web_pages: ['https://www.vaniercollege.qc.ca/'],
        alpha_two_code: 'CA',
        name: 'Vanier College',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['ontariotechu.ca', 'ontariotechu.net'],
        web_pages: ['https://ontariotechu.ca/'],
        alpha_two_code: 'CA',
        name: 'Ontario Tech University',
        'state-province': null,
    },
    {
        country: 'Canada',
        domains: ['cstj.qc.ca'],
        web_pages: ['https://www.cstj.qc.ca', 'https://ccmt.cstj.qc.ca', 'https://ccml.cstj.qc.ca'],
        alpha_two_code: 'CA',
        name: 'C\u00e9gep de Saint-J\u00e9r\u00f4me',
        'state-province': null,
    },
].sort((a, b) => a.name - b.name);

export default INSTITUTIONS;
